"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[753],{

/***/ 8367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ withSeoHeadTags; }
});

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/hoc/withSeoHeadTags.tsx




function withSeoHeadTags(component, headTags, partner, longImageUrl) {
  var _headTags$metaTags, _headTags$metaTags2, _headTags$metaTags2$f, _headTags$metaTags3, _headTags$metaTags3$f, _headTags$metaTags4, _headTags$metaTags4$f, _headTags$metaTags5, _headTags$metaTags5$f, _headTags$schema;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      "data-test-id": "Head",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        "data-test-id": "title",
        children: (headTags === null || headTags === void 0 ? void 0 : headTags.title) || "Travel Insurance - MakeMyTrip"
      }), headTags === null || headTags === void 0 ? void 0 : (_headTags$metaTags = headTags.metaTags) === null || _headTags$metaTags === void 0 ? void 0 : _headTags$metaTags.map(function (metaTag, index) {
        if (metaTag.name && metaTag.content) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
            name: metaTag.name,
            content: metaTag.content,
            "data-test-id": `meta-${index}`
          }, index);
        }
      }), (headTags === null || headTags === void 0 ? void 0 : headTags.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: headTags === null || headTags === void 0 ? void 0 : headTags.title,
        "data-test-id": "meta"
      }), (headTags === null || headTags === void 0 ? void 0 : (_headTags$metaTags2 = headTags.metaTags) === null || _headTags$metaTags2 === void 0 ? void 0 : (_headTags$metaTags2$f = _headTags$metaTags2.find(function (meta) {
        return meta.name === "description";
      })) === null || _headTags$metaTags2$f === void 0 ? void 0 : _headTags$metaTags2$f.content) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: headTags === null || headTags === void 0 ? void 0 : (_headTags$metaTags3 = headTags.metaTags) === null || _headTags$metaTags3 === void 0 ? void 0 : (_headTags$metaTags3$f = _headTags$metaTags3.find(function (meta) {
          return meta.name === "description";
        })) === null || _headTags$metaTags3$f === void 0 ? void 0 : _headTags$metaTags3$f.content,
        "data-test-id": "meta"
      }), longImageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: longImageUrl,
        "data-test-id": "meta"
      }), (headTags === null || headTags === void 0 ? void 0 : headTags.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: headTags === null || headTags === void 0 ? void 0 : headTags.title,
        "data-test-id": "meta"
      }), (headTags === null || headTags === void 0 ? void 0 : (_headTags$metaTags4 = headTags.metaTags) === null || _headTags$metaTags4 === void 0 ? void 0 : (_headTags$metaTags4$f = _headTags$metaTags4.find(function (meta) {
        return meta.name === "description";
      })) === null || _headTags$metaTags4$f === void 0 ? void 0 : _headTags$metaTags4$f.content) && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: headTags === null || headTags === void 0 ? void 0 : (_headTags$metaTags5 = headTags.metaTags) === null || _headTags$metaTags5 === void 0 ? void 0 : (_headTags$metaTags5$f = _headTags$metaTags5.find(function (meta) {
          return meta.name === "description";
        })) === null || _headTags$metaTags5$f === void 0 ? void 0 : _headTags$metaTags5$f.content,
        "data-test-id": "meta"
      }), longImageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:image",
        content: longImageUrl,
        "data-test-id": "meta"
      }), headTags === null || headTags === void 0 ? void 0 : (_headTags$schema = headTags.schema) === null || _headTags$schema === void 0 ? void 0 : _headTags$schema.map(function (schema, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "application/ld+json",
          dangerouslySetInnerHTML: {
            __html: JSON.stringify(schema)
          },
          "data-test-id": "script"
        }, "schema-".concat(index));
      }), headTags !== null && headTags !== void 0 && headTags.canonical ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: headTags.canonical,
        "data-test-id": "link"
      }) : null]
    }), component]
  });
}
;// CONCATENATED MODULE: ./src/hoc/index.ts


/***/ }),

/***/ 627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Me": function() { return /* binding */ TravelNote; },
/* harmony export */   "Nj": function() { return /* binding */ PopularCountry; },
/* harmony export */   "P5": function() { return /* binding */ BgText; },
/* harmony export */   "QQ": function() { return /* binding */ PopularCountryItem; },
/* harmony export */   "Q_": function() { return /* binding */ CountryImg; },
/* harmony export */   "S_": function() { return /* binding */ DiscountingNote; },
/* harmony export */   "TR": function() { return /* binding */ TripUpcoming; },
/* harmony export */   "Vr": function() { return /* binding */ UpcomingTripStyle; },
/* harmony export */   "cM": function() { return /* binding */ UpcomingTripTag; },
/* harmony export */   "fK": function() { return /* binding */ TravellingToStyleWrap; },
/* harmony export */   "in": function() { return /* binding */ OtherCountyBtn; },
/* harmony export */   "s0": function() { return /* binding */ TravellingToStyle; },
/* harmony export */   "xZ": function() { return /* binding */ CountryNameTxt; }
/* harmony export */ });
/* unused harmony exports TravelDetailsStyle, ButtonWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5148);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2874);




var TravelDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-1eenbn7-0"
})(["background:#ffffff;padding:30px;"]);
var TravellingToStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-1eenbn7-1"
})(["background:#ffffff;padding:30px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;", "{padding:5px;margin:-5px;}@media ", "{padding:16px;margin-bottom:36px;}"], _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .TagsStyle */ .EN, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var PopularCountry = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-1eenbn7-2"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);min-height:178px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var PopularCountryItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-1eenbn7-3"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], function (p) {
  return p.listSelected && "\n        border: 1px solid #008cff;\n        ";
}, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var OtherCountyBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-1eenbn7-4"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:8px;cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var CountryImg = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-1eenbn7-5"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var TravelNote = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-1eenbn7-6"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.desktop, function (p) {
  return p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "\n        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);\n    " : p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.GI ? "background: #18A160;" : "";
});
var DiscountingNote = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-1eenbn7-7"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:#e4fbf4;}@media ", "{background:#e4fbf4;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText5 */ .rS.greyText5, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.desktop);
var TravellingToStyleWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-1eenbn7-8"
})([""]);
var UpcomingTripStyle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-1eenbn7-9"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n  ";
}, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .AnchorTagStyle */ .C2, _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.purpleGradient */ .rS.purpleGradient);
var UpcomingTripTag = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-1eenbn7-10"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.purpleGradient */ .rS.purpleGradient);
var BgText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-1eenbn7-11"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
var TripUpcoming = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-1eenbn7-12"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
var CountryNameTxt = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-1eenbn7-13"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ButtonWrapper",
  componentId: "sc-1eenbn7-14"
})(["position:fixed;bottom:0;background:#fff;padding:16px;left:0;right:0;width:100%;z-index:1;"]);

/***/ }),

/***/ 2915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TravelDetails_TravellingToShimmer; }
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(5148);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(9011);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(8224);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidgetShimmer.tsx






var TravellingToWidgetShimmer = function TravellingToWidgetShimmer(_ref) {
  (0,objectDestructuringEmpty/* default */.Z)(_ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    "data-test-id": "TravellingToWidgetShimmer-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetShimmerStyle */.fF, {
      "data-test-id": "TravellingToWidgetShimmer-TravelDateWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetShimmerStyle */.Mf, {
      "data-test-id": "TravellingToWidgetShimmer-TravellerCountWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellingToWidgetShimmer = (TravellingToWidgetShimmer);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(627);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx







var TravellingToShimmer = function TravellingToShimmer() {
  var device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingToShimmer-TravellingToStyleWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      "data-test-id": "TravellingToShimmer-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        height: "22px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingToShimmer-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        "data-test-id": "TravellingToShimmer-FlexComp",
        children: Array.from({
          length: 5
        }, function (_, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
            width: "89px",
            height: "79px",
            "data-test-id": `TravellingToShimmer-ShimmerVersion2-${index}`
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "30px -30px 30px",
        xs: true,
        "data-test-id": "TravellingToShimmer-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidgetShimmer, {
        "data-test-id": "TravellingToShimmer-TravellingToWidgetShimmer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        width: "100%",
        height: "44px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingToShimmer = (TravellingToShimmer);

/***/ }),

/***/ 8224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ TravellerCountWigetStyle; },
/* harmony export */   "Jp": function() { return /* binding */ TravelDateWigetStyle; },
/* harmony export */   "Mf": function() { return /* binding */ TravellerCountWigetShimmerStyle; },
/* harmony export */   "N": function() { return /* binding */ ChevStateWrap; },
/* harmony export */   "ZN": function() { return /* binding */ CounterBtn; },
/* harmony export */   "ZP": function() { return /* binding */ DateSeparator; },
/* harmony export */   "bF": function() { return /* binding */ TravellingToWidgetStyle; },
/* harmony export */   "fF": function() { return /* binding */ TravelDateWigetShimmerStyle; },
/* harmony export */   "vg": function() { return /* binding */ CounterWrap; }
/* harmony export */ });
/* unused harmony exports TravelPurposeWigetStyle, WidgetList, ListItem, EmptySpace, ChevWrap, BtnWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5148);



var TravellingToWidgetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-1vav6o1-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .CommonModalDwebStyle */ .E5, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .ToastStyle */ .jf);
var TravelPurposeWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-1vav6o1-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
var TravellerCountWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-1vav6o1-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var TravellerCountWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-1vav6o1-3"
})(["display:flex;gap:20px;align-items:end;"]);
var TravelDateWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-1vav6o1-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var TravelDateWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-1vav6o1-5"
})(["display:flex;gap:20px;align-items:end;"]);
/* istanbul ignore next */

var WidgetList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-1vav6o1-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], function (p) {
  return p.width ? p.width : "111px";
}, function (p) {
  return p.travelCount && "\nleft:250px;\n";
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-1vav6o1-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], function (p) {
  return p.selected && "\n    ".concat(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs, "{\n        color:#008CFF;\n        font-weight:700;\n    }\n    ");
}, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
var EmptySpace = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-1vav6o1-8"
})(["width:100%;height:60px;padding:18px;"]);
var ChevWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-1vav6o1-9"
})(["margin-left:auto;"]);
var DateSeparator = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_1__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-1vav6o1-10"
})(["flex-shrink:0;"]);
var ChevStateWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-1vav6o1-11"
})(["transition:0.5s ease-in;", ""], function (p) {
  return p.open && "\ntransform:rotate(180deg);\n";
});
var BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-1vav6o1-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
var CounterWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-1vav6o1-13"
})(["border-radius:4px;background:#fff;box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);padding:0px 8px;display:flex;gap:14px;align-items:center;width:fit-content;height:40px;button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"]);
var CounterBtn = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-1vav6o1-14"
})(["", ""], function (p) {
  return p.isDiabled && "\npointer-events:none;\nopacity:0.5;\n";
});

/***/ }),

/***/ 8990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumb": function() { return /* reexport */ Breadcrumb_Breadcrumb; },
  "ClaimYourInsurance": function() { return /* reexport */ ClaimYourInsurance_ClaimYourInsurance; },
  "DomesticTrip": function() { return /* reexport */ DomesticTravelDetail_DomesticTrip; },
  "ExclusiveOffers": function() { return /* reexport */ ExculsiveOffers_ExclusiveOffers; },
  "InsuranceStats": function() { return /* reexport */ InsuranceStats_InsuranceStats; },
  "InterlinkingBlock": function() { return /* reexport */ InterlinkingBlock_InterlinkingBlock; },
  "LandingFaq": function() { return /* reexport */ LandingFaq_LandingFaq; },
  "LandingFooter": function() { return /* reexport */ LandingFooter_LandingFooter; },
  "LandingTestimonials": function() { return /* reexport */ LandingTestimonials_LandingTestimonials; },
  "PersuasionBannerInsurance": function() { return /* reexport */ PersuasionBanner_PersuasionBannerInsurance; },
  "SafenSecureTrav": function() { return /* reexport */ SafenSecureTrav_SafenSecureTrav; },
  "SecureTravOffer": function() { return /* reexport */ SecureTravOffer_SecureTravOffer; },
  "SelectCountryCodeModal": function() { return /* reexport */ SelectCountryModal_SelectCountryCodeModal; },
  "SelectCountryModal": function() { return /* reexport */ SelectCountryModal_SelectCountryModal; },
  "SelectCountryModalSheet": function() { return /* reexport */ SelectCountryModal_SelectCountryModalSheet; },
  "SeoContent": function() { return /* reexport */ SeoContent_SeoContent; },
  "TravellingTo": function() { return /* reexport */ TravelDetails_TravellingTo; },
  "TravellingToShimmer": function() { return /* reexport */ TravellingToShimmer/* default */.Z; },
  "TravellingToWidget": function() { return /* reexport */ TravellingToWidget_TravellingToWidget; },
  "WhatsCovered": function() { return /* reexport */ WhatsCovered_WhatsCovered; },
  "WhyBuyTravIns": function() { return /* reexport */ WhyBuyTravIns_WhyBuyTravIns; }
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.style.ts


var BreadcrumbNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbNav",
  componentId: "hea2ec-0"
})(["width:100%;"]);
var BreadcrumbContainer = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbContainer",
  componentId: "hea2ec-1"
})(["display:flex;align-items:center;list-style:none;padding:0 20px;background:transparent;@media ", "{padding:0 20px;}"], src.deviceType.mobile);
var BreadcrumbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbItem",
  componentId: "hea2ec-2"
})(["color:#000;font-size:14px;font-weight:400;", " @media ", "{font-size:12px;}"], function (props) {
  return props.isActive && "\n    font-weight: 500;\n  ";
}, src.deviceType.mobile);
var BreadcrumbLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbLink",
  componentId: "hea2ec-3"
})(["color:#000;text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}&:visited{color:#000;}"]);
var BreadcrumbSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbSeparator",
  componentId: "hea2ec-4"
})(["color:#000;margin:0 8px;font-size:14px;user-select:none;@media ", "{margin:0 6px;font-size:12px;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.tsx






var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      propHostname = _ref.hostname;
  var router = (0,next_router.useRouter)(); // Get current path and hostname

  var currentPath = router.asPath; // Remove query parameters to get clean pathname

  var pathname = currentPath.split("?")[0];
  var hostname = propHostname || ( true ? window.location.hostname : 0);

  var generateBreadcrumbs = function generateBreadcrumbs() {
    var breadcrumbs = []; // Always add Home as first breadcrumb

    breadcrumbs.push({
      label: "Home",
      href: "https://".concat(hostname, "/"),
      isActive: false
    }); // Check if we're on travel insurance page

    if (pathname.includes("/travel-insurance")) {
      // Check if there's a country in the path
      var countryMatch = pathname.match(/\/travel-insurance\/([^/?]+)/);
      var isOnCountryPage = countryMatch && countryMatch[1];
      var isOnTravelInsurancePage = pathname === "/travel-insurance" || pathname === "/travel-insurance/";
      breadcrumbs.push({
        label: "Travel Insurance",
        href: isOnTravelInsurancePage ? null : "https://".concat(hostname, "/travel-insurance/"),
        // No link if already on travel insurance page
        isActive: isOnTravelInsurancePage // Active only if on main travel insurance page

      }); // Add country breadcrumb if on country page

      if (isOnCountryPage) {
        var countrySlug = countryMatch[1]; // Convert slug to readable country name (capitalize first letter)

        var countryName = countrySlug.charAt(0).toUpperCase() + countrySlug.slice(1);
        breadcrumbs.push({
          label: countryName,
          href: null,
          // No link for current page
          isActive: true
        });
      }
    }

    return breadcrumbs;
  };

  var breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null; // Don't show breadcrumb if only home exists
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbNav, {
    "aria-label": "Breadcrumb",
    className: className,
    "data-test-id": "Breadcrumb-BreadcrumbNav",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContainer, {
      "data-test-id": "Breadcrumb-BreadcrumbContainer",
      children: breadcrumbs.map(function (breadcrumb, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbItem, {
            isActive: breadcrumb.isActive,
            "aria-current": breadcrumb.isActive ? "page" : undefined,
            "data-test-id": "Breadcrumb-BreadcrumbItem",
            children: breadcrumb.href ? /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbLink, {
              href: breadcrumb.href,
              onClick: function onClick(e) {
                e.preventDefault();

                if (breadcrumb.href) {
                  window.location.href = breadcrumb.href;
                }
              },
              "data-test-id": "Breadcrumb-BreadcrumbLink",
              children: breadcrumb.label
            }) : breadcrumb.label
          }), index < breadcrumbs.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbSeparator, {
            "aria-hidden": "true",
            "data-test-id": "Breadcrumb-BreadcrumbSeparator",
            children: ">"
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ var Breadcrumb_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/index.tsx

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(5148);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(8619);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(2874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.style.ts




var ClaimYourInsuranceStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "sc-1iy9j2p-0"
})(["background:#f6f6f6;width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], src.deviceType.mobile, ui_widgets_src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
var ClaimStructureStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "sc-1iy9j2p-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:226px;position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimStructure.tsx









var ClaimStructure = function ClaimStructure(_ref) {
  var claimIndex = _ref.claimIndex,
      claimInfo = _ref.claimInfo,
      showSpiral = _ref.showSpiral;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimStructureStyle, {
    "data-test-id": "ClaimStructure-ClaimStructureStyle",
    children: [context === src.PARTNER.MMT ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H2Tag",
      children: claimIndex
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H3Tag",
      children: claimIndex
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
      "data-test-id": "ClaimStructure-SpanTag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RichText */.Ho, {
        value: claimInfo,
        "data-test-id": "ClaimStructure-RichText"
      })]
    }), !showSpiral && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg",
      "data-test-id": "ClaimStructure-ImageComponent"
    })]
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimStructure = (ClaimStructure);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.tsx










var ClaimYourInsurance = function ClaimYourInsurance(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsuranceStyle, {
    "data-test-id": "ClaimYourInsurance-ClaimYourInsuranceStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "ClaimYourInsurance-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          color: Global/* theme.greenText */.rS.greenText,
          margin: "0 0 86px",
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          color: Global/* theme.greenText5 */.rS.greenText5,
          margin: "0 0 20px",
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "100px" : "48px",
        padding: "0 0 20px 0",
        "data-test-id": "ClaimYourInsurance-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance_ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1,
              "data-test-id": `ClaimYourInsurance-ClaimStructure-${index}`
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimYourInsurance = (ClaimYourInsurance);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(1908);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

var DomesticTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "uoelnx-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
var ContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "uoelnx-1"
})(["display:flex;", ";", ";"], function (props) {
  return props.flexDirection && "flex-direction: ".concat(props.flexDirection);
}, function (props) {
  return props.gap && "gap: ".concat(props.gap);
});
var TagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "uoelnx-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], function (props) {
  var _props$startColor, _props$endColor;

  return "background: linear-gradient(45deg, ".concat((_props$startColor = props === null || props === void 0 ? void 0 : props.startColor) !== null && _props$startColor !== void 0 ? _props$startColor : "#00d2ff", " 14.64%, ").concat((_props$endColor = props === null || props === void 0 ? void 0 : props.endColor) !== null && _props$endColor !== void 0 ? _props$endColor : "#3a7bd5", " 85.36%)");
});
var ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "uoelnx-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "uoelnx-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTrip.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var analytics = (0,insurance/* getAnalytics */.I)();

var DomesticTrip = function DomesticTrip(_ref) {
  var _tripData$tag, _tripData$tag2, _tripData$tag3, _tripData$banner;

  var trips = _ref.trips,
      title = _ref.title;
  (0,react.useEffect)(function () {
    analytics === null || analytics === void 0 ? void 0 : analytics.trackLandingEvents({
      actionType: "upcoming_domestic_trips_shown"
    }, "pageView");
  }, []);
  var tripData = trips === null || trips === void 0 ? void 0 : trips[0];

  var handleDomesticClick = function handleDomesticClick() {
    var _trips$;

    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());

    var params = _objectSpread(_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips === null || trips === void 0 ? void 0 : (_trips$ = trips[0]) === null || _trips$ === void 0 ? void 0 : _trips$.bookingId
    });

    analytics === null || analytics === void 0 ? void 0 : analytics.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    } //"click"
    );
    navigation/* navigationActionsSeo.navigateToTravellerDetails */.Ro.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    "data-test-id": "DomesticTrip-ContainerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
      value: title,
      baseStyle: {
        color: Global/* theme.blackText */.rS.blackText
      },
      "data-test-id": "DomesticTrip-FormattedText"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DomesticTripStyle, {
      "data-test-id": "DomesticTrip-DomesticTripStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
        "data-test-id": "DomesticTrip-ContainerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagStyle, {
          startColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag = tripData.tag) === null || _tripData$tag === void 0 ? void 0 : _tripData$tag.startColor,
          endColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag2 = tripData.tag) === null || _tripData$tag2 === void 0 ? void 0 : _tripData$tag2.endColor,
          "data-test-id": "DomesticTrip-TagStyle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag3 = tripData.tag) === null || _tripData$tag3 === void 0 ? void 0 : _tripData$tag3.title,
            "data-test-id": "DomesticTrip-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        "data-test-id": "DomesticTrip-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          "data-test-id": "DomesticTrip-SpanTag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData === null || tripData === void 0 ? void 0 : tripData.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            },
            "data-test-id": "DomesticTrip-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            "data-test-id": "DomesticTrip-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData === null || tripData === void 0 ? void 0 : tripData.image,
              "data-test-id": "DomesticTrip-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: tripData === null || tripData === void 0 ? void 0 : tripData.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                },
                "data-test-id": "DomesticTrip-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
                "data-test-id": "DomesticTrip-ContainerStyle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: tripData === null || tripData === void 0 ? void 0 : tripData.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  },
                  "data-test-id": "DomesticTrip-FormattedText"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
          "data-test-id": "DomesticTrip-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
            "data-test-id": "DomesticTrip-ImageComponent"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        "data-test-id": "DomesticTrip-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: tripData === null || tripData === void 0 ? void 0 : (_tripData$banner = tripData.banner) === null || _tripData$banner === void 0 ? void 0 : _tripData$banner.description,
          "data-test-id": "DomesticTrip-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var DomesticTravelDetail_DomesticTrip = (DomesticTrip);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(354);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.style.ts




var ExclusiveOffersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__ExclusiveOffersStyle",
  componentId: "sc-11fj0jf-0"
})(["width:100%;background:", ";position:relative;z-index:1;overflow:hidden;display:flex;", "{width:64%;}@media ", "{padding:0 16px;}"], Global/* theme.whiteText */.rS.whiteText, components/* H2TagStyle */.FI, src.deviceType.mobile);
var OfferItemStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ExclusiveOffersstyle__OfferItemStyle",
  componentId: "sc-11fj0jf-1"
})(["display:inline-block;background-color:", ";border-radius:8px;width:450px;height:220px;flex-shrink:0;overflow:hidden;@media ", "{width:286px;height:180px;border-radius:16px;", "}"], Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile, function (p) {
  return p.singleItem && "\n      width: calc(100vw - 32px);\n      height: calc((100vw - 32px) / 1.5888888888888888);\n    ";
});
var OffersWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__OffersWrap",
  componentId: "sc-11fj0jf-2"
})(["display:flex;align-items:center;gap:20px;overflow-x:auto;margin-left:-16px;padding-left:16px;margin-right:-16px;padding-right:16px;"]);
var SliderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderWrap",
  componentId: "sc-11fj0jf-3"
})(["display:flex;padding-left:7px;padding-top:7px;"]);
var SlidesBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SlidesBtnWrap",
  componentId: "sc-11fj0jf-4"
})(["box-shadow:0px 1px 7px 0px #00000033;background-color:", ";border-radius:100px;padding:4px 14px;width:72px;height:28px;display:flex;align-items:center;justify-content:space-between;"], Global/* theme.whiteText */.rS.whiteText);
var SliderArrowLeft = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowLeft",
  componentId: "sc-11fj0jf-5"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(135deg);-webkit-transform:rotate(135deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, function (p) {
  return p.disable && "opacity: 0.5;";
});
var SliderArrowRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowRight",
  componentId: "sc-11fj0jf-6"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, function (p) {
  return p.disable && "opacity: 0.5;";
});
var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderContainer",
  componentId: "sc-11fj0jf-7"
})(["overflow:hidden;width:100%;position:relative;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/OfferItem.tsx




var aspectRatio = (/* unused pure expression or super */ null && (286 / 180));

var OfferItem = function OfferItem(_ref) {
  var cta = _ref.cta,
      image_url = _ref.image_url,
      handleClickOfferItem = _ref.handleClickOfferItem,
      offerItemLength = _ref.offerItemLength;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItemStyle, {
    onClick: handleClickOfferItem,
    href: cta.url,
    rel: "noreferrer",
    target: "_blank",
    singleItem: offerItemLength == 1 && device == "sm",
    "data-test-id": "OfferItem-OfferItemStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
      src: image_url,
      width: "100%",
      height: "100%",
      "data-test-id": "OfferItem-ImageTag"
    })
  });
};

/* harmony default export */ var ExculsiveOffers_OfferItem = (OfferItem);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.tsx









var ExclusiveOffers_analytics = (0,insurance/* getAnalytics */.I)();

var ExclusiveOffers = function ExclusiveOffers(_ref) {
  var data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(0),
      currentSlide = _useState[0],
      setCurrentSlide = _useState[1];

  var handleNext = function handleNext() {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  var handlePrev = function handlePrev() {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  (0,react.useEffect)(function () {
    data.items.forEach(function (item, index) {
      var element = document.getElementById("slide".concat(index));
      var observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          ExclusiveOffers_analytics === null || ExclusiveOffers_analytics === void 0 ? void 0 : ExclusiveOffers_analytics.trackLandingEvents({
            actionType: "offer_banner".concat(index + 1, "_shown")
          } // "click"
          );
          (0,XDMAnalytics.trackComponentView)({
            name: "offer_banner_".concat(index + 1, "_shown"),
            type: "offers"
          });
        }
      }
    });
  }, [data.items]);

  var _handleClickOfferItem = function handleClickOfferItem(index) {
    ExclusiveOffers_analytics === null || ExclusiveOffers_analytics === void 0 ? void 0 : ExclusiveOffers_analytics.trackLandingEvents({
      actionType: "offer_banner".concat(index + 1, "_clicked")
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "offer_banner_".concat(index + 1, "_clicked")
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExclusiveOffersStyle, {
    "data-test-id": "ExclusiveOffers-ExclusiveOffersStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "ExclusiveOffers-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        "data-test-id": "ExclusiveOffers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ExclusiveOffers-H2Tag",
          children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: data.title,
            "data-test-id": "ExclusiveOffers-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlidesBtnWrap, {
          "data-test-id": "ExclusiveOffers-SlidesBtnWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowLeft, {
            disable: currentSlide == 0,
            onClick: handlePrev,
            "data-test-id": "ExclusiveOffers-SliderArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowRight, {
            disable: currentSlide == data.items.length - 1,
            onClick: handleNext,
            "data-test-id": "ExclusiveOffers-SliderArrowRight"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "ExclusiveOffers-H5Tag",
        children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: data.title,
          "data-test-id": "ExclusiveOffers-FormattedText"
        })
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersWrap, {
        "data-test-id": "ExclusiveOffers-OffersWrap",
        children: data.items && data.items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: "slide".concat(index),
            "data-test-id": `ExclusiveOffers-${index}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
              handleClickOfferItem: function handleClickOfferItem() {
                return _handleClickOfferItem(index);
              },
              cta: item.cta,
              image_url: item.image_url,
              offerItemLength: data.items.length,
              "data-test-id": "ExclusiveOffers-OfferItem"
            })
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderContainer, {
        "data-test-id": "ExclusiveOffers-SliderContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrap, {
          style: {
            transform: "translateX(-".concat(currentSlide * 42, "%)"),
            transition: "transform 0.5s ease-in-out"
          },
          "data-test-id": "ExclusiveOffers-SliderWrap",
          children: data.items && data.items.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "slide".concat(index),
              style: {
                marginRight: 20
              },
              "data-test-id": `ExclusiveOffers-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
                handleClickOfferItem: function handleClickOfferItem() {
                  return _handleClickOfferItem(index);
                },
                cta: item.cta,
                image_url: item.image_url,
                "data-test-id": "ExclusiveOffers-OfferItem"
              })
            }, index);
          })
        })
      })]
    })
  });
};

/* harmony default export */ var ExculsiveOffers_ExclusiveOffers = (ExclusiveOffers);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.style.ts


var InsuranceStatsWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "sc-1qor9fz-0"
})(["width:100%;@media ", "{padding:0 16px;}"], src.deviceType.mobile);
var InsuranceStatsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "sc-1qor9fz-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    border-radius: 20px;\n    background: #FFF;\n    ";
}, src.deviceType.mobile, function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #fff;\n    box-shadow:none;\n    ";
});
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.tsx







var InsuranceStats = function InsuranceStats(_ref) {
  var data = _ref.data;
  var context = (0,hooks/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsWrap, {
    id: "insurance-stats",
    "data-test-id": "InsuranceStats-InsuranceStatsWrap",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsStyle, {
      pageTheme: context ? context : undefined,
      "data-test-id": "InsuranceStats-InsuranceStatsStyle",
      children: data && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": `InsuranceStats-${index}`,
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H4Tag",
            children: item.title
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H5Tag",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceStats-ParaTag",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ var InsuranceStats_InsuranceStats = (InsuranceStats);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.style.ts



var InterlinkingBlockStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockStyle",
  componentId: "sc-18rfz75-0"
})(["background:", ";color:", ";padding:20px 0;width:100%;"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText);
var InterlinkingBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockWrap",
  componentId: "sc-18rfz75-1"
})(["margin:0 auto;max-width:1200px;padding:0 20px;@media screen and ", "{padding:0 16px;}"], src.deviceType.mobile);
var SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__SectionContainer",
  componentId: "sc-18rfz75-2"
})(["display:flex;flex-direction:column;gap:40px;& > *:last-child{gap:0;}@media screen and ", "{gap:30px;& > *:last-child{gap:0;}}"], src.deviceType.mobile);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__Section",
  componentId: "sc-18rfz75-3"
})(["display:flex;flex-direction:column;"]);
var SectionTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "InterlinkingBlockstyle__SectionTitle",
  componentId: "sc-18rfz75-4"
})(["color:", ";font-size:14px;font-weight:700;margin-bottom:8px;line-height:1.4;text-transform:uppercase;letter-spacing:0.5px;@media screen and ", "{font-size:13px;margin-bottom:6px;}"], Global/* theme.blackText */.rS.blackText, src.deviceType.mobile);
var LinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__LinksContainer",
  componentId: "sc-18rfz75-5"
})(["line-height:1.6;text-align:justify;"]);
var LinkItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InterlinkingBlockstyle__LinkItem",
  componentId: "sc-18rfz75-6"
})(["&:not(:last-child):after{content:\", \";color:", ";}"], Global/* theme.blackText */.rS.blackText);
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "InterlinkingBlockstyle__Link",
  componentId: "sc-18rfz75-7"
})(["color:", ";text-decoration:none;font-size:13px;font-weight:400;line-height:1.6;transition:color 0.2s ease;&:hover{color:", ";text-decoration:underline;}@media screen and ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText || "#007bff", src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.tsx





var InterlinkingBlock = function InterlinkingBlock(_ref) {
  var _ref$interlinkingBloc = _ref.interlinkingBlock,
      interlinkingBlock = _ref$interlinkingBloc === void 0 ? [] : _ref$interlinkingBloc;

  if (!interlinkingBlock || interlinkingBlock.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockStyle, {
    "data-test-id": "InterlinkingBlock-InterlinkingBlockStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockWrap, {
      "data-test-id": "InterlinkingBlock-InterlinkingBlockWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionContainer, {
        "data-test-id": "InterlinkingBlock-SectionContainer",
        children: interlinkingBlock === null || interlinkingBlock === void 0 ? void 0 : interlinkingBlock.map(function (section, sectionIndex) {
          var _section$links;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
            className: "".concat(sectionIndex),
            "data-test-id": "InterlinkingBlock-Section",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
              "data-test-id": "InterlinkingBlock-SectionTitle",
              children: section === null || section === void 0 ? void 0 : section.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
              "data-test-id": "InterlinkingBlock-LinksContainer",
              children: section === null || section === void 0 ? void 0 : (_section$links = section.links) === null || _section$links === void 0 ? void 0 : _section$links.map(function (link, linkIndex) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkItem, {
                  "data-test-id": "InterlinkingBlock-LinkItem",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                    href: link === null || link === void 0 ? void 0 : link.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-test-id": "InterlinkingBlock-Link",
                    children: link.title
                  })
                }, "link-".concat(sectionIndex, "-").concat(linkIndex));
              })
            })]
          }, "section-".concat(sectionIndex));
        })
      })
    })
  });
};

/* harmony default export */ var InterlinkingBlock_InterlinkingBlock = (InterlinkingBlock);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/index.tsx

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 194 modules
var static_components = __webpack_require__(997);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(4576);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.style.ts



var LandingFaqStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "sc-1sfu3od-0"
})(["", " display:flex;background:#fff;flex-direction:column;width:100%;", ""], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.customFaq && "";
});
var LandingFaqTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1sfu3od-1"
})(["font-family:\"Lato\";font-weight:400;font-size:36px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
}, function (props) {
  return props.marginBottom ? props.marginBottom : "56px";
}, Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.marginLeft ? props.marginLeft : "0px";
});
var LandingFaqList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1sfu3od-2"
})(["width:1000px;gap:16px;li{margin-bottom:16px;position:relative;cursor:pointer;}li h3{padding:24px;@media screen and ", "{padding:16px;}}li p{padding:0 24px 24px;}li .faq-content{max-height:0;overflow:hidden;opacity:0;padding:0 24px;}li.open .faq-content{max-height:10000px;opacity:1;padding:0 24px 24px;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.customFaq && "\n            width:100%;\n            gap:8px;\n            margin-bottom: 24px;\n            li {\n                padding: 12px 16px;\n                background: #FFFFFF;\n                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);\n                border-radius: 6px;\n            }\n            li h3 {\n                padding: unset;\n            }\n            li p {\n                padding:unset;\n                font-size: 12px;\n                line-height: 16px;\n                color: #000000;\n            }\n            li:after {\n                border: solid #008CFF;\n                border-width: 0 2px 2px 0;\n                padding: 4px;\n                right: 24px;\n                top: 13px;\n            }\n    ";
}, utils/* deviceType.mobile */.vO.mobile);
var LandingFaqQues = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1sfu3od-3"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], function (props) {
  return props.customFaq && "\n        font-size: 12px;\n        line-height: 16px;\n        color: #000000;";
}, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.tsx








var LandingFaq = function LandingFaq(_ref) {
  var customTitle = _ref.customTitle,
      customFaq = _ref.customFaq,
      faq = _ref.faq,
      margin = _ref.margin;

  var _useState = (0,react.useState)(-1),
      exp = _useState[0],
      setExp = _useState[1];

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var handleClick = function handleClick(index) {
    exp != index ? setExp(index) : setExp(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqStyle, {
    margin: margin,
    customFaq: customFaq,
    "data-test-id": "LandingFaq-LandingFaqStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingFaq-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H2Tag, {
        margin: "0 0 24px 0",
        "data-test-id": "LandingFaq-H2Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H5Tag, {
        margin: "0 0 24px 16px",
        "data-test-id": "LandingFaq-H5Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqList, {
        customFaq: customFaq,
        "data-test-id": "LandingFaq-LandingFaqList",
        children: faq.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "".concat(exp == index ? "open" : "close"),
            onClick: function onClick() {
              return handleClick(index);
            },
            "data-test-id": `LandingFaq-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqQues, {
              customFaq: customFaq,
              "data-test-id": "LandingFaq-LandingFaqQues",
              children: item.ques && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.ques,
                "data-test-id": "LandingFaq-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "faq-content",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.info,
                baseStyle: {
                  whiteSpace: "pre-line"
                },
                "data-test-id": "LandingFaq-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var LandingFaq_LandingFaq = (LandingFaq);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.style.ts



var LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "sc-14d61ct-0"
})(["background:", ";color:", ";padding-top:32px;padding-bottom:64px;width:100%;@media screen and ", "{padding-bottom:22px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile);
var ChevronContainerIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "sc-14d61ct-1"
})(["transform:", ";"], function (props) {
  return props.isInvert ? "rotate(180deg)" : "rotate(0deg)";
});
var LandingFooter_style_LinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "sc-14d61ct-2"
})(["margin-bottom:", ";& > li:not(:last-child){margin-bottom:24px;}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], function (p) {
  return p.isCopyrightText ? "100px" : "0";
}, src.deviceType.mobile, Global/* theme.greyText */.rS.greyText);
var FooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "sc-14d61ct-3"
})(["width:964px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
var InnerLinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "sc-14d61ct-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;& > li{position:relative;color:white;font-size:12px;line-height:16px;}& > li::after{content:\"\u2022\";margin-left:4px;margin-right:4px;}& > li:last-child:after{content:\"\";}"]);
var LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "sc-14d61ct-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(1046);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.tsx








var LandingFooter = function LandingFooter(_ref) {
  var _footerHeading$value, _footerCopyrightData$, _footerCopyrightData$2;

  var footerData = _ref.footerData,
      _ref$followUsText = _ref.followUsText,
      followUsText = _ref$followUsText === void 0 ? "FOLLOW US" : _ref$followUsText,
      _ref$downloadText = _ref.downloadText,
      downloadText = _ref$downloadText === void 0 ? "DOWNLOAD" : _ref$downloadText,
      _ref$countryText = _ref.countryText,
      countryText = _ref$countryText === void 0 ? "Country" : _ref$countryText,
      _ref$locationText = _ref.locationText,
      locationText = _ref$locationText === void 0 ? "INDIA" : _ref$locationText,
      _ref$mmtText = _ref.mmtText,
      mmtText = _ref$mmtText === void 0 ? "MAKEMYTRIP PVT. LTD." : _ref$mmtText,
      playStoreImgURI = _ref.playStoreImgURI,
      appStoreImgURI = _ref.appStoreImgURI,
      linkedInImgURI = _ref.linkedInImgURI,
      facebookImgURI = _ref.facebookImgURI,
      twitterImgURI = _ref.twitterImgURI,
      downIcon = _ref.downIcon,
      footerHeartIcon = _ref.footerHeartIcon,
      footerHeading = _ref.footerHeading,
      footerCopyrightData = _ref.footerCopyrightData;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(-1),
      activeIdx = _useState[0],
      setActiveIdx = _useState[1];

  var footerTextOne = "";
  var headerAlt = "";
  var headerImg = "";
  var footerTextTwo = "";
  var regex = /^(.*?)!\[(.*?)\]\((.*?)\)(.*?)$/;
  var match = footerHeading === null || footerHeading === void 0 ? void 0 : (_footerHeading$value = footerHeading.value) === null || _footerHeading$value === void 0 ? void 0 : _footerHeading$value.match(regex);

  if (match) {
    footerTextOne = match[1].trim();
    headerAlt = match[2].trim();
    headerImg = match[3].trim();
    footerTextTwo = match[4].trim();
  }

  var copyrightText = footerCopyrightData === null || footerCopyrightData === void 0 ? void 0 : (_footerCopyrightData$ = footerCopyrightData.items) === null || _footerCopyrightData$ === void 0 ? void 0 : (_footerCopyrightData$2 = _footerCopyrightData$.find(function (item) {
    return item.type === "copyright";
  })) === null || _footerCopyrightData$2 === void 0 ? void 0 : _footerCopyrightData$2.value;

  var optionsHandler = function optionsHandler(index) {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterWrap, {
      "data-test-id": "LandingFooter-LandingFooterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSection, {
        "data-test-id": "LandingFooter-FooterSection",
        children: [footerHeading && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          "data-test-id": "LandingFooter-FlexComp",
          children: [footerTextOne && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextOne
          }), headerImg ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "85px",
            height: "27px",
            src: headerImg,
            alt: headerAlt,
            "data-test-id": "LandingFooter-ImageComponent"
          }) : null, footerTextTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooter_style_LinksContainer, {
          isCopyrightText: !!copyrightText,
          "data-test-id": "LandingFooter-LinksContainer",
          children: footerData === null || footerData === void 0 ? void 0 : footerData.map(function (item, idx) {
            return (item === null || item === void 0 ? void 0 : item.label) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              onClick: device === "sm" ? function () {
                return optionsHandler(idx);
              } : undefined,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                "data-test-id": "LandingFooter-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                  gap: "10px",
                  "data-test-id": "LandingFooter-FlexComp",
                  children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "18px",
                    height: "18px",
                    src: item.icon,
                    "data-test-id": "LandingFooter-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    color: "white",
                    fontWeight: "black",
                    "data-test-id": "LandingFooter-ParaTag",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  "data-test-id": "LandingFooter-ChevronContainerIcon",
                  children: downIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
                    src: downIcon,
                    "data-test-id": "LandingFooter-ImageTag"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {
                    "data-test-id": "LandingFooter-ChevronUpIcon"
                  })
                })]
              }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              }) : activeIdx === idx && /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              })]
            }, item.id);
          })
        })]
      }), copyrightText && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : undefined,
        justifyContent: "space-between",
        "data-test-id": "LandingFooter-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            textAlign: device === "lg" ? "right" : "center"
          },
          dangerouslySetInnerHTML: {
            __html: copyrightText.replace(/\n/g, "<br />")
          }
        })
      })]
    })
  });
};

/* harmony default export */ var LandingFooter_LandingFooter = (LandingFooter);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.style.ts



var LandingTestimonialsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1e4zunl-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], src.deviceType.mobile);
var LandingTestTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1e4zunl-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], src.deviceType.mobile);
var TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1e4zunl-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
var LandingTest = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1e4zunl-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], src.deviceType.mobile);
var LandingTestWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1e4zunl-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], components/* ParaTagStyle */.OG, src.deviceType.mobile, components/* ParaTagStyle */.OG);
var LandingTestImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1e4zunl-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], src.deviceType.mobile);
var LandingTextCrd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1e4zunl-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], function (p) {
  return p.cardType == "travelLoan" && "\n    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);\n    ";
}, function (p) {
  return p.cardType == "forexCard" && "\n    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);\n    ";
}, src.deviceType.mobile);
var PersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1e4zunl-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], src.deviceType.mobile);
var LandingTestimonials_style_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1e4zunl-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], src.deviceType.mobile);
var LandingTestCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1e4zunl-9"
})(["z-index:1;@media ", "{white-space:initial;}"], src.deviceType.mobile);
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1e4zunl-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
var SlideShowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1e4zunl-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], src.deviceType.mobile);
var SlideShowSLider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1e4zunl-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
var SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1e4zunl-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], src.deviceType.mobile);
var SlideShowDotItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1e4zunl-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], function (p) {
  return p.active && "\n        width: 32px;\n        height: 12px;\n        background: #000000 !important;\n        opacity: 1;\n        border-radius: 6px;\n        ";
});
var StarRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1e4zunl-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], function (p) {
  return p.starRateFull && "\n    position: absolute;\n    top: 0;\n    ";
}, src.deviceType.mobile);
var StarRatingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1e4zunl-16"
})(["margin-bottom:12px;position:relative;"]);
var TestimonialTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1e4zunl-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.tsx









var LandingTestimonials = function LandingTestimonials(_ref) {
  var customTitle = _ref.customTitle,
      test = _ref.test;

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = (0,react.useState)(test === null || test === void 0 ? void 0 : test.length),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      touchPosition = _useState3[0],
      setTouchPosition = _useState3[1];

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState4 = (0,react.useState)(false),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  (0,react.useEffect)(function () {
    setLength(test === null || test === void 0 ? void 0 : test.length);
  }, [test]);

  var next = function next() {
    if (currentIndex < length - 1) {
      setCurrentIndex(function (prevState) {
        return prevState + 1;
      });
    }
  };

  var prev = function prev() {
    if (currentIndex > 0) {
      setCurrentIndex(function (prevState) {
        return prevState - 1;
      });
    }
  };

  var handleTouchStart = function handleTouchStart(e) {
    var touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  var handleTouchMove = function handleTouchMove(e) {
    var touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    var currentTouch = e.touches[0].clientX;
    var diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  var timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(function () {
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
    return function () {
      resetTimeout();
      timeoutRef.current = window.setTimeout(function () {
        return setCurrentIndex(function (prevIndex) {
          return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
        });
      }, 2500);
    };
  }, [currentIndex]);

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
    resetTimeout();
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonialsStyle, {
    "data-test-id": "LandingTestimonials-LandingTestimonialsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingTestimonials-InnerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestTitle, {
        "data-test-id": "LandingTestimonials-LandingTestTitle",
        children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingTestimonials-FormattedText"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg",
          "data-test-id": "LandingTestimonials-ImageComponent"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-test-id": "LandingTestimonials-SlideShowContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
          style: {
            transform: "translateX(-".concat(currentIndex * (device === "lg" ? 50 : 100), "%)")
          },
          "data-test-id": "LandingTestimonials-SlideShowSLider",
          children: test && test.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
              "data-test-id": `LandingTestimonials-LandingTest-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
                "data-test-id": "LandingTestimonials-LandingTestWrap",
                children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                  "data-test-id": "LandingTestimonials-LandingTestImg",
                  children: [item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src,
                    "data-test-id": "LandingTestimonials-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    "data-test-id": "LandingTestimonials-LandingTextCrd",
                    children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.personCard,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                  "data-test-id": "LandingTestimonials-LandingTestCntnt",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialContent, {
                    "data-test-id": "LandingTestimonials-TestimonialContent",
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                        "data-test-id": "LandingTestimonials-PersonName",
                        children: item.personName && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personName,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                        "data-test-id": "LandingTestimonials-StarRatingWrap",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: 5
                          }, function (_, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarEmpty */.rj, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26,
                              "data-test-id": `LandingTestimonials-StarEmpty-${index}`
                            }, index);
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          starRateFull: true,
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: Number(item.personRating)
                          }, function (_, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarFull */.Um, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26,
                              "data-test-id": `LandingTestimonials-StarFull-${index}`
                            }, index);
                          })
                        })]
                      }), device !== "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                        "data-test-id": "LandingTestimonials-LandingTextCrd",
                        children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personCard,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    fontSize: "md",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "LandingTestimonials-ParaTag",
                    children: item.testInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.testInfo,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
          "data-test-id": "LandingTestimonials-SlideDots",
          children: test === null || test === void 0 ? void 0 : test.map(function (_, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowDotItem, {
              active: currentIndex === idx,
              onClick: function onClick() {
                setCurrentIndex(idx);
              },
              "data-test-id": `LandingTestimonials-SlideShowDotItem-${idx}`
            }, idx);
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingTestimonials_LandingTestimonials = (LandingTestimonials);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBanner.style.tsx




var PersuasionBannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "szyc0w-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return "url(".concat(props.bgImage, ")");
}, Global/* theme.greenText */.rS.greenText, components/* H3TagStyle */.KO, Global/* theme.darkYellowText */.rS.darkYellowText, src.deviceType.mobile, components/* BulletListItemStyle */.Il, src.deviceType.mobile, components/* LandingButtonStyle */.zm);
var BulletListStyle = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "szyc0w-1"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBannerInsurance.tsx






var PersuasionBannerInsurance = function PersuasionBannerInsurance(_ref) {
  var crossSell = _ref.crossSell,
      btnHandler = _ref.btnHandler;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  if (!crossSell) {
    return null;
  }

  var title = crossSell.title,
      background = crossSell.background,
      description = crossSell.description,
      cta = crossSell.cta,
      info = crossSell.info;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionBannerStyle, {
    bgImage: background === null || background === void 0 ? void 0 : background.url,
    "data-test-id": "PersuasionBannerInsurance-PersuasionBannerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      "data-test-id": "PersuasionBannerInsurance-H3Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "PersuasionBannerInsurance-FormattedText"
      })
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
      gap: "6px",
      "data-test-id": "PersuasionBannerInsurance-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        "data-test-id": "PersuasionBannerInsurance-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "PersuasionBannerInsurance-FormattedText"
        })
      })
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MarkdownText */.rU, {
      value: description,
      "data-test-id": "PersuasionBannerInsurance-MarkdownText"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
      customTitle: cta === null || cta === void 0 ? void 0 : cta.title,
      onClick: btnHandler,
      padding: "0px 40px",
      "data-test-id": "PersuasionBannerInsurance-LandingButton"
    })]
  });
};

/* harmony default export */ var PersuasionBanner_PersuasionBannerInsurance = (PersuasionBannerInsurance);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.style.ts



var SafenSecureTravStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "sc-1t32hx4-0"
})(["width:100%;background:#fff;position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], components/* H2TagStyle */.FI, src.deviceType.mobile);
var SafenSecureTravCrdStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "sc-1t32hx4-1"
})(["background:linear-gradient( 128.03deg,rgba(227,247,245,0.36) 2.1%,rgba(230,237,255,0.441706) 49.06%,rgba(214,232,244,0.6) 80.75% ),#fcffff;border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], src.deviceType.mobile);
var FeatList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "sc-1t32hx4-2"
})(["display:flex;flex-direction:", ";gap:", ";max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;flex-direction:column;gap:16px;}"], function (p) {
  return p.cardQuantity === 1 ? "row" : "column";
}, function (p) {
  return p.cardQuantity === 1 ? "50px" : "16px";
}, src.deviceType.mobile);
var SafenSecureBgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "sc-1t32hx4-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTravCrd.tsx






var SafenSecureTravCrd = function SafenSecureTravCrd(_ref) {
  var title = _ref.title,
      featList = _ref.featList,
      cardImg = _ref.cardImg,
      poweredBy = _ref.poweredBy,
      cardQuantity = _ref.cardQuantity;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravCrdStyle, {
    "data-test-id": "SafenSecureTravCrd-SafenSecureTravCrdStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3SmallTag */.vb, {
      "data-test-id": "SafenSecureTravCrd-H3SmallTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      "data-test-id": "SafenSecureTravCrd-ParaTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatList, {
      cardQuantity: cardQuantity,
      "data-test-id": "SafenSecureTravCrd-FeatList",
      children: featList && (featList === null || featList === void 0 ? void 0 : featList.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          "data-test-id": `SafenSecureTravCrd-${index}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: item,
            "data-test-id": "SafenSecureTravCrd-FormattedText"
          })
        }, index);
      }))
    }), poweredBy && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      "data-test-id": "SafenSecureTravCrd-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        "data-test-id": "SafenSecureTravCrd-SpanTag",
        children: "Powered By"
      }), poweredBy && poweredBy.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          src: item,
          height: "32px",
          width: "auto",
          "data-test-id": `SafenSecureTravCrd-ImageComponent-${index}`
        }, index);
      })]
    }), cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "92px" : "54px",
      height: device == "lg" ? "102px" : "60px",
      src: cardImg,
      "data-test-id": "SafenSecureTravCrd-ImageComponent"
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTravCrd = (SafenSecureTravCrd);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.tsx


function SafenSecureTrav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SafenSecureTrav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SafenSecureTrav_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SafenSecureTrav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SafenSecureTrav = function SafenSecureTrav(_ref) {
  var title = _ref.title,
      data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravStyle, {
    "data-test-id": "SafenSecureTrav-SafenSecureTravStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureBgWrap, {
      "data-test-id": "SafenSecureTrav-SafenSecureBgWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg",
        "data-test-id": "SafenSecureTrav-ImageComponent"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "SafenSecureTrav-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        margin: "0 0 60px",
        "data-test-id": "SafenSecureTrav-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "SafenSecureTrav-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        "data-test-id": "SafenSecureTrav-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureTrav_SafenSecureTravCrd, SafenSecureTrav_objectSpread(SafenSecureTrav_objectSpread({
            cardQuantity: data === null || data === void 0 ? void 0 : data.length
          }, item), {}, {
            "data-test-id": `SafenSecureTrav-SafenSecureTravCrd-${index}`
          }), index);
        })
      })]
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTrav = (SafenSecureTrav);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.style.ts



var SecureTravOfferStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "sc-19r9m5r-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], components/* H5TagStyle */.Wl);
var SecureTravItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "sc-19r9m5r-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], src.deviceType.mobile);
var SecureTravImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "sc-19r9m5r-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], function (p) {
  return p.pageTheme === src.PARTNER.MMT ? "\n     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);\n    " : p.pageTheme === src.PARTNER.GI ? "background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);" : "\n    ";
});
var SecureTravContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "sc-19r9m5r-3"
})(["align-self:center;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.tsx








var SecureTravOffer = function SecureTravOffer(_ref) {
  var data = _ref.data;
  var context = (0,hooks/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravOfferStyle, {
    "data-test-id": "SecureTravOffer-SecureTravOfferStyle",
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravItem, {
        "data-test-id": `SecureTravOffer-SecureTravItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravImgWrap, {
          pageTheme: context ? context : undefined,
          "data-test-id": "SecureTravOffer-SecureTravImgWrap",
          children: item.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager",
            "data-test-id": "SecureTravOffer-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravContent, {
          "data-test-id": "SecureTravOffer-SecureTravContent",
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-H5Tag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "md",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.info,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ var SecureTravOffer_SecureTravOffer = (SecureTravOffer);
// EXTERNAL MODULE: ../../node_modules/react-virtualized/dist/es/index.js + 93 modules
var es = __webpack_require__(845);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.style.ts




var SelectCountryModalStyle = (0,styled_components_browser_esm/* default */.ZP)(components/* CommonModalDwebStyle */.E5).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "sc-1n427kc-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
var CountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "sc-1n427kc-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], function (props) {
  return props.margin && "".concat(props.margin);
}, function (props) {
  return props.disableCursor ? "default" : "pointer";
}, components/* LandingButtonStyle */.zm, components/* CheckButtonStyle */.mT, Global/* theme.yellowText3 */.rS.yellowText3, components/* ToolTipCompWrapper */.V6);
var BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "sc-1n427kc-2"
})(["position:", ";", ";", ";width:100%;"], function (props) {
  return props.position ? "".concat(props.position) : "sticky";
}, function (props) {
  return props.bottom && "bottom:".concat(props.bottom);
}, function (props) {
  return props.background && "background:".concat(props.background);
});
var CountrySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "sc-1n427kc-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
var CountrySectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "sc-1n427kc-4"
})(["@media ", "{padding:16px;}"], src.deviceType.mobile);
var PopularRegionCountries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "sc-1n427kc-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
var SelectCountrySheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "sc-1n427kc-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], components/* TMInputWrap */.dd);
var SelectCountryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "sc-1n427kc-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryCodeModal.tsx









var SelectCountryCodeModal = function SelectCountryCodeModal(_ref) {
  var countryData = _ref.countryData,
      handleSelectCountry = _ref.handleSelectCountry,
      handleClose = _ref.handleClose;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var windowWidth = window.innerWidth - 60;

  var _useState = (0,react.useState)(countryData),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setInputValue = _useState2[1];

  var rowHeight = 60;

  var calculateListHeight = function calculateListHeight() {
    var _countriesData$length;

    var rowCount = (_countriesData$length = countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) !== null && _countriesData$length !== void 0 ? _countriesData$length : 0; // Replace with your actual data length

    var height = rowCount * rowHeight;
    return height;
  };

  var countryHandler = function countryHandler(id) {
    if (id) {
      setCountriesData(countryData === null || countryData === void 0 ? void 0 : countryData.map(function (item) {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  (0,react.useEffect)(function () {
    if (searchTxt !== null && searchTxt !== void 0 && searchTxt.length) {
      var filteredDataList = searchTxt ? countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (items) {
        var _items$countryName;

        return (_items$countryName = items.countryName) === null || _items$countryName === void 0 ? void 0 : _items$countryName.toLowerCase().includes(searchTxt.toLowerCase());
      }) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-test-id": `SelectCountryCodeModal-rowRenderer-${key}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        onClick: function onClick() {
          return countryHandler(item.id);
        },
        "data-test-id": "SelectCountryCodeModal-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RadioButton */.EU, {
          handleChange: function handleChange() {
            return countryHandler(item.id);
          },
          activeBtn: item.isSelected,
          "data-test-id": "SelectCountryCodeModal-rowRenderer-RadioButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
              alignItems: "center",
              gap: "8px",
              "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
              children: [item.countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                src: item.countryFlag,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                fontSize: "sm",
                color: Global/* theme.blackText */.rS.blackText,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
                children: item.countryName
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
              fontWeight: "bold",
              fontSize: "xs",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CommonModalDweb */.Eq, {
    handleClick: handleClose,
    customTitle: "Select Country",
    "data-test-id": "SelectCountryCodeModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
      handleChange: function handleChange(e) {
        return setInputValue(e.target.value);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country Name",
      "data-test-id": "SelectCountryCodeModal-TMFloatingInput"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(CountrySection, {
      "data-test-id": "SelectCountryCodeModal-CountrySection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Country Name"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Code"
      })]
    }), countriesData && (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(es/* List */.aV, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer,
      "data-test-id": "SelectCountryCodeModal-List"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      fontSize: "sm",
      color: Global/* theme.greyText */.rS.greyText,
      margin: "16px 0 16px",
      "data-test-id": "SelectCountryCodeModal-ParaTag",
      children: "No Country Found! Please enter correct name"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "SelectCountryCodeModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: function onClick() {
          return handleSelectCountry(countriesData);
        },
        "data-test-id": "SelectCountryCodeModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryCodeModal = (SelectCountryCodeModal);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(2746);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
var fuse = __webpack_require__(9325);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 2 modules
var insurance_utils = __webpack_require__(3621);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.style.tsx



var modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "n7dugx-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, function (p) {
  return p.customHeight ? p.customHeight : "420px";
}, components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, modalAnim, components/* TMInputWrap */.dd);
var CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "n7dugx-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:85%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, function (p) {
  return p.nonClipHeading && "\n     ".concat(components/* H5TagStyle */.Wl, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, src.deviceType.mobile);
var CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "n7dugx-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.tsx







var RegionCountryModal = function RegionCountryModal(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      customSubTitle = _ref.customSubTitle,
      handleClick = _ref.handleClick,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      customHeight = _ref.customHeight,
      nonClipHeading = _ref.nonClipHeading;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
    return function () {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionCountryModal-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      "data-test-id": "RegionCountryModal-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionCountryModal-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "RegionCountryModal-H5Tag",
            children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "40px",
              height: "40px",
              src: customIcon,
              "data-test-id": "RegionCountryModal-ImageComponent"
            }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionCountryModal-FormattedText"
            })]
          }), customSubTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: customSubTitle,
            "data-test-id": "RegionCountryModal-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "RegionCountryModal-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "RegionCountryModal-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionCountryModal-BackDropComp"
    })]
  });
};

/* harmony default export */ var RegionModalDweb_RegionCountryModal = (RegionCountryModal);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(7696);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.style.tsx

var CountryList_style_ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "jzswvv-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var DescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "jzswvv-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
});
var ColumnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "jzswvv-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.tsx










var CountryList = function CountryList(_ref) {
  var countryData = _ref.countryData,
      countryHandler = _ref.countryHandler,
      isCheckedHandler = _ref.isCheckedHandler,
      setCountryData = _ref.setCountryData,
      searchQueryHighlighter = _ref.searchQueryHighlighter,
      setIsSelectedError = _ref.setIsSelectedError,
      showHeader = _ref.showHeader,
      setCountrySelectToastMsg = _ref.setCountrySelectToastMsg;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var windowWidth = window.innerWidth - 60; //TODO: handle default cell height using css var

  var defaultCellHeight = 57; //TODO: Check alternate height calculation using DOM elements

  var windowHeight = window.innerHeight - 213;
  var listRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      showViewAllButton = _useState[0],
      setShowViewAllButton = _useState[1];

  (0,react.useEffect)(function () {
    var _listRef$current;

    var temp = countryData.map(function (data) {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  (0,react.useEffect)(function () {
    var _listRef$current2;

    listRef === null || listRef === void 0 ? void 0 : (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.resetAfterIndex(0);
  }, [countryData]);

  var handleDescription = function handleDescription(code) {
    var data = countryData.filter(function (data) {
      return (data === null || data === void 0 ? void 0 : data.code) === code;
    })[0];

    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    var tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    var descData = tempDescData.join(" ") + "...";
    return descData;
  };

  var handleRegionDescription = function handleRegionDescription(code) {
    var _listRef$current3;

    var temp = countryData.map(function (data) {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }

      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.resetAfterIndex(0);
    setCountryData(temp);
  };

  var handleErrorToast = (0,insurance_utils/* debounce */.Ds)(function () {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  var handleCountrySelectError = function handleCountrySelectError(country) {
    var isExclusiveCountrySelected = countryData.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });

    if (isExclusiveCountrySelected && !(country !== null && country !== void 0 && country.isExclusiveSelection) && country.isDisabled) {
      setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
      handleErrorToast();
    } else if (country !== null && country !== void 0 && country.isExclusiveSelection && !isExclusiveCountrySelected && country.isDisabled) {
      setCountrySelectToastMsg("India cannot be chosen for International Travel");
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDescription && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDescription && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  var handleViewAll = function handleViewAll(code) {
    var _listRef$current4;

    var temp = countryData.map(function (data) {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }

      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 ? void 0 : _listRef$current4.resetAfterIndex(0);
    setCountryData(temp);
  };

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countryData === null || countryData === void 0 ? void 0 : countryData[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return showHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        disableCursor: true,
        margin: device === "lg" ? "0px 17px 0px 0px" : "",
        "data-test-id": "CountryList-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: item.name,
          baseStyle: {
            fontWeight: "bold",
            fontSize: "14px"
          },
          "data-test-id": "CountryList-rowRenderer-FormattedText"
        })
      });
    } else if (item.code) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-test-id": `CountryList-rowRenderer-${key}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CountryItem, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          "data-test-id": "CountryList-rowRenderer-CountryItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            "data-test-id": "CountryList-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* CheckButton */.nt, {
              handleChange: function handleChange() {
                return handleCountrySelectError(item);
              },
              isChecked: item.isDisabled ? true : isCheckedHandler(item),
              isDisabled: item.isDisabled,
              "data-test-id": "CountryList-rowRenderer-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                handleClick: function handleClick() {
                  return handleCountrySelectError(item);
                },
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "CountryList-rowRenderer-FlexComp",
                children: [item.subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnWrapper, {
                  "data-test-id": "CountryList-rowRenderer-ColumnWrapper",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: searchQueryHighlighter(item.name)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.subtitle,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "400"
                      },
                      "data-test-id": "CountryList-rowRenderer-FormattedText"
                    })
                  })]
                }) : searchQueryHighlighter(item.name), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.countryCount,
                  baseStyle: {
                    padding: "0px 10px 0px 0px",
                    fontSize: "12px",
                    color: "#4A4A4A"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.regionName,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#0000004D"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                })]
              })
            }), item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList_style_ArrowButtonWrap, {
              onClick: function onClick() {
                handleRegionDescription(item.code);
              },
              "data-test-id": "CountryList-rowRenderer-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: item.showDescription ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "CountryList-rowRenderer-ImageComponent"
              })
            })]
          }), item.showDescription && item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrap, {
            "data-test-id": "CountryList-rowRenderer-DescriptionWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.descTitle,
              baseStyle: {
                fontWeight: "bold",
                fontSize: "14px"
              },
              "data-test-id": "CountryList-rowRenderer-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: handleDescription(item.code),
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "CountryList-rowRenderer-FormattedText"
              })
            }), showViewAllButton && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
              handleClick: function handleClick() {
                handleViewAll(item.code);
              },
              fontWeight: "bold",
              "data-test-id": "CountryList-rowRenderer-AnchorTag",
              children: "View All"
            })]
          })]
        })
      }, key);
    }

    return;
  };

  var getItemSize = function getItemSize(code, isShowDesc, isShowAllDesc) {
    var expansionValue = 0;

    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }

    return (0,insurance_utils/* interpolateRowHeight */.IS)(device === "lg" ? 360 : windowWidth, code, expansionValue) || defaultCellHeight;
  };

  var getItemSizes = function getItemSizes(index) {
    var height = countryData[index].type === "REGION" ? getItemSize(countryData[index].code, countryData[index].showDescription, countryData[index].showExpandedDescription) : defaultCellHeight;
    return height;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* VariableSizeList */.S_, {
    height: device === "lg" ? 380 : windowHeight,
    itemCount: countryData.length,
    itemSize: getItemSizes,
    width: device === "lg" ? 360 : windowWidth,
    ref: listRef,
    "data-test-id": "CountryList-FixList",
    children: function children(_ref3) {
      var index = _ref3.index,
          style = _ref3.style;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: style,
        "data-test-id": `CountryList-${index}`,
        children: rowRenderer({
          index: index,
          key: index
        })
      }, index);
    }
  });
};

/* harmony default export */ var SelectCountryModal_CountryList = (CountryList);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.tsx



function SelectCountryModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var SelectCountryModal_analytics = (0,insurance/* getAnalytics */.I)();
var DEBOUNCE_TIME = 300;

var fuzzySearch = function fuzzySearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) {
  var selectedCountriesData = displayCountryData.filter(function (country) {
    return country.isSelected && !country.isDisabled;
  });
  var searchResults = searcher.search(searchValue);
  var filteredData = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (match) {
    return match === null || match === void 0 ? void 0 : match.item;
  });
  var originalSortData = countryData.map(function (country) {
    return displayCountryData.find(function (item) {
      return item.code === country.code;
    });
  });
  var allObjects = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesData), (0,toConsumableArray/* default */.Z)(filteredData), (0,toConsumableArray/* default */.Z)(originalSortData));
  var tempObj = allObjects.reduce(function (acc, obj) {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  var uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

var debouncedSearch = (0,insurance_utils/* debounce */.Ds)(fuzzySearch, DEBOUNCE_TIME);

var SelectCountryModal = function SelectCountryModal(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      showCountry = _ref.showCountry,
      setCountryData = _ref.setCountryData,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      customSubTitle = _ref.customSubTitle,
      handleDescriptionModal = _ref.handleDescriptionModal;

  var _useState = (0,react.useState)(countryData),
      displayCountryData = _useState[0],
      setDisplayCountrysData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSelectedError = _useState3[0],
      setIsSelectedError = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      countrySelectToastMsg = _useState4[0],
      setCountrySelectToastMsg = _useState4[1];

  var searchedCountriesOmn = (0,react.useRef)([]);
  var selectedCountriesOmn = (0,react.useRef)([]);
  var searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  var noSearchResults = function noSearchResults(addTimeOut) {
    var allObjects = [];
    var selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    var selectedCountriesData = displayCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    });
    var originalSortData = countryData.map(function (country) {
      return displayCountryData.find(function (item) {
        return item.code === country.code;
      });
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModal_objectSpread({}, selectedHeader)].concat((0,toConsumableArray/* default */.Z)(selectedCountriesData), (0,toConsumableArray/* default */.Z)(originalSortData));
      var tempObj = allObjects.reduce(function (acc, obj) {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      var uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(function () {
    noSearchResults(false);
  }, []);

  var countryClickHandler = function countryClickHandler(code) {
    handleDescriptionModal(displayCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var updatedCountryArr = displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModal_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          var _selectedCountriesOmn2;

          selectedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn2 = selectedCountriesOmn.current) === null || _selectedCountriesOmn2 === void 0 ? void 0 : _selectedCountriesOmn2.slice(1)), [country.code]);
        } else {
          selectedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = updatedCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    updatedCountryArr = updatedCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModal_objectSpread({}, country) : SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModal_objectSpread({}, country);
      }

      return SelectCountryModal_objectSpread({}, country);
    });
    var selectedCountryCodes = updatedCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      updatedCountryArr = updatedCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    var popularCountryData = updatedCountryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat((0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
  };

  var handleSearchtxt = (0,react.useCallback)(function (searchValue) {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  var onSearchChange = function onSearchChange(searchValue) {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModal-searchQueryHighlighter-ParaTag"
    });
  };

  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModal_analytics === null || SelectCountryModal_analytics === void 0 ? void 0 : SelectCountryModal_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = displayCountryData.map(function (country) {
      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModal_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn3;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModal_analytics === null || SelectCountryModal_analytics === void 0 ? void 0 : SelectCountryModal_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn3 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn3 !== void 0 && _selectedCountriesOmn3.length) {
      var _selectedCountriesOmn4;

      SelectCountryModal_analytics === null || SelectCountryModal_analytics === void 0 ? void 0 : SelectCountryModal_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn4 = selectedCountriesOmn.current) === null || _selectedCountriesOmn4 === void 0 ? void 0 : _selectedCountriesOmn4.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = displayCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = displayCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModal_analytics === null || SelectCountryModal_analytics === void 0 ? void 0 : SelectCountryModal_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_RegionCountryModal, {
    customHeight: "600px",
    handleClick: onCountrySubmit,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    "data-test-id": "SelectCountryModal-RegionCountryModal",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
      handleChange: function handleChange(e) {
        return handleSearchTxt(e);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country/Region",
      "data-test-id": "SelectCountryModal-TMFloatingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountrySectionWrap, {
      "data-test-id": "SelectCountryModal-CountrySectionWrap",
      children: displayCountryData !== null && displayCountryData !== void 0 && displayCountryData.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
        countryData: searchTxt.length ? displayCountryData.filter(function (country) {
          return country.type !== "HEADER";
        }) : displayCountryData,
        countryHandler: countryClickHandler,
        isCheckedHandler: isCheckedHandler,
        searchQueryHighlighter: searchQueryHighlighter,
        setCountryData: setDisplayCountrysData,
        setIsSelectedError: setIsSelectedError,
        showHeader: !searchTxt.length,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        "data-test-id": "SelectCountryModal-CountryList"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "30px 0px 0px 0px",
        "data-test-id": "SelectCountryModal-ParaTag",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectToastMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), (displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "SelectCountryModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit,
        "data-test-id": "SelectCountryModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryModal = (SelectCountryModal);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModalSheet.tsx



function SelectCountryModalSheet_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalSheet_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalSheet_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalSheet_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var SelectCountryModalSheet_analytics = (0,insurance/* getAnalytics */.I)();
var SelectCountryModalSheet_DEBOUNCE_TIME = 300;

var SelectCountryModalSheet_fuzzySearch = function fuzzySearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) {
  var selectedCountriesData = displayCountryData.filter(function (country) {
    return country.isSelected && !country.isDisabled;
  });
  var searchResults = searcher.search(searchValue);
  var filteredData = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (match) {
    return match === null || match === void 0 ? void 0 : match.item;
  });
  var originalSortData = countryData.map(function (country) {
    return displayCountryData.find(function (item) {
      return item.code === country.code;
    });
  });
  var allObjects = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesData), (0,toConsumableArray/* default */.Z)(filteredData), (0,toConsumableArray/* default */.Z)(originalSortData));
  var tempObj = allObjects.reduce(function (acc, obj) {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  var uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

var SelectCountryModalSheet_debouncedSearch = (0,insurance_utils/* debounce */.Ds)(SelectCountryModalSheet_fuzzySearch, 300);

var SelectCountryModalSheet = function SelectCountryModalSheet(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      setCountryData = _ref.setCountryData,
      showCountry = _ref.showCountry,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      handleDescriptionModal = _ref.handleDescriptionModal,
      customSubTitle = _ref.customSubTitle;

  var _useState = (0,react.useState)(countryData),
      displayCountryData = _useState[0],
      setDisplayCountrysData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSelectedError = _useState3[0],
      setIsSelectedError = _useState3[1];

  var searchedCountriesOmn = (0,react.useRef)([]);
  var selectedCountriesOmn = (0,react.useRef)([]);

  var _useState4 = (0,react.useState)(""),
      countrySelectToastMsg = _useState4[0],
      setCountrySelectToastMsg = _useState4[1];

  var searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  var noSearchResults = function noSearchResults(addTimeOut) {
    var allObjects = [];
    var selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    var selectedCountriesData = displayCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    });
    var originalSortData = countryData.map(function (country) {
      return displayCountryData.find(function (item) {
        return item.code === country.code;
      });
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModalSheet_objectSpread({}, selectedHeader)].concat((0,toConsumableArray/* default */.Z)(selectedCountriesData), (0,toConsumableArray/* default */.Z)(originalSortData));
      var tempObj = allObjects.reduce(function (acc, obj) {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      var uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(uniqueObjects);
      }, SelectCountryModalSheet_DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(originalSortData);
      }, SelectCountryModalSheet_DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(function () {
    noSearchResults(false);
  }, []);

  var countryClickHandler = function countryClickHandler(code) {
    handleDescriptionModal(displayCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var updatedCountryArr = displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalSheet_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          var _selectedCountriesOmn2;

          selectedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn2 = selectedCountriesOmn.current) === null || _selectedCountriesOmn2 === void 0 ? void 0 : _selectedCountriesOmn2.slice(1)), [country.code]);
        } else {
          selectedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = updatedCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    updatedCountryArr = updatedCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModalSheet_objectSpread({}, country) : SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModalSheet_objectSpread({}, country);
      }

      return SelectCountryModalSheet_objectSpread({}, country);
    });
    var selectedCountryCodes = updatedCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      updatedCountryArr = updatedCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    var popularCountryData = updatedCountryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat((0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
  };

  var handleSearchtxt = (0,react.useCallback)(function (searchValue) {
    SelectCountryModalSheet_debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  var onSearchChange = function onSearchChange(searchValue) {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalSheet-searchQueryHighlighter-ParaTag"
    });
  };

  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModalSheet_analytics === null || SelectCountryModalSheet_analytics === void 0 ? void 0 : SelectCountryModalSheet_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = displayCountryData.map(function (country) {
      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModalSheet_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn3;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModalSheet_analytics === null || SelectCountryModalSheet_analytics === void 0 ? void 0 : SelectCountryModalSheet_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn3 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn3 !== void 0 && _selectedCountriesOmn3.length) {
      var _selectedCountriesOmn4;

      SelectCountryModalSheet_analytics === null || SelectCountryModalSheet_analytics === void 0 ? void 0 : SelectCountryModalSheet_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn4 = selectedCountriesOmn.current) === null || _selectedCountriesOmn4 === void 0 ? void 0 : _selectedCountriesOmn4.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = displayCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = displayCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModalSheet_analytics === null || SelectCountryModalSheet_analytics === void 0 ? void 0 : SelectCountryModalSheet_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat((0,toConsumableArray/* default */.Z)(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ReactPortalComp */.hK, {
    "data-test-id": "SelectCountryModalSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountrySheetStyle, {
      "data-test-id": "SelectCountryModalSheet-SelectCountrySheetStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryHeader, {
        "data-test-id": "SelectCountryModalSheet-SelectCountryHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
          handleClick: handleCrossClick,
          "data-test-id": "SelectCountryModalSheet-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          flexDirection: "column",
          "data-test-id": "SelectCountryModalSheet-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "md",
            fontWeight: "bold",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SelectCountryModalSheet-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: "Select Destinations",
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: "xs",
            color: Global/* theme.greyText6 */.rS.greyText6,
            "data-test-id": "SelectCountryModalSheet-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customSubTitle,
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
        handleChange: function handleChange(e) {
          return handleSearchTxt(e);
        },
        inputValue: searchTxt,
        labelTxt: "Search Country/Region",
        "data-test-id": "SelectCountryModalSheet-TMFloatingInput"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountrySectionWrap, {
        "data-test-id": "SelectCountryModalSheet-CountrySectionWrap",
        children: displayCountryData !== null && displayCountryData !== void 0 && displayCountryData.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
          countryData: searchTxt.length ? displayCountryData.filter(function (country) {
            return country.type !== "HEADER";
          }) : displayCountryData,
          countryHandler: countryClickHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setDisplayCountrysData,
          setIsSelectedError: setIsSelectedError,
          showHeader: !searchTxt.length,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          "data-test-id": "SelectCountryModalSheet-CountryList"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "sm",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "30px 0px 0px 0px",
          "data-test-id": "SelectCountryModalSheet-ParaTag",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px",
        "data-test-id": "SelectCountryModalSheet-WebToast"
      }), (displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        "data-test-id": "SelectCountryModalSheet-BtnWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit,
          "data-test-id": "SelectCountryModalSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryModalSheet = (SelectCountryModalSheet);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.style.ts



var SeoContentStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SeoContentstyle__SeoContentStyle",
  componentId: "sc-1ipkwsi-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}ul{list-style:initial;padding-left:30px;}h1,h2,h3,h4,h5,h6,p,ul{margin:1em 0;}@media ", "{padding:0 16px;", "}"], function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #EFF3F8;\n    padding-bottom:80px;\n    ";
}, components/* H2TagStyle */.FI, src.deviceType.mobile, src.deviceType.mobile, function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #fff;\n    padding-top:16px;\n    ";
});
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.tsx





var SeoContent = function SeoContent(_ref) {
  var seoContent = _ref.seoContent;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContentStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "SeoContent-SeoContentStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_widgets_src/* InnerContentWrap */.IY, {
      dangerouslySetInnerHTML: {
        __html: seoContent
      },
      "data-test-id": "SeoContent-InnerContentWrap"
    })
  });
};

/* harmony default export */ var SeoContent_SeoContent = (SeoContent);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.style.tsx



var RegionModalDweb_style_modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RegionModalDweb_style_CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1g04rko-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, RegionModalDweb_style_modalAnim, components/* TMInputWrap */.dd);
var RegionModalDweb_style_CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "sc-1g04rko-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, function (p) {
  return p.nonClipHeading && "\n     ".concat(components/* H5TagStyle */.Wl, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, src.deviceType.mobile);
var RegionModalDweb_style_CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "sc-1g04rko-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.tsx






var RegionModalDweb = function RegionModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      handleClick = _ref.handleClick,
      customWidth = _ref.customWidth,
      nonClipHeading = _ref.nonClipHeading;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_style_CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "RegionModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionModalDweb-CommonModalHeader",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            "data-test-id": "RegionModalDweb-H5Tag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg",
              "data-test-id": "RegionModalDweb-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CrossIconWrap, {
              onClick: handleClick,
              "data-test-id": "RegionModalDweb-CrossIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
                "data-test-id": "RegionModalDweb-ImageComponent"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "xlarge",
            fontWeight: "black",
            "data-test-id": "RegionModalDweb-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionModalDweb-FormattedText"
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ var RegionModalDweb_RegionModalDweb = (RegionModalDweb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.style.tsx

var PopularDescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-217pnf-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.tsx







var DescriptionModal = function DescriptionModal(_ref) {
  var handleDescriptionModal = _ref.handleDescriptionModal,
      value = _ref.value,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_RegionModalDweb, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    "data-test-id": "DescriptionModal-RegionModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularDescriptionWrap, {
      "data-test-id": "DescriptionModal-PopularDescriptionWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs"
        },
        "data-test-id": "DescriptionModal-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: value,
        "data-test-id": "DescriptionModal-FormattedText"
      })]
    })
  });
};

/* harmony default export */ var DescriptionModal_DescriptionModal = (DescriptionModal);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(627);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/PopularCountryCompV2.tsx









var PopularCountryComp = function PopularCountryComp(_ref) {
  var popCountry = _ref.popCountry,
      handleShowOtherCountry = _ref.handleShowOtherCountry,
      otherCountryTxt = _ref.otherCountryTxt,
      handlePopularCountrySelect = _ref.handlePopularCountrySelect,
      setIsSelectedError = _ref.setIsSelectedError,
      setCountrySelectToastMsg = _ref.setCountrySelectToastMsg;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data === null || data === void 0 ? void 0 : data.isSelected;
  }, [popCountry]);
  var handleErrorToast = (0,insurance_utils/* debounce */.Ds)(function () {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  var handleCountrySelect = function handleCountrySelect(item) {
    if (item.isDisabled) {
      var isExclusiveCountrySelected = popCountry === null || popCountry === void 0 ? void 0 : popCountry.find(function (item) {
        return item.isExclusiveSelection && item.isSelected;
      });

      if (isExclusiveCountrySelected && !(item !== null && item !== void 0 && item.isExclusiveSelection) && item.isDisabled) {
        setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
        handleErrorToast();
      } else if (item !== null && item !== void 0 && item.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
        setCountrySelectToastMsg("India cannot be chosen for International Travel");
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountry */.Nj, {
    "data-test-id": "PopularCountryComp-PopularCountry",
    children: [popCountry && popCountry.slice(0, 5).map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountryItem */.QQ, {
        listSelected: isCheckedHandler(item),
        onClick: function onClick() {
          return handleCountrySelect(item);
        },
        "data-test-id": `PopularCountryComp-PopularCountryItem-${index}`,
        children: [index !== popCountry.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CheckButton */.nt, {
          isDisabled: item.isDisabled,
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          "data-test-id": "PopularCountryComp-CheckButton",
          children: [!item.img && item.name && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* BgText */.P5, {
            "data-test-id": "PopularCountryComp-BgText",
            children: item === null || item === void 0 ? void 0 : item.code
          }), item.upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TripUpcoming */.TR, {
            "data-test-id": "PopularCountryComp-TripUpcoming",
            children: "TRIP UPCOMING"
          }), (item === null || item === void 0 ? void 0 : item.name) && !item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item === null || item === void 0 ? void 0 : item.name
          }), (item === null || item === void 0 ? void 0 : item.name) && item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name + item.subtitle,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: (item === null || item === void 0 ? void 0 : item.name) + " " + item.subtitle
          })]
        }), (item === null || item === void 0 ? void 0 : item.img) && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryImg */.Q_, {
          "data-test-id": "PopularCountryComp-CountryImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager",
            "data-test-id": "PopularCountryComp-ImageComponent"
          })
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* OtherCountyBtn */["in"], {
      onClick: handleShowOtherCountry,
      "data-test-id": "PopularCountryComp-OtherCountyBtn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager",
        "data-test-id": "PopularCountryComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blueText */.rS.blueText,
        "data-test-id": "PopularCountryComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: otherCountryTxt,
          "data-test-id": "PopularCountryComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var PopularCountryCompV2 = (PopularCountryComp);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/UpcomingTrips.tsx










var UpcomingTrips_analytics = (0,insurance/* getAnalytics */.I)();

var UpcomingTrips = function UpcomingTrips(_ref) {
  var country = _ref.country,
      travelDuration = _ref.travelDuration,
      travellerNum = _ref.travellerNum,
      travellerTitle = _ref.travellerTitle,
      handleUpcomingTripClick = _ref.handleUpcomingTripClick;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(false),
      isUpcomingTripSelected = _useState[0],
      setIsUpcomingTripSelected = _useState[1];

  (0,react.useEffect)(function () {
    var queryParams = new URLSearchParams(window.location.search);
    var isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    UpcomingTrips_analytics === null || UpcomingTrips_analytics === void 0 ? void 0 : UpcomingTrips_analytics.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    });
  }, []);

  var showFormattedDate = function showFormattedDate(date) {
    if (date) {
      var dateValue = (0,insurance_utils/* convertUnixToDate */.P9)(date);
      return (0,insurance_utils/* formatDate */.p6)(dateValue, src.DATE_FORMATS["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* UpcomingTripStyle */.Vr, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    "data-test-id": "UpcomingTrips-UpcomingTripStyle",
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* UpcomingTripTag */.cM, {
      "data-test-id": "UpcomingTrips-UpcomingTripTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xxs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "UpcomingTrips-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: country,
          "data-test-id": "UpcomingTrips-FormattedText"
        }), "\xA0"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontSize: "xs",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [" ".concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.startDate), " - ").concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.endDate)), " ", "| ", travellerNum, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travellerTitle,
          "data-test-id": "UpcomingTrips-FormattedText"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
      "data-test-id": "UpcomingTrips-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px",
        "data-test-id": "UpcomingTrips-ImageTag"
      })
    })]
  });
};

/* harmony default export */ var TravelDetails_UpcomingTrips = (UpcomingTrips);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 5 modules
var utility_src = __webpack_require__(5277);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(8521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(6535);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingTo.tsx





function TravellingTo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravellingTo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravellingTo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravellingTo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var TravellingTo_analytics = (0,insurance/* getAnalytics */.I)();

var TravellingTo = function TravellingTo(_ref) {
  var _upcomingTrip$travelD, _upcomingTrip$travelD2, _isExclusiveCountrySe, _travelSearchForm$seg8, _travelSearchForm$seg9, _segmentSelected$moda, _segmentSelected$moda2, _segmentSelected$moda3, _segmentSelected$moda4, _segmentSelected$moda5;

  var travellingToSection = _ref.travellingToSection,
      upcomingTrip = _ref.upcomingTrip,
      calendarDatesLimit = _ref.calendarDatesLimit,
      travelSearchBanner = _ref.travelSearchBanner,
      _ref$btnDisabledState = _ref.btnDisabledState,
      btnDisabledState = _ref$btnDisabledState === void 0 ? true : _ref$btnDisabledState,
      nextPageRoute = _ref.nextPageRoute,
      countryCodes = _ref.countryCodes,
      setLoginModal = _ref.setLoginModal;
  var buttonRef = (0,react.useRef)(null);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,hooks/* usePartnerContext */.X)();

  var _ref2 = travellingToSection || {},
      otherCountryTxt = _ref2.otherCountryTxt,
      travelNote = _ref2.travelNote,
      travDateTitle = _ref2.travDateTitle,
      travCountTitle = _ref2.travCountTitle,
      travPurpTitle = _ref2.travPurpTitle,
      travelPurposeTxt = _ref2.travelPurposeTxt,
      popularCountryTxt = _ref2.popularCountryTxt,
      travelBtnTxt = _ref2.travelBtnTxt,
      travelSearchForm = _ref2.travelSearchForm;

  var _travelSearchForm$reg = travelSearchForm.regionCountryList,
      label = _travelSearchForm$reg.label,
      error_message = _travelSearchForm$reg.error_message,
      countrySelectErrMsg = _travelSearchForm$reg.countrySelectErrMsg,
      placeHolder = _travelSearchForm$reg.placeHolder,
      value = _travelSearchForm$reg.value;

  var _useState = (0,react.useState)([]),
      popularCountries = _useState[0],
      setPopularCountries = _useState[1];

  var _useState2 = (0,react.useState)([]),
      countryData = _useState2[0],
      setCountryData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showOtherCountry = _useState3[0],
      setOtherCountry = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      countValue = _useState4[0],
      setCountValue = _useState4[1];

  var _useState5 = (0,react.useState)(),
      calenderValue = _useState5[0],
      setCalenderValue = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      showCountry = _useState6[0],
      setShowCountry = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isCountryError = _useState7[0],
      setIsCountryError = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      descriptionTxt = _useState8[0],
      setDescriptionTxt = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isSelectedError = _useState9[0],
      setIsSelectedError = _useState9[1];

  var _useState10 = (0,react.useState)(""),
      descTitle = _useState10[0],
      setDescTitle = _useState10[1];

  var _useState11 = (0,react.useState)([]),
      segments = _useState11[0],
      setSegments = _useState11[1];

  var _useState12 = (0,react.useState)({}),
      segmentSelected = _useState12[0],
      setSegmentSelected = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      isSegmentModalShown = _useState13[0],
      setIsSegmentModalShown = _useState13[1];

  var _useState14 = (0,react.useState)(""),
      countrySelectToastMsg = _useState14[0],
      setCountrySelectToastMsg = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      showLoginModal = _useState15[0],
      setShowLoginModal = _useState15[1];

  var _useState16 = (0,react.useState)(),
      nextPageError = _useState16[0],
      setNextPageError = _useState16[1]; //set the default selected segement


  (0,react.useEffect)(function () {
    var _travelSearchForm$seg;

    var queryParams = new URLSearchParams(window.location.search);
    var segParam = queryParams.get("segment");
    var segments = travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg = travelSearchForm.segments) === null || _travelSearchForm$seg === void 0 ? void 0 : _travelSearchForm$seg.value;

    if (segments) {
      var segment = segments.find(function (item) {
        return item.id === segParam || !segParam && item.isSelected;
      });

      if (segment) {
        setSegmentSelected(segment);
        (0,insurance_utils/* replaceHistory */.df)("segment", segment.id);
      }
    }
  }, []); //set the travelSerachForm.segments to segments

  (0,react.useEffect)(function () {
    var _travelSearchForm$seg2;

    var queryParams = new URLSearchParams(window.location.search);
    var segParam = queryParams.get("segment");

    if (travelSearchForm !== null && travelSearchForm !== void 0 && (_travelSearchForm$seg2 = travelSearchForm.segments) !== null && _travelSearchForm$seg2 !== void 0 && _travelSearchForm$seg2.value) {
      if (segParam) {
        handleSegementSelect(segParam);
      } else {
        var _travelSearchForm$seg3;

        setSegments(travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg3 = travelSearchForm.segments) === null || _travelSearchForm$seg3 === void 0 ? void 0 : _travelSearchForm$seg3.value);
      }
    }
  }, [travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    if (travelSearchForm !== null && travelSearchForm !== void 0 && travelSearchForm.segments) {
      TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
        actionType: "special_segments_shown"
      } //"click"
      );
      (0,XDMAnalytics.trackComponentView)({
        name: "special_segments_shown",
        type: "card"
      });
    }
  }, [travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    var _totalCountryData, _totalCountryData2, _totalCountryData3, _totalCountryData3$fi, _totalCountryData$fil, _totalCountryData5, _popularCountryData, _popularCountryData2;

    var queryParams = new URLSearchParams(window.location.search);
    var selectedCountries = queryParams.get("countries") || countryCodes;
    var selectedCountryCodes;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.split(",");
    } else if (upcomingTrip !== null && upcomingTrip !== void 0 && upcomingTrip.countryCode) {
      selectedCountryCodes = upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode;
      (0,insurance_utils/* replaceHistory */.df)("countries", upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode);
    }

    var totalCountryData = value === null || value === void 0 ? void 0 : value.map(function (data) {
      var _selectedCountryCodes;

      if ((_selectedCountryCodes = selectedCountryCodes) !== null && _selectedCountryCodes !== void 0 && _selectedCountryCodes.includes(data.code)) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return TravellingTo_objectSpread({}, data);
    });
    var isExclusiveCountrySelected = (_totalCountryData = totalCountryData) === null || _totalCountryData === void 0 ? void 0 : _totalCountryData.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    totalCountryData = (_totalCountryData2 = totalCountryData) === null || _totalCountryData2 === void 0 ? void 0 : _totalCountryData2.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (totalCountryData.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    var selectedRegionCodes = (_totalCountryData3 = totalCountryData) === null || _totalCountryData3 === void 0 ? void 0 : (_totalCountryData3$fi = _totalCountryData3.filter(function (data) {
      return data.isSelected && data.type === "REGION";
    })) === null || _totalCountryData3$fi === void 0 ? void 0 : _totalCountryData3$fi.map(function (data) {
      return data.code;
    });
    selectedRegionCodes === null || selectedRegionCodes === void 0 ? void 0 : selectedRegionCodes.map(function (code) {
      var _totalCountryData4;

      totalCountryData = (_totalCountryData4 = totalCountryData) === null || _totalCountryData4 === void 0 ? void 0 : _totalCountryData4.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setCountryData(totalCountryData);
    var popularCountryData = (_totalCountryData$fil = (_totalCountryData5 = totalCountryData) === null || _totalCountryData5 === void 0 ? void 0 : _totalCountryData5.filter(function (country) {
      return country.isSelected || country.isPopular;
    })) !== null && _totalCountryData$fil !== void 0 ? _totalCountryData$fil : [];
    popularCountryData = [].concat((0,toConsumableArray/* default */.Z)((_popularCountryData = popularCountryData) === null || _popularCountryData === void 0 ? void 0 : _popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)((_popularCountryData2 = popularCountryData) === null || _popularCountryData2 === void 0 ? void 0 : _popularCountryData2.filter(function (country) {
      return country.isDisabled;
    })), (0,toConsumableArray/* default */.Z)(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    })));
    setShowCountry((0,toConsumableArray/* default */.Z)(popularCountryData));
    setPopularCountries((0,toConsumableArray/* default */.Z)(popularCountryData));
  }, [value, upcomingTrip, travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    var button = buttonRef.current;
    var viewportMargin = 16;
    var searchBarOffset = 60;

    if (button) {
      var rect = button.getBoundingClientRect();
      var offsetTop = window.scrollY + rect.top;
      var isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        var scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  var populateTravelDetails = function populateTravelDetails(countryCodes, startDate, endDate, travellers) {
    if (countryCodes) {
      (0,insurance_utils/* replaceHistory */.df)("countries", countryCodes);
    }

    if (startDate) {
      (0,insurance_utils/* replaceHistory */.df)("startDate", startDate);
    }

    if (endDate) {
      (0,insurance_utils/* replaceHistory */.df)("endDate", endDate);
    }

    if (travellers) {
      (0,insurance_utils/* replaceHistory */.df)("travellers", travellers);
    }
  };

  var handleUpcomingTripClick = function handleUpcomingTripClick() {
    var _travelDuration$start, _travelDuration$endDa;

    (0,insurance_utils/* replaceHistory */.df)("isUpcomingTrip", "true");
    (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked"
      }
    });

    var _ref3 = upcomingTrip || {},
        countryCode = _ref3.countryCode,
        travelDuration = _ref3.travelDuration,
        travellerNum = _ref3.travellerNum;

    var selectedCountry = countryData === null || countryData === void 0 ? void 0 : countryData.find(function (country) {
      return country.code === countryCode;
    });
    populateTravelDetails(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code, travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start = travelDuration.startDate) === null || _travelDuration$start === void 0 ? void 0 : _travelDuration$start.toString(), travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa = travelDuration.endDate) === null || _travelDuration$endDa === void 0 ? void 0 : _travelDuration$endDa.toString(), travellerNum === null || travellerNum === void 0 ? void 0 : travellerNum.toString());

    if (nextPageRoute) {
      navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName("".concat(nextPageRoute, "&isUpcomingTrip=true"));
    } else {
      var _travelDuration$start2, _travelDuration$endDa2, _travellerNum$toStrin;

      var data = {
        startDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start2 = travelDuration.startDate) === null || _travelDuration$start2 === void 0 ? void 0 : _travelDuration$start2.toString(),
        endDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa2 = travelDuration.endDate) === null || _travelDuration$endDa2 === void 0 ? void 0 : _travelDuration$endDa2.toString(),
        travellers: travellerNum === null || travellerNum === void 0 ? void 0 : (_travellerNum$toStrin = travellerNum.toString) === null || _travellerNum$toStrin === void 0 ? void 0 : _travellerNum$toStrin.call(travellerNum),
        countries: [countryCode],
        isUpcomingTrip: true
      };
      navigation/* navigationActionsSeo.navigateToListing */.Ro.navigateToListing(data);
    }
  };

  var handleShowOtherCountry = function handleShowOtherCountry() {
    if (!showOtherCountry) {
      var _countryDataArr2;

      var countryDataArr = countryData === null || countryData === void 0 ? void 0 : countryData.map(function (country) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false
        });
      });
      popularCountries.map(function (data) {
        var _countryDataArr;

        countryDataArr = (_countryDataArr = countryDataArr) === null || _countryDataArr === void 0 ? void 0 : _countryDataArr.map(function (country) {
          if (country.code === data.code) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });

      var _isExclusiveCountrySelected = countryDataArr.find(function (item) {
        return item.isExclusiveSelection && item.isSelected;
      });

      countryDataArr = (_countryDataArr2 = countryDataArr) === null || _countryDataArr2 === void 0 ? void 0 : _countryDataArr2.map(function (country) {
        if (_isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(function (item) {
          return item.isSelected;
        })) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          }) : TravellingTo_objectSpread({}, country);
        }

        return TravellingTo_objectSpread({}, country);
      });
      var selectedRegionCodes = countryDataArr.filter(function (data) {
        return data.isSelected && data.type === "REGION";
      }).map(function (data) {
        return data.code;
      });
      selectedRegionCodes === null || selectedRegionCodes === void 0 ? void 0 : selectedRegionCodes.map(function (code) {
        countryDataArr = countryDataArr.map(function (country) {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  var handleDescriptionModal = function handleDescriptionModal(country) {
    var clickedTime = (0,utility_src/* getSessionStorageItem */.St)("clickedTime") ? (0,utility_src/* getSessionStorageItem */.St)("clickedTime") : {};
    var currentTime = new Date().getTime();
    var code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("clickedTime", TravellingTo_objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  var handlePopularCountrySelect = function handlePopularCountrySelect(code) {
    setIsCountryError(false);
    var popularCountryArr = popularCountries === null || popularCountries === void 0 ? void 0 : popularCountries.map(function (country) {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return TravellingTo_objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = popularCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    popularCountryArr = popularCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      } else if (popularCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    var selectedPopRegionCodes = popularCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedPopRegionCodes.map(function (item) {
      popularCountryArr = popularCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    var selectedCountries = popularCountryArr.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:popular_country_selected"
      }
    }, {
      countries: selectedCountries
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    var countries = popularCountryArr.filter(function (data) {
      return data.isSelected && !data.isDisabled;
    }).map(function (data) {
      return data.code;
    }).join(",");

    if (countries) {
      (0,insurance_utils/* replaceHistory */.df)("countries", countries);
    } else {
      (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    }
  };

  var handleSegementSelect = function handleSegementSelect(segmentId) {
    var _travelSearchForm$seg4;

    if (travelSearchForm !== null && travelSearchForm !== void 0 && (_travelSearchForm$seg4 = travelSearchForm.segments) !== null && _travelSearchForm$seg4 !== void 0 && _travelSearchForm$seg4.value) {
      var _travelSearchForm$seg5;

      var updatedData = travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg5 = travelSearchForm.segments) === null || _travelSearchForm$seg5 === void 0 ? void 0 : _travelSearchForm$seg5.value.map(function (item) {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,insurance_utils/* replaceHistory */.df)("segment", item.id);
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  var handleSegmentClick = function handleSegmentClick(segmentId) {
    var _travelSearchForm$seg6;

    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:segment_clicked"
      }
    }, {
      journeyType: (segmentId === null || segmentId === void 0 ? void 0 : segmentId.toString().toLowerCase()) || ""
    });

    if (travelSearchForm !== null && travelSearchForm !== void 0 && (_travelSearchForm$seg6 = travelSearchForm.segments) !== null && _travelSearchForm$seg6 !== void 0 && _travelSearchForm$seg6.value) {
      var _travelSearchForm$seg7;

      var updatedData = travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg7 = travelSearchForm.segments) === null || _travelSearchForm$seg7 === void 0 ? void 0 : _travelSearchForm$seg7.value.map(function (item) {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,insurance_utils/* replaceHistory */.df)("segment", item.id);
          TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
            actionType: item.config.clickEventName
          } //"click"
          );
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  var toastTimeout = null;

  var toggleSegmentModal = function toggleSegmentModal() {
    var searchParams = new URLSearchParams(window.location.search);
    var countries = searchParams.get("countries");
    var countryCodes = countries === null || countries === void 0 ? void 0 : countries.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id) === "STUDENT") {
      setCountrySelectToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(function () {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.modal) && setIsSegmentModalShown(true);
    }
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _countryCodes;

      var searchParams, countries, isUpcomingTrip, countryCodes, _showCountry$filter, selectedCountriesFromState, selectedPopCountries, queryParams, params, partner, requestData, response, responseStatus, nextPageRouteConfig, _error$response, domain, host, req;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchParams = new URLSearchParams(window.location.search);
              countries = searchParams.get("countries");
              isUpcomingTrip = searchParams.get("isUpcomingTrip");
              countryCodes = countries === null || countries === void 0 ? void 0 : countries.split(","); // If no countries in URL, check the state for selected countries

              if (!countryCodes) {
                selectedCountriesFromState = showCountry === null || showCountry === void 0 ? void 0 : (_showCountry$filter = showCountry.filter(function (country) {
                  return country.isSelected && !country.isDisabled;
                })) === null || _showCountry$filter === void 0 ? void 0 : _showCountry$filter.map(function (country) {
                  return country.code;
                });

                if ((selectedCountriesFromState === null || selectedCountriesFromState === void 0 ? void 0 : selectedCountriesFromState.length) > 0) {
                  countryCodes = selectedCountriesFromState; // Update URL with selected countries from state

                  (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountriesFromState.join(",")); // Clear any existing country error since we found selected countries

                  setIsCountryError(false);
                }
              }

              if (!(!countryCodes || countryCodes.length === 0)) {
                _context.next = 12;
                break;
              }

              setIsCountryError(true);
              TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                actionType: "error_shown",
                payload: error_message
              } //"click"
              );
              (0,xdmEvents/* errorTrackEvent */.t1)({
                error_details_list: [{
                  message: error_message,
                  source: "country_select",
                  severity: 3
                }]
              });
              return _context.abrupt("return");

            case 12:
              // Clear error if we have countries
              setIsCountryError(false);

            case 13:
              if (isUpcomingTrip) {
                (0,insurance_utils/* replaceHistoryRemoveParams */._A)("isUpcomingTrip");
                searchParams.delete("isUpcomingTrip");
                (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
              }

              (0,insurance_utils/* replaceHistory */.df)("segment", segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id);

              if (!(calenderValue && countValue && (_countryCodes = countryCodes) !== null && _countryCodes !== void 0 && _countryCodes.length)) {
                _context.next = 36;
                break;
              }

              selectedPopCountries = (popularCountries !== null && popularCountries !== void 0 ? popularCountries : []).filter(function (country) {
                var _countryCodes2;

                return (_countryCodes2 = countryCodes) === null || _countryCodes2 === void 0 ? void 0 : _countryCodes2.includes(country.code);
              }).map(function (item) {
                return item.name;
              }).join("|");
              TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                actionType: "popular_country_selected",
                payload: selectedPopCountries
              } //"click"
              );
              queryParams = Object.fromEntries(searchParams.entries());
              params = TravellingTo_objectSpread(TravellingTo_objectSpread({}, queryParams), {}, {
                startDate: (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.from).toString(),
                endDate: calenderValue.to ? (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.to).toString() : searchParams.get("endDate"),
                travellers: countValue,
                countries: countryCodes,
                segment: segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id
              });
              TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                actionType: "explore_plan_click"
              } //"click"
              );
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "explore_plan_click"
                }
              });
              partner = (0,insurance_utils/* getPartnerOnClientSide */.et)();
              requestData = {
                query: {
                  source: "seo"
                },
                partner: partner,
                userSearchIntent: {
                  country: countryCodes,
                  departureDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.from),
                  arrivalDateTime: calenderValue.to ? (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.to) : Number(searchParams.get("endDate")),
                  numberOfTravellers: countValue,
                  segment: segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id
                }
              };
              _context.prev = 24;
              _context.next = 27;
              return (0,api/* getNextPageRouteDetails */.$P)(requestData);

            case 27:
              response = _context.sent;
              responseStatus = response.responseStatus, nextPageRouteConfig = response.nextPageRouteConfig;

              if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
                navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName("".concat(nextPageRouteConfig === null || nextPageRouteConfig === void 0 ? void 0 : nextPageRouteConfig.route));
              }

              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](24);
              console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
                error: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response
              });

              if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
                domain = partner === src.PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";

                if ((0,insurance_utils/* getCookieByName */.A7)("next_page_req")) {
                  document.cookie = "next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=".concat(domain, "; path=/");
                }

                document.cookie = "next_page_req= ".concat(JSON.stringify(requestData), "; expires=").concat(new Date(Date.now() + 15 * 60 * 1000).toUTCString(), "; domain=").concat(domain, "; path=/");

                if (device === "sm" && partner === src.PARTNER.MMT) {
                  host = window.location.host;
                  req = {
                    url: window.location.pathname + window.location.search
                  };
                  document.cookie = "loginActionDetails=" + JSON.stringify("https://".concat(host, "/insurance/next-page")) + ";domain=.makemytrip.com;path=/";
                  window.location.href = "https://www.makemytrip.com/pwa/hlp/v3/login";
                }

                setLoginModal === null || setLoginModal === void 0 ? void 0 : setLoginModal("LOGIN");
              } else {
                setNextPageError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response);
              }

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[24, 32]]);
    }));

    return function onSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();

  var isExclusiveCountrySelected = countryData.find(function (item) {
    return item.isExclusiveSelection && item.isSelected;
  });

  if (nextPageError && true) {
    throw new utility_src/* ClientError */.XF(nextPageError);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingTo-TravellingToStyleWrap",
    children: [travelSearchBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* DiscountingNote */.S_, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-DiscountingNote",
      children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        }), (travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: travelNote,
        "data-test-id": "TravellingTo-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingTo-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "TravellingTo-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: label,
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        margin: "0px 0px 20px 0px",
        "data-test-id": "TravellingTo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: placeHolder,
          baseStyle: {
            color: "#717171"
          },
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_UpcomingTrips, {
        country: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.country,
        countryCode: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode,
        travelDuration: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travelDuration,
        travellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        travellerTitle: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerTitle,
        handleUpcomingTripClick: handleUpcomingTripClick,
        "data-test-id": "TravellingTo-UpcomingTrips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText7 */.rS.greyText7,
        fontWeight: "bold",
        fontSize: "xs",
        margin: "2px 0 8px",
        "data-test-id": "TravellingTo-SpanTag",
        children: popularCountryTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: "Popular Destination",
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularCountryCompV2, {
        otherCountryTxt: otherCountryTxt,
        handleShowOtherCountry: handleShowOtherCountry,
        popCountry: showCountry,
        setIsSelectedError: setIsSelectedError,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        handlePopularCountrySelect: handlePopularCountrySelect,
        "data-test-id": "TravellingTo-PopularCountryComp"
      }), isCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.redText2 */.rS.redText2,
        fontSize: "xs",
        margin: device === "sm" ? "0 0 8px" : "8px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: error_message
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "14px -30px 14px",
        backgroundColor: "#FFFFFF",
        xs: true,
        "data-test-id": "TravellingTo-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidget, {
        travelPurposeTxt: travelPurposeTxt,
        travCountTitle: travCountTitle,
        travPurpTitle: travPurpTitle,
        travDateTitle: travDateTitle,
        btnDisabledState: btnDisabledState,
        setCountValue: setCountValue,
        calendarDatesLimit: calendarDatesLimit,
        setCalenderValue: setCalenderValue,
        upcomingTravellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        upcomingFromDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD === void 0 ? void 0 : _upcomingTrip$travelD.startDate,
        upcomingToDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD2 = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD2 === void 0 ? void 0 : _upcomingTrip$travelD2.endDate,
        calendarConfig: (isExclusiveCountrySelected === null || isExclusiveCountrySelected === void 0 ? void 0 : (_isExclusiveCountrySe = isExclusiveCountrySelected.config) === null || _isExclusiveCountrySe === void 0 ? void 0 : _isExclusiveCountrySe.calendar) || (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.config) || calendarDatesLimit,
        "data-test-id": "TravellingTo-TravellingToWidget"
      }), (travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.segments) && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 24px",
        gap: "8px",
        flexDirection: "column",
        "data-test-id": "TravellingTo-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "xs",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "TravellingTo-ParaTag",
          children: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg8 = travelSearchForm.segments) === null || _travelSearchForm$seg8 === void 0 ? void 0 : _travelSearchForm$seg8.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tags */.$G, {
          handleClickTab: handleSegmentClick,
          data: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg9 = travelSearchForm.segments) === null || _travelSearchForm$seg9 === void 0 ? void 0 : _travelSearchForm$seg9.value,
          "data-test-id": "TravellingTo-Tags"
        })]
      }), isSegmentModalShown && segmentSelected && (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.modal) && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CommonModalDweb */.Eq, {
        customIcon: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda = segmentSelected.modal) === null || _segmentSelected$moda === void 0 ? void 0 : _segmentSelected$moda.icon,
        customTitle: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda2 = segmentSelected.modal) === null || _segmentSelected$moda2 === void 0 ? void 0 : _segmentSelected$moda2.title,
        handleClick: function handleClick() {
          setIsSegmentModalShown(false);
        },
        nonClipHeading: true,
        "data-test-id": "TravellingTo-CommonModalDweb",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "md",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "0 0 36px",
          "data-test-id": "TravellingTo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda3 = segmentSelected.modal) === null || _segmentSelected$moda3 === void 0 ? void 0 : _segmentSelected$moda3.description,
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: function handleClick() {
              setIsSegmentModalShown(false);
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda4 = segmentSelected.modal) === null || _segmentSelected$moda4 === void 0 ? void 0 : _segmentSelected$moda4.secondaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: function handleClick() {
              setIsSegmentModalShown(false);
              onSubmit();
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda5 = segmentSelected.modal) === null || _segmentSelected$moda5 === void 0 ? void 0 : _segmentSelected$moda5.primaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          })]
        })]
      }), travelBtnTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        buttonref: buttonRef,
        customWidth: "100%",
        customTitle: travelBtnTxt,
        onClick: segmentSelected !== null && segmentSelected !== void 0 && segmentSelected.modal && travelSearchForm !== null && travelSearchForm !== void 0 && travelSearchForm.segments ? toggleSegmentModal : onSubmit,
        "data-test-id": "TravellingTo-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.greyText */.rS.greyText,
        margin: "16px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.disclaimer
      }), showOtherCountry && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_SelectCountryModal, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModal"
      }), showOtherCountry && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_SelectCountryModalSheet, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalSheet"
      }), descriptionTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionModal_DescriptionModal, {
        handleDescriptionModal: function handleDescriptionModal() {
          return setDescriptionTxt("");
        },
        value: descriptionTxt,
        title: descTitle,
        "data-test-id": "TravellingTo-DescriptionModal"
      }), isSelectedError && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      }), isSelectedError && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px",
        "data-test-id": "TravellingTo-WebToast"
      }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectToastMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingTo = (TravellingTo);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(2915);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(8224);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravelDateWiget.tsx








var TravelDateWiget = function TravelDateWiget(_ref) {
  var showTravDate = _ref.showTravDate,
      handleTravDate = _ref.handleTravDate,
      ref = _ref.ref,
      travDateTitle = _ref.travDateTitle,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetStyle */.Jp, {
    ref: ref,
    onClick: handleTravDate,
    "data-test-id": "TravelDateWiget-TravelDateWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "8px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [travDateTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravDate ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravelDateWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travDateTitle,
          "data-test-id": "TravelDateWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
        open: showTravDate,
        "data-test-id": "TravelDateWiget-ChevStateWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
          "data-test-id": "TravelDateWiget-BlueChev"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "4px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [startDate === null || startDate === void 0 ? void 0 : startDate.getDate(), " \xA0", startDate ? src.MONTHS[parseInt(startDate === null || startDate === void 0 ? void 0 : startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: startDate && src.LONG_WEEK_DAYS[startDate.getDay()]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* DateSeparator */.ZP, {
        "data-test-id": "TravelDateWiget-DateSeparator",
        children: "-to-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? src.MONTHS[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? src.MONTHS[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : src.MONTHS[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: endDate ? src.LONG_WEEK_DAYS[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? src.LONG_WEEK_DAYS[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : src.LONG_WEEK_DAYS[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravelDateWiget = (TravelDateWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellerCounterWiget.tsx






var TravellerCounterWiget = function TravellerCounterWiget(_ref) {
  var showTravCount = _ref.showTravCount,
      handleCaptureCountIncr = _ref.handleCaptureCountIncr,
      handleCaptureCountDecr = _ref.handleCaptureCountDecr,
      captureCount = _ref.captureCount,
      travCountTitle = _ref.travCountTitle,
      travCountSubtitle = _ref.travCountSubtitle;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetStyle */.Dq, {
    "data-test-id": "TravellerCounterWiget-TravellerCountWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravCount ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountTitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText6 */.rS.greyText6,
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountSubtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountSubtitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CounterWrap */.vg, {
      "data-test-id": "TravellerCounterWiget-CounterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 1,
        onClick: handleCaptureCountDecr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "#008CFF"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 20,
        onClick: handleCaptureCountIncr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "#008CFF"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellerCounterWiget = (TravellerCounterWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.tsx












var TravellingToWidget_analytics = (0,insurance/* getAnalytics */.I)();

var TravellingToWidget = function TravellingToWidget(_ref) {
  var travelPurposeTxt = _ref.travelPurposeTxt,
      travCountTitle = _ref.travCountTitle,
      travPurpTitle = _ref.travPurpTitle,
      travDateTitle = _ref.travDateTitle,
      btnDisabledState = _ref.btnDisabledState,
      setCountValue = _ref.setCountValue,
      calendarDatesLimit = _ref.calendarDatesLimit,
      setCalenderValue = _ref.setCalenderValue,
      calenderRef = _ref.calenderRef,
      upcomingTravellerNum = _ref.upcomingTravellerNum,
      upcomingFromDate = _ref.upcomingFromDate,
      upcomingToDate = _ref.upcomingToDate,
      calendarConfig = _ref.calendarConfig;

  var _ref2 = (calendarConfig ? calendarConfig : calendarDatesLimit) || {},
      endDateErrorMessage = _ref2.endDateErrorMessage,
      insPurchaseDateLimitInDays = _ref2.insPurchaseDateLimitInDays,
      insPurchaseEndDateLimitInDays = _ref2.insPurchaseEndDateLimitInDays,
      insPurchaseStartDateLimitInDays = _ref2.insPurchaseStartDateLimitInDays,
      insPurchaseStartDateMinLimitInDays = _ref2.insPurchaseStartDateMinLimitInDays,
      startDateErrorMessage = _ref2.startDateErrorMessage,
      insPurchaseEndDateMinLimitInDays = _ref2.insPurchaseEndDateMinLimitInDays;

  var from = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays);
  var to = (0,insurance_utils/* addDaysToDate */.Xz)(from || new Date(), insPurchaseEndDateMinLimitInDays || 0);
  var defaultSelected = {
    from: from,
    to: to
  };
  var maxEndDate = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var ref = (0,react.useRef)(null);
  var divRefs = (0,react.useRef)([]);

  var _useState = (0,react.useState)(1),
      captureCount = _useState[0],
      setCaptureCount = _useState[1];

  var _useState2 = (0,react.useState)(0),
      dateTab = _useState2[0],
      setDateTab = _useState2[1];

  var _useState3 = (0,react.useState)(defaultSelected),
      range = _useState3[0],
      setRange = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showToast = _useState4[0],
      setShowToast = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      toastMessage = _useState5[0],
      setToastMessage = _useState5[1];

  var _useState6 = (0,react.useState)(new Date()),
      startDate = _useState6[0],
      setStartDate = _useState6[1];

  var _useState7 = (0,react.useState)(),
      endDate = _useState7[0],
      setEndDate = _useState7[1];

  var _useState8 = (0,react.useState)(-1),
      focusedIndex = _useState8[0],
      setFocusedIndex = _useState8[1];

  var prevFocusedIndexRef = (0,react.useRef)(focusedIndex);

  var handleClickOutside = function handleClickOutside(event) {
    var _ref$current;

    if (ref !== null && ref !== void 0 && ref.current && !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target))) {
      setFocusedIndex(-1);
      setShowToast(false);
    }
  };

  var addTravellerNumber = function addTravellerNumber(travNumber) {
    if (travNumber > src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS || travNumber < src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
      });
      (0,insurance_utils/* replaceHistory */.df)("travellers", src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS.toString());
    } else {
      setCaptureCount(travNumber);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: travNumber
      });
      (0,insurance_utils/* replaceHistory */.df)("travellers", travNumber.toString());
    }
  };

  var addTravellerDates = function addTravellerDates(travStartDate, travEndDate) {
    var tempFromDate = (0,insurance_utils/* convertUnixToDate */.P9)(travStartDate);
    var tempToDate = (0,insurance_utils/* convertUnixToDate */.P9)(travEndDate);
    (0,insurance_utils/* replaceHistory */.df)("startDate", travStartDate.toString());
    (0,insurance_utils/* replaceHistory */.df)("endDate", travEndDate.toString());
    (0,XDMAnalytics.updateSearchContext)({
      fromDateTime: travStartDate,
      toDateTime: travEndDate
    });
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  (0,react.useEffect)(function () {
    document.addEventListener("click", handleClickOutside, false);
    return function () {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  (0,react.useEffect)(function () {
    var queryParameters = new URLSearchParams(window.location.search);
    var trav = queryParameters.get("travellers");
    var fromDate = queryParameters.get("startDate");
    var toDate = queryParameters.get("endDate");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    } else {
      var _defaultSelected$from, _defaultSelected$to;

      (0,XDMAnalytics.updateSearchContext)({
        fromDateTime: (_defaultSelected$from = defaultSelected.from) !== null && _defaultSelected$from !== void 0 && _defaultSelected$from.getTime() ? defaultSelected.from.getTime() / 1000 : undefined,
        toDateTime: (_defaultSelected$to = defaultSelected.to) !== null && _defaultSelected$to !== void 0 && _defaultSelected$to.getTime() ? defaultSelected.to.getTime() / 1000 : undefined
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  (0,react.useEffect)(function () {
    if (captureCount >= src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  (0,react.useEffect)(function () {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);
  (0,react.useEffect)(function () {
    var datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      var rect = datePickerElement.getBoundingClientRect();
      var isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        var offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  (0,react.useEffect)(function () {
    if ((range === null || range === void 0 ? void 0 : range.to) === undefined && range !== null && range !== void 0 && range.from) {
      var tempToDate = new Date(range === null || range === void 0 ? void 0 : range.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      (0,insurance_utils/* replaceHistory */.df)("endDate", (0,insurance_utils/* convertDateToUnix */.cJ)(tempToDate).toString());
    }
  }, [range === null || range === void 0 ? void 0 : range.from]);

  var handleClick = function handleClick(index) {
    if (index === focusedIndex) {
      setFocusedIndex(-1);
      setShowToast(false);
    } else {
      setFocusedIndex(index);
    }
  };

  var handleDayClick = function handleDayClick(selectedDate) {
    if (dateTab === 0) {
      var maxStartDate = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range !== null && range !== void 0 && range.from && range !== null && range !== void 0 && range.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        (0,insurance_utils/* replaceHistory */.df)("startDate", (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range !== null && range !== void 0 && range.from) {
        var fromDate = new Date(range === null || range === void 0 ? void 0 : range.from);

        var _maxEndDate = (0,insurance_utils/* addDaysToDate */.Xz)(fromDate, calendarConfig === null || calendarConfig === void 0 ? void 0 : calendarConfig.insPurchaseEndDateLimitInDays);

        if ((range === null || range === void 0 ? void 0 : range.from) > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (_maxEndDate && _maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          var _range$from, _range$from$toLocaleD, _range$to, _range$to$toLocaleDat;

          setRange({
            from: range === null || range === void 0 ? void 0 : range.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
          }

          (0,insurance_utils/* replaceHistory */.df)("endDate", (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
          TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
            actionType: "travel_date_selected",
            payload: {
              departure: (_range$from = range.from) === null || _range$from === void 0 ? void 0 : (_range$from$toLocaleD = _range$from.toLocaleDateString("en-GB")) === null || _range$from$toLocaleD === void 0 ? void 0 : _range$from$toLocaleD.replace(/\//gi, ":"),
              arrival: ((_range$to = range.to) === null || _range$to === void 0 ? void 0 : (_range$to$toLocaleDat = _range$to.toLocaleDateString("en-GB")) === null || _range$to$toLocaleDat === void 0 ? void 0 : _range$to$toLocaleDat.replace(/\//gi, ":")) || ""
            }
          } //"click"
          );
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "travel_date_selected"
            }
          }, {
            fromDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(range === null || range === void 0 ? void 0 : range.from),
            toDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate)
          });
        }
      }
    }
  };

  var handleCaptureCountIncr = function handleCaptureCountIncr() {
    captureCount < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? setCaptureCount(captureCount + 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? captureCount + 1 : src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS
    });
    (0,insurance_utils/* replaceHistory */.df)("travellers", (captureCount + 1).toString());
  };

  var handleCaptureCountDecr = function handleCaptureCountDecr() {
    captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? setCaptureCount(captureCount - 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? captureCount - 1 : src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
    });
    (0,insurance_utils/* replaceHistory */.df)("travellers", (captureCount - 1).toString());
  };

  var handleSubmit = function handleSubmit(chkIn, chkOut) {
    var _chkIn$toLocaleDateSt, _chkOut$toLocaleDateS;

    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: (chkIn === null || chkIn === void 0 ? void 0 : (_chkIn$toLocaleDateSt = chkIn.toLocaleDateString("en-GB")) === null || _chkIn$toLocaleDateSt === void 0 ? void 0 : _chkIn$toLocaleDateSt.replace(/\//gi, ":")) || "",
        arrival: (chkOut === null || chkOut === void 0 ? void 0 : (_chkOut$toLocaleDateS = chkOut.toLocaleDateString("en-GB")) === null || _chkOut$toLocaleDateS === void 0 ? void 0 : _chkOut$toLocaleDateS.replace(/\//gi, ":")) || ""
      }
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_date_selected"
      }
    }, {
      fromDateTime: chkIn ? (0,insurance_utils/* convertDateToUnix */.cJ)(chkIn) : 0,
      toDateTime: chkOut ? (0,insurance_utils/* convertDateToUnix */.cJ)(chkOut) : 0
    });
    setFocusedIndex(-1);
    setShowToast(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    ref: device == "lg" ? ref : null,
    "data-test-id": "TravellingToWidget-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: function handleTravDate() {
        return handleClick(0);
      },
      travDateTitle: travDateTitle,
      startDate: range === null || range === void 0 ? void 0 : range.from,
      endDate: range === null || range === void 0 ? void 0 : range.to,
      "data-test-id": "TravellingToWidget-TravelDateWiget"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr,
      "data-test-id": "TravellingToWidget-TravellerCounterWiget"
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* DatePickerComp */.X9, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range === null || range === void 0 ? void 0 : range.from,
      to: range === null || range === void 0 ? void 0 : range.to,
      maxEndDate: maxEndDate,
      toastMessage: toastMessage,
      showToast: showToast,
      "data-test-id": "TravellingToWidget-DatePickerComp"
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ReactPortalComp */.hK, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RangeDatePicker */.$m, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: function onBackPress() {
          return handleClick(0);
        },
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range === null || range === void 0 ? void 0 : range.from,
        to: range === null || range === void 0 ? void 0 : range.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick,
        maxEndDate: maxEndDate,
        "data-test-id": "TravellingToWidget-RangeDatePicker"
      })
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellingToWidget = (TravellingToWidget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.style.ts




var WhatsCoveredStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1fouhoy-0"
})(["background:#fff;width:100%;", "{font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], components/* H2TagStyle */.FI, function (p) {
  return p.pageTheme === src.PARTNER.MMT && "\n    ".concat(components/* H4TagStyle */.sz, "{\n        font-size:24px;\n        font-weight:900;\n    }\n    ");
}, src.deviceType.mobile, ui_widgets_src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
var BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1fouhoy-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.tsx








var WhatsCovered = function WhatsCovered(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsCoveredStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "WhatsCovered-WhatsCoveredStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "WhatsCovered-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        "data-test-id": "WhatsCovered-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        "data-test-id": "WhatsCovered-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: device == "lg" ? "large" : "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "0 0 66px",
        "data-test-id": "WhatsCovered-ParaTag",
        children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? (data === null || data === void 0 ? void 0 : data.length) === 2 ? "50px" : "82px" : "24px",
        padding: "0 0 15px 0",
        "data-test-id": "WhatsCovered-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
            "data-test-id": `WhatsCovered-BenefitItem-${index}`,
            children: [item.cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg,
              "data-test-id": "WhatsCovered-ImageComponent"
            }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-H4Tag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ParaTag */.dZ, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-ParaTag",
              children: [" ", item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
              "data-test-id": "WhatsCovered-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.info,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var WhatsCovered_WhatsCovered = (WhatsCovered);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.style.ts



var WhyBuyTravInsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "dnzmib-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #EFF3F8;\n    padding-bottom:80px;\n    ";
}, components/* H2TagStyle */.FI, src.deviceType.mobile, src.deviceType.mobile, function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #fff;\n    padding-top:16px;\n    ";
});
var WhyFeatListWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "dnzmib-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], src.deviceType.mobile);
var WhyBuyItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "dnzmib-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], src.deviceType.mobile);
var ShieldWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "dnzmib-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.tsx








var WhyBuyTravIns = function WhyBuyTravIns(_ref) {
  var title = _ref.title,
      info = _ref.info,
      data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuyTravInsStyle, {
    "data-test-id": "WhyBuyTravIns-WhyBuyTravInsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "WhyBuyTravIns-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? "74px" : "24px",
        "data-test-id": "WhyBuyTravIns-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
            margin: "0 0 60px",
            "data-test-id": "WhyBuyTravIns-H2Tag",
            children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            margin: "0 0 20px",
            "data-test-id": "WhyBuyTravIns-H5Tag",
            children: [" ", title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "large" : "sm",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "WhyBuyTravIns-ParaTag",
            children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: info,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyFeatListWrap, {
          "data-test-id": "WhyBuyTravIns-WhyFeatListWrap",
          children: data && data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuyItem, {
              "data-test-id": `WhyBuyTravIns-WhyBuyItem-${index}`,
              children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                src: item.icon,
                height: "24",
                width: "24",
                "data-test-id": "WhyBuyTravIns-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                "data-test-id": "WhyBuyTravIns-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item === null || item === void 0 ? void 0 : item.info,
                  "data-test-id": "WhyBuyTravIns-FormattedText"
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldWrap, {
          "data-test-id": "WhyBuyTravIns-ShieldWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg",
            "data-test-id": "WhyBuyTravIns-ImageComponent"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var WhyBuyTravIns_WhyBuyTravIns = (WhyBuyTravIns);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx






















/***/ }),

/***/ 3837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IV": function() { return /* reexport */ withExperimentTrackingStringProvider; },
  "ut": function() { return /* reexport */ withReferrerProvider; }
});

// UNUSED EXPORTS: withDeviceAndThemeProvider

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/withDeviceAndThemeProvider.tsx
var withDeviceAndThemeProvider = __webpack_require__(2390);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ExperimentTrackingStringContext.ts
var ExperimentTrackingStringContext = __webpack_require__(5658);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/withExperimentTrackingStringProvider.tsx


function withExperimentTrackingStringProvider(comp, experiment) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExperimentTrackingStringContext/* ExperimentTrackingString.Provider */.M.Provider, {
    value: experiment,
    children: comp
  });
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ReferrerContext.ts
var ReferrerContext = __webpack_require__(932);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/withReferrerProvider.tsx


function withReferrerProvider(comp, referrer) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ReferrerContext/* default.Provider */.Z.Provider, {
    value: referrer,
    children: comp
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/index.ts




/***/ }),

/***/ 5148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y6": function() { return /* reexport */ TextStyles_AnchorTag; },
  "C2": function() { return /* reexport */ AnchorTagStyle; },
  "YP": function() { return /* reexport */ BackDropComp_BackDropComp; },
  "Il": function() { return /* reexport */ BulletListItem_style_BulletListItemStyle; },
  "nt": function() { return /* reexport */ CheckButton_CheckButton; },
  "mT": function() { return /* reexport */ CheckButtonStyle; },
  "Eq": function() { return /* reexport */ CommonModalDweb_CommonModalDweb; },
  "E5": function() { return /* reexport */ CommonModalDwebStyle; },
  "X9": function() { return /* reexport */ DatePickerComp_DatePickerComp; },
  "S_": function() { return /* reexport */ DesktopLayout_DesktopLayout; },
  "bA": function() { return /* reexport */ components_FlexComp_FlexComp; },
  "lL": function() { return /* reexport */ FlexCompStyle; },
  "rc": function() { return /* reexport */ components_FormattedText_FormattedText; },
  "yZ": function() { return /* reexport */ TextStyles_H2Tag; },
  "FI": function() { return /* reexport */ H2TagStyle; },
  "vb": function() { return /* reexport */ TextStyles_H3SmallTag; },
  "AI": function() { return /* reexport */ TextStyles_H3Tag; },
  "KO": function() { return /* reexport */ H3TagStyle; },
  "j9": function() { return /* reexport */ TextStyles_H4Tag; },
  "sz": function() { return /* reexport */ H4TagStyle; },
  "jN": function() { return /* reexport */ TextStyles_H5Tag; },
  "Wl": function() { return /* reexport */ H5TagStyle; },
  "cu": function() { return /* reexport */ ImageComponent_ImageComponent; },
  "Du": function() { return /* reexport */ ImageTag_ImageTag; },
  "WB": function() { return /* reexport */ LandingButton_LandingButton; },
  "zm": function() { return /* reexport */ LandingButtonStyle; },
  "rU": function() { return /* reexport */ MarkdownText_MarkdownText; },
  "dZ": function() { return /* reexport */ TextStyles_ParaTag; },
  "OG": function() { return /* reexport */ ParaTagStyle; },
  "EU": function() { return /* reexport */ RadioButton_RadioButton; },
  "$m": function() { return /* reexport */ RangeDatePicker_RangeDatePicker; },
  "hK": function() { return /* reexport */ ReactPortalComp_ReactPortalComp; },
  "Ho": function() { return /* reexport */ RichText_RichText; },
  "LV": function() { return /* reexport */ SectionDividers_SectionDividers; },
  "$f": function() { return /* reexport */ SectionDividersStyle; },
  "qm": function() { return /* reexport */ Shimmer; },
  "KQ": function() { return /* reexport */ ShimmerVersion2; },
  "AO": function() { return /* reexport */ ShimmerVersion3; },
  "pF": function() { return /* reexport */ TextStyles_SpanTag; },
  "zs": function() { return /* reexport */ SpanTagStyle; },
  "$j": function() { return /* reexport */ Spinner_Spinner; },
  "Wz": function() { return /* reexport */ TMFloatingInput_TMFloatingInput; },
  "dd": function() { return /* reexport */ TMInputWrap; },
  "$G": function() { return /* reexport */ Tags_Tags; },
  "EN": function() { return /* reexport */ TagsStyle; },
  "jf": function() { return /* reexport */ Toast_style_ToastStyle; },
  "V6": function() { return /* reexport */ ToolTipCompWrapper; },
  "Bu": function() { return /* reexport */ Toast_WebToast; }
});

// UNUSED EXPORTS: BulletListItem, DatePicker, H6Tag, LandingButtonTertiary, LandingButtonWhite, Toast, getPlainText

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BackDropComp/BackDropComp.style.ts

var BackDropCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BackDropCompstyle__BackDropCompStyle",
  componentId: "sc-13xixk0-0"
})(["position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);z-index:46;width:100%;height:", ";"], function (p) {
  return p.height ? "".concat(p.height, "px") : "100vh";
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BackDropComp/BackDropComp.tsx




var BackDropComp = function BackDropComp(_ref) {
  var onClose = _ref.onClose;

  var _useState = (0,react.useState)(undefined),
      height = _useState[0],
      setHeight = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      setHeight(window.innerHeight);
    };

    if (true) {
      setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropCompStyle, {
    onClick: onClose,
    height: height,
    "data-test-id": "BackDropComp-BackDropCompStyle"
  });
};

/* harmony default export */ var BackDropComp_BackDropComp = (BackDropComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(2874);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.style.ts


var BulletListItem_style_BulletListItemStyle = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "m828am-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:18px;line-height:22px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], Global/* theme.greyText */.rS.greyText, function (props) {
  return props.bulletColor;
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.tsx




var BulletListItem = function BulletListItem(_ref) {
  var children = _ref.children,
      _ref$bulletColor = _ref.bulletColor,
      bulletColor = _ref$bulletColor === void 0 ? theme.darkYellowText : _ref$bulletColor;
  return /*#__PURE__*/_jsx(BulletListItemStyle, {
    bulletColor: bulletColor,
    "data-test-id": "BulletListItem-BulletListItemStyle",
    children: children
  });
};

/* harmony default export */ var BulletListItem_BulletListItem = ((/* unused pure expression or super */ null && (BulletListItem)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CheckButton/CheckButton.style.ts

var CheckButtonStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckButtonstyle__CheckButtonStyle",
  componentId: "dvx3ai-0"
})(["display:flex;align-items:baseline;cursor:pointer;", " label{margin-left:10px;flex:1;width:100%;cursor:pointer;user-select:none;}}", " input[type=\"checkbox\"]{", " visibility:hidden;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;}@supports (-moz-appearance:none){input[type=\"checkbox\"]{visibility:visible;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;width:18px;height:18px;accent-color:#008CFF;}}input[type='checkbox']::before{width:16px;height:16px;display:flex;visibility:visible;flex-shrink:0;border:1px solid #4a4a4a;border-radius:4px;background:#fff;position:absolute;top:0px;left:-2px;content:'';}input[type='checkbox']::after{content:'';display:block;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin:0px 0 0 4px;position:absolute;visibility:visible;top:3px;left:0px;}input[type='checkbox']:checked::before{", " border:unset;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.travellingTo && "\n label{\n  position:absolute;\n  left:8px;\n  bottom:8px;\n }\n";
}, function (props) {
  return !props.isDisabled && "cursor: pointer;";
}, function (props) {
  return props.isDisabled ? "background: #0000004D;" : "background: #008cff;";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CheckButton/CheckButton.tsx





var CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      inputId = _ref.inputId,
      travellingTo = _ref.travellingTo,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      isDisabled = _ref.isDisabled,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      margin = _ref.margin;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckButtonStyle, {
    margin: margin,
    travellingTo: travellingTo,
    isDisabled: isDisabled,
    "data-test-id": "CheckButton-CheckButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      onChange: handleChange,
      type: "checkbox",
      id: inputId,
      checked: isChecked
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      id: inputId,
      "data-test-id": "CheckButton-label",
      children: children
    })]
  });
};

/* harmony default export */ var CheckButton_CheckButton = (CheckButton);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.style.ts

var SectionDividersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "aokiou-0"
})(["background:", ";width:", ";height:", ";border-radius:", ";margin:", ";", ";", ";", ";flex-shrink:0;"], function (p) {
  return p.backgroundColor ? "".concat(p.backgroundColor) : "#f2f2f2";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.height ? p.height : "4px";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0px";
}, function (p) {
  return p.margin ? p.margin : "0px";
}, function (p) {
  return p.xs && "height: 1px;";
}, function (p) {
  return p.small && "height: 10px;";
}, function (p) {
  return p.large && "height: 25px;";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/TextStyles.style.ts




var renderFont = function renderFont(txtfontSize) {
  switch (txtfontSize) {
    case "xxs":
      return "\n        font-size: 10px;\n        line-height: 16px;\n      ";

    case "xs":
      return "\n        font-size: 12px;\n        line-height: 16px;\n      ";

    case "sm":
      return "\n        font-size: 0.875rem;\n        line-height: 20px;\n      ";

    case "md":
      return "\n        font-size: 1em;\n        line-height: 22px;\n      ";

    case "large":
      return "\n        font-size: 18px;\n        line-height: 24px;\n      ";

    case "xlarge":
      return "\n        font-size: 1.375rem;\n        line-height: 26px;\n      ";

    /* istanbul ignore next */

    case "xxlarge":
      return "\n        font-size: 1.5em;\n        line-height: 32px;\n      ";

    /* istanbul ignore next */

    case "xxxlarge":
      return "\n        font-size: 1.75em;\n        line-height: 32px;\n      ";

    /* istanbul ignore next */

    default:
      return "\n        font-size: 0.875em;\n        line-height: 20px;\n      ";
  }
};

var renderFontWeight = function renderFontWeight(txtfontWeight, context) {
  switch (txtfontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "bold":
      return "\n          ".concat(context === src.PARTNER.MMT ? "font-weight: 700" : "font-weight: 500", ";\n      ");

    case "black":
      return "\n           ".concat(context === src.PARTNER.MMT ? "font-weight: 900" : "font-weight: 700", ";\n        ");

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H2TagStyle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "f0szg1-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "36px" : "32px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "44px" : "37px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H3TagStyle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "f0szg1-1"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";text-align:var(--textAlign,left);font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "32px" : "24px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "38px" : "28px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H4TagStyle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "f0szg1-2"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "24px" : "22px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "28px" : "26px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H5TagStyle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "f0szg1-3"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "22px" : "18px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "26px" : "21px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H3TagSmallStyle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagSmallStyle",
  componentId: "f0szg1-4"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "22px" : "18px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "26px" : "21px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var TextStyles_style_H6TagStyle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "f0szg1-5"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === src.PARTNER.MMT ? "18px" : "16px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "21px" : "18px";
}, function (p) {
  return p.context === src.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var ParaTagStyle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "f0szg1-6"
})(["", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";text-transform:", ";& > .boldText{font-weight:700;}word-break:break-word;"], function (p) {
  return p.txtfontSize ? "\n    ".concat(renderFont(p.txtfontSize), "\n  ") : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.lineHeight && p.lineHeight;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var SpanTagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "f0szg1-7"
})(["", " ", " display:inline-block;color:", ";margin:", ";text-transform:", ";word-break:break-word;"], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "inherit";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var AnchorTagStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "f0szg1-8"
})(["", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";text-transform:", ";", ""], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.txtcolor ? p.txtcolor : Global/* theme.blueText */.rS.blueText;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.textTransform && p.textTransform;
}, function (p) {
  return p.disableState && "\n    opacity:0.5;\n    pointer-events:none;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts


var TMInputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__TMInputWrap",
  componentId: "sc-1pz2vug-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:700;font-size:14px;line-height:20px;color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:10px;top:18px;text-transform:uppercase;", " ", "}", " label span{font-weight:400;text-transform:lowercase;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
}, Global/* theme.greyText */.rS.greyText, function (props) {
  return props.placeholder && "\n    color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n    background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n    top: 5px;\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color: ".concat(Global/* theme.lightBlack */.rS.lightBlack, ";\n    ");
}, function (props) {
  return props.clickable && "\n        cursor: pointer;\n        background:".concat(Global/* theme.whiteText */.rS.whiteText, ";\n        color: ").concat(Global/* theme.greyText */.rS.greyText, "\n    ");
});
var TMInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "TMFloatingInputstyle__TMInputStyle",
  componentId: "sc-1pz2vug-1"
})(["background:", ";border:1px solid ", ";border-radius:4px;padding:26px 10px 10px;font-weight:700;font-size:14px;line-height:19px;display:block;width:100%;", " &:focus + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", "}&:valid + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", " ", " ", " ", "}", " ", " ", " &:focus{outline:none;border:1px solid ", ";background:", ";}&:valid{outline:none;border:1px solid ", ";background:", ";", "}"], Global/* theme.gray97 */.rS.gray97, Global/* theme.lightGrey */.rS.lightGrey, function (props) {
  return props.verifiedTag && "\n        padding-right: 80px;\n    ";
}, Global/* theme.blueText */.rS.blueText, Global/* theme.blueLight */.rS.blueLight, function (props) {
  return props.errorState && "\n        color: ".concat(Global/* theme.redText2 */.rS.redText2, ";\n    ");
}, Global/* theme.greyText6 */.rS.greyText6, Global/* theme.smokeWhite */.rS.smokeWhite, function (props) {
  return props.isActive && "\n            color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
}, function (props) {
  return props.placeholder && "\n            color: ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
}, function (props) {
  return props.errorState && "\n             color: ".concat(Global/* theme.redText2 */.rS.redText2, ";\n     ");
}, function (props) {
  return props.clickable && "\n        background: ".concat(Global/* theme.whiteText */.rS.whiteText, ";\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color:  ".concat(Global/* theme.lightBlack */.rS.lightBlack, ";\n        border: 1px solid ").concat(Global/* theme.lightSilver */.rS.lightSilver, ";\n        background: ").concat(Global/* theme.whiteText */.rS.whiteText, ";\n    ");
}, function (props) {
  return props.clickable && "\n        pointer-events: none;\n        background: ".concat(Global/* theme.whiteText */.rS.whiteText, "  !important;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n    ");
}, function (props) {
  return props.errorState && "\n      border: 1px solid ".concat(Global/* theme.redText2 */.rS.redText2, " !important;\n      background: ").concat(Global/* theme.snowWhite */.rS.snowWhite, "  !important;\n    ");
}, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.gainsBoro */.rS.gainsBoro, Global/* theme.smokeWhite */.rS.smokeWhite, function (props) {
  return props.isActive && "\n            border: 1px solid ".concat(Global/* theme.blueText */.rS.blueText, ";\n            background: ").concat(Global/* theme.blueLight */.rS.blueLight, ";\n        ");
});
var VerifiedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__VerifiedContainer",
  componentId: "sc-1pz2vug-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
var InputWpr = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__InputWpr",
  componentId: "sc-1pz2vug-3"
})(["position:relative;"]);
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__IconContainer",
  componentId: "sc-1pz2vug-4"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts





var modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1890wa2-0"
})(["position:fixed;width:", ";height:fit-content;max-height:531px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, SectionDividersStyle, TMInputWrap, src.deviceType.mobile, modalAnim, TMInputWrap);
var CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalHeader",
  componentId: "sc-1890wa2-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:flex-start;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], H5TagStyle, function (p) {
  return p.nonClipHeading && "\n     ".concat(H5TagStyle, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, src.deviceType.mobile);
var CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CrossIconWrap",
  componentId: "sc-1890wa2-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx







var CommonModalDweb = function CommonModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      nonClipHeading = _ref.nonClipHeading;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ReactPortalComp_ReactPortalComp, {
    "data-test-id": "CommonModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "CommonModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "CommonModalDweb-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
          color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
          "data-test-id": "CommonModalDweb-H5Tag",
          children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "40px",
            height: "40px",
            src: customIcon,
            "data-test-id": "CommonModalDweb-ImageComponent"
          }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
            value: customTitle,
            "data-test-id": "CommonModalDweb-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "CommonModalDweb-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "CommonModalDweb-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropComp_BackDropComp, {
      onClose: handleClick,
      "data-test-id": "CommonModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ var CommonModalDweb_CommonModalDweb = (CommonModalDweb);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(3063);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(405);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(2598);
// EXTERNAL MODULE: ../../node_modules/react-day-picker/dist/index.esm.js + 30 modules
var index_esm = __webpack_require__(6621);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 2 modules
var utils = __webpack_require__(3621);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButton.style.ts



var LandingButtonStyle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "yz2hwb-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:", ";height:", ";border:none;outline:none;cursor:pointer;margin:", ";flex:", ";flex-shrink:", ";display:flex;align-items:center;gap:8px;justify-content:center;position:relative;padding:12px 20px;text-transform:uppercase;", " ", " span{font-size:16px;font-weight:900;flex-shrink:0;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}"], Global/* theme.blueGradient */.rS.blueGradient, function (p) {
  return p.customWidth ? p.customWidth : "fit-content";
}, function (p) {
  return p.customHeight ? p.customHeight : "fit-content";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "0";
}, function (p) {
  return p.btnTheme === src.PARTNER.MMT ? "\n    border-radius:8px;\n    " : p.btnTheme === src.PARTNER.GI ? "border-radius: 4px;\n    background: ".concat(Global/* theme.orange */.rS.orange, ";\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.14);") : "";
}, function (props) {
  return props.disableState && "\n  background: ".concat(Global/* theme.greyText2 */.rS.greyText2, ";\n  color: rgba(0, 0, 0, 0.3);\n  pointer-events:none;\n  ");
});
var ShimmerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "yz2hwb-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
var LandingButton_style_LandingButtonWhiteStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "yz2hwb-2"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);color:", ";span{color:", ";font-size:16px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(Global/* theme.greyText2 */.rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButton_style_LandingButtonTertiaryStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonTertiaryStyle",
  componentId: "yz2hwb-3"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border:1px solid ", ";height:32px;padding:9px;color:", ";span{color:", ";font-size:12px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(Global/* theme.greyText2 */.rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButtonBlackOutlineStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonBlackOutlineStyle",
  componentId: "yz2hwb-4"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:", ";border:1px solid black;span{color:", ";}"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/Toast.style.ts




var Toast_style_ToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastStyle",
  componentId: "p382w4-0"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 18px;background:#4a4a4a;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:12px;width:436px;position:fixed;bottom:30px;right:30px;gap:8px;", "{flex-shrink:0;}", "{width:127px;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], SpanTagStyle, LandingButton_style_LandingButtonTertiaryStyle, src.deviceType.mobile);
var Toast_style_CloseIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__CloseIconWrap",
  componentId: "p382w4-1"
})(["width:28px;height:28px;cursor:pointer;"]);
var Toast_style_ToastIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastIcon",
  componentId: "p382w4-2"
})(["display:flex;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DatePickerComp/DatePickerComp.style.ts



var DatePickerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerWrap",
  componentId: "sc-3xqyqc-0"
})(["width:592px;background:#ffffff;box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;", "{position:static;background:#fcdadb;width:fit-content;margin-bottom:16px;margin-left:16px;}", " span{font-size:14px;color:", ";}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:#eaf5ff;color:#000;border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:#008cff;border-radius:0px 2px 2px 0px;color:#fff;}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:#9b9b9b;}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:#000;}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:#eaf5ff;border-radius:0;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:#008cff;border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px #008cff;border-left:solid 2px #008cff;}"], Toast_style_ToastStyle, Toast_style_ToastStyle, Global/* theme.redText */.rS.redText);
var DateLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DateLabel",
  componentId: "sc-3xqyqc-1"
})(["background:#ffffff;border-radius:2px;padding:0 8px;", ""], function (p) {
  return p.activeTab && "\n    background: #eaf5ff;\n    border: 1px solid #008cff;\n    border-radius: 2px;\n    ";
});
var DateTab = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "DatePickerCompstyle__DateTab",
  componentId: "sc-3xqyqc-2"
})(["display:flex;padding:10px 15px;border-radius:4px 4px 0px 0px;background-color:#f2f2f2;"]);
var DateTabList = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "DatePickerCompstyle__DateTabList",
  componentId: "sc-3xqyqc-3"
})(["cursor:pointer;display:flex;align-items:center;gap:4px;margin-right:10px;&:last-child{margin-right:unset;}"]);
var ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__ErrorToast",
  componentId: "sc-3xqyqc-4"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
var DobPickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DobPickerStyle",
  componentId: "sc-3xqyqc-5"
})(["border-radius:4px;border:0px solid #979797;background:#fff;box-shadow:0px 1px 6px 0px rgba(0,0,0,0.2);width:300px;.rdp-dropdown_year,.rdp-dropdown_month{border-radius:4px;border:1px solid #4a4a4a;padding:0 8px;}.rdp-day_selected,.rdp-day_selected:focus-visible,.rdp-day_selected:hover{border-radius:2px 0px 0px 2px;background:#008cff;color:#fff;}.rdp-head{color:#9b9b9b;text-align:center;font-size:12px;font-weight:700;}.rdp-weeknumber,.rdp-day{font-size:12px;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DatePickerComp/DatePickerComp.tsx





 // import "react-day-picker/dist/style.css";




var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var DatePickerComp = function DatePickerComp(_ref) {
  var startDateLabel = _ref.startDateLabel,
      endDateLabel = _ref.endDateLabel,
      from = _ref.from,
      to = _ref.to,
      maxEndDate = _ref.maxEndDate,
      dateTab = _ref.dateTab,
      handleDateTab = _ref.handleDateTab,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage;

  var weekDayNameFormatter = function weekDayNameFormatter(date) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-test-id": "DatePickerComp-weekDayNameFormatter",
      children: date.toDateString()[0]
    });
  };

  var monthNameFormatter = function monthNameFormatter(date) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      "data-test-id": "DatePickerComp-monthNameFormatter",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        "data-test-id": "DatePickerComp-monthNameFormatter-b",
        children: MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  var disabledDays = function disabledDays(date) {
    return (0,isBefore/* default */.Z)((0,startOfDay/* default */.Z)(date), (0,startOfDay/* default */.Z)(new Date())) || !!(maxEndDate && (0,isAfter/* default */.Z)(date, maxEndDate));
  };

  var _useState = (0,react.useState)(new Date()),
      currentMonth = _useState[0],
      setCurrentMonth = _useState[1];

  (0,react.useEffect)(function () {
    if (from && to) {
      setCurrentMonth(from);
    }
  }, [from, to]);

  var handleMonthChange = function handleMonthChange(month) {
    setCurrentMonth(month);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DatePickerWrap, {
    id: "datePickerContainer",
    "data-test-id": "DatePickerComp-DatePickerWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTab, {
      "data-test-id": "DatePickerComp-DateTab",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(0);
        },
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: startDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: dateTab == 0 ? "bold" : "regular",
            color: dateTab == 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: from ? (0,utils/* calendarLabelFormatter */.IZ)(from) : "Select"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateTabList, {
        "data-test-id": "DatePickerComp-DateTabList",
        children: "-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(1);
        },
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: endDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontWeight: dateTab == 1 ? "bold" : "regular",
            fontSize: "sm",
            color: dateTab == 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: to ? (0,utils/* calendarLabelFormatter */.IZ)(to) : "Select"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, {
      mode: "range",
      numberOfMonths: 2,
      selected: selected,
      disabled: disabledDays,
      onDayClick: handleDayClick,
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      },
      month: currentMonth,
      onMonthChange: handleMonthChange,
      "data-test-id": "DatePickerComp-DayPicker"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorToast, {
      "data-test-id": "DatePickerComp-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "DatePickerComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
          value: toastMessage,
          "data-test-id": "DatePickerComp-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var DatePickerComp_DatePickerComp = (DatePickerComp);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(1046);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(8619);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DesktopLayout/DesktopLayout.style.ts



var DesktopLayoutStyleSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSectionWrap",
  componentId: "n4shqf-0"
})(["position:relative;padding-top:6px;img,picture{flex-shrink:0;}&:after{position:fixed;width:100%;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/blue_Grad_Bg_563cf7d36a.png\");background-repeat:no-repeat;background-size:cover;content:\"\";top:0;left:0;height:87%;z-index:1;}", " @media ", "{padding-top:0px;&:after{height:0;background:transparent;background-image:none;}}"], function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.landingPageProp ? "\n        &:after {\n        background:transparent;\n        }\n        ".concat(LandingButtonStyle, "{\n            border-radius:38px;\n        }\n") : p.pageTheme === src.PARTNER.GI && p.landingPageProp ? "\n    &:after {\n    background:transparent;\n    }\n    ".concat(LandingButtonStyle, "{\n        border-radius:30px;\n    }\n") : p.pageTheme === src.PARTNER.MYBIZ && p.landingPageProp ? "\n    &:after {\n    background:transparent;\n    }\n    ".concat(LandingButtonStyle, "{\n        border-radius:30px;\n    }\n") : "";
}, src.deviceType.mobile);
var DesktopLayoutStyleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSection",
  componentId: "n4shqf-1"
})(["width:", ";margin:0 auto;display:flex;gap:", ";height:100%;z-index:3;position:relative;justify-content:space-between;align-items:", ";flex-direction:", ";margin-bottom:", ";background:", ";", " @media ", "{background:#f2f2f2;width:100%;gap:24px;padding:56px 16px 0;margin-top:0;border-radius:0px;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/mob_Bg_76aceb3f35.png\");background-repeat:no-repeat;background-size:contain;flex-direction:column;", "}"], function (p) {
  return p.landingMargin ? "1200px" : "1230px";
}, function (p) {
  return p.landingMargin ? "88px" : "58px";
}, function (p) {
  return p.alignCenter ? "flex-start" : "baseline";
}, function (p) {
  return p.flexDirection ? "column" : "row";
}, function (p) {
  return p.landingMargin ? "70px" : "";
}, function (p) {
  return p.landingMargin ? "#fff" : "transparent";
}, function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.landingMargin ? "\n            padding:68px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : p.pageTheme === src.PARTNER.GI && p.landingMargin ? "\n            padding:38px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : "";
}, src.deviceType.mobile, function (p) {
  return p.landingMargin && "\n            padding-bottom: 238px;\n            margin-bottom: -236px ;\n        ";
});
var DesktopLayoutBotttomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutBotttomSection",
  componentId: "n4shqf-2"
})(["margin-top:20px;display:flex;gap:60px;height:100%;z-index:2;position:relative;align-items:flex-start;flex-direction:column;@media ", "{gap:56px;z-index:3;}"], src.deviceType.mobile);
var DesktopLayoutLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutLeftSection",
  componentId: "n4shqf-3"
})(["display:flex;flex-direction:column;align-self:flex-start;padding-top:", ";gap:32px;margin:", ";height:", ";flex:1;margin-left:", ";position:sticky;top:155px;width:498px;", " @media ", "{margin-left:0;margin-top:11px;padding-top:0;height:unset;gap:10px;position:static;width:100%;}"], function (p) {
  return p.leftSectionHeight ? "" : "0px";
}, function (p) {
  return p.leftSectionMargin ? p.leftSectionMargin : "";
}, function (p) {
  return p.leftSectionHeight ? "100%" : "calc(708px - 130px)";
}, function (p) {
  return p.leftSectionHeight ? "" : "15px";
}, function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.leftSectionHeight ? "\n            margin-top:40px;\n" : p.pageTheme === src.PARTNER.GI ? "\n            margin-top:40px;\n" : "";
}, src.deviceType.mobile);
var DesktopLayoutRightSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutRightSection",
  componentId: "n4shqf-4"
})(["width:", ";flex-shrink:0;padding-bottom:", ";display:flex;flex-direction:column;z-index:1;gap:16px;padding:", ";margin-right:", ";min-height:490px;margin-top:40px;&::-webkit-scrollbar{display:none;}@media ", "{width:100%;overflow-y:unset;padding:0;margin-right:0;height:unset;margin-top:0;", "}"], function (p) {
  return p.rightSectionHeight ? "592px" : "622px";
}, function (p) {
  return p.rightSectionHeight ? "" : "40px";
}, function (p) {
  return p.rightSectionHeight ? "" : "56px 30px 0";
}, function (p) {
  return p.rightSectionHeight ? "" : "-15px";
}, src.deviceType.mobile, function (p) {
  return !p.rightSectionHeight && "\n        margin-right: -16px;\n        margin-left: -16px;\n        width: -webkit-fill-available;\n        overflow-y: scroll;\n        flex-shrink:unset;\n        ";
});
var DesktopLayoutHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutHeading",
  componentId: "n4shqf-5"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DesktopLayout/DesktopLayout.tsx










var DesktopLayout = function DesktopLayout(_ref) {
  var title = _ref.title,
      leftComp = _ref.leftComp,
      rightComp = _ref.rightComp,
      bottomComp = _ref.bottomComp,
      headingComp = _ref.headingComp,
      height = _ref.height,
      alignCenter = _ref.alignCenter,
      leftSectionMargin = _ref.leftSectionMargin,
      rightSectionHeight = _ref.rightSectionHeight,
      leftSectionHeight = _ref.leftSectionHeight,
      landingMargin = _ref.landingMargin,
      subTitle = _ref.subTitle,
      shimmer = _ref.shimmer,
      landingPageProp = _ref.landingPageProp,
      goToMyOrders = _ref.goToMyOrders,
      _ref$showMyOrders = _ref.showMyOrders,
      showMyOrders = _ref$showMyOrders === void 0 ? true : _ref$showMyOrders;
  var context = (0,hooks/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(undefined),
      windowHeight = _useState[0],
      setWindowHeight = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      setWindowHeight(window.innerHeight);
    };

    if (true) {
      setWindowHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSectionWrap, {
    id: "pageId",
    height: height,
    pageTheme: context ? context : undefined,
    landingPageProp: landingPageProp,
    "data-test-id": "DesktopLayout-DesktopLayoutStyleSectionWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSection, {
      landingMargin: landingMargin,
      alignCenter: alignCenter,
      pageTheme: context ? context : undefined,
      "data-test-id": "DesktopLayout-DesktopLayoutStyleSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutLeftSection, {
        leftSectionHeight: leftSectionHeight,
        leftSectionMargin: leftSectionMargin,
        pageTheme: context ? context : undefined,
        "data-test-id": "DesktopLayout-DesktopLayoutLeftSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: shimmer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            flexDirection: "column",
            gap: "4px",
            "data-test-id": "DesktopLayout-FlexComp",
            children: [subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer, {
              width: "375px",
              height: "38px",
              "data-test-id": "DesktopLayout-Shimmer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer, {
              width: "100%",
              height: "56px",
              "data-test-id": "DesktopLayout-Shimmer"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [subTitle && (device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              margin: device == "lg" ? "40px 0 0" : "",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "md",
              fontWeight: "black",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-ParaTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })), device == "lg" ? title !== null && title !== void 0 && title.html ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
              value: title,
              "data-test-id": "DesktopLayout-FormattedText"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
              "data-test-id": "DesktopLayout-H2Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : title !== null && title !== void 0 && title.html ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
              value: title,
              "data-test-id": "DesktopLayout-FormattedText"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })]
          })
        }), leftComp]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutRightSection, {
        rightSectionHeight: rightSectionHeight,
        "data-test-id": "DesktopLayout-DesktopLayoutRightSection",
        children: [context && showMyOrders && landingPageProp && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignSelf: "flex-end",
          isCursorPointer: true,
          gap: "4px",
          alignItems: "center",
          margin: "0 0 8px",
          "data-test-id": "DesktopLayout-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            fontWeight: "bold",
            handleClick: goToMyOrders,
            "data-test-id": "DesktopLayout-AnchorTag",
            children: "My Orders"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {
            width: 16,
            height: 16,
            "data-test-id": "DesktopLayout-ArrowRight"
          })]
        }), rightComp]
      })]
    }), bottomComp && /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopLayoutBotttomSection, {
      "data-test-id": "DesktopLayout-DesktopLayoutBotttomSection",
      children: bottomComp
    })]
  });
};

/* harmony default export */ var DesktopLayout_DesktopLayout = (DesktopLayout);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FlexComp/FlexComp.style.ts


var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderAlignSelf = function renderAlignSelf(alignSelf) {
  switch (alignSelf) {
    case "center":
      return "align-self: center;";

    case "baseline":
      return "align-self: baseline;";

    case "flex-start":
      return "align-self:flex-start;";

    case "flex-end":
      return "align-self:flex-end;";

    default:
      return "align-self:unset;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    case "inherit":
      return "justify-content:inherit;";

    case "right":
      return "justify-content:right;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    case "row-reverse":
      return "flex-direction:row-reverse;";

    case "column-reverse":
      return "flex-direction:column-reverse;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "sc-82xs04-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " ", " gap:", ";flex:", ";flex-shrink:", ";margin:", ";padding:", ";border-bottom:", ";border-top:", ";background:", ";border-radius:", ";height:", ";width:", ";box-shadow:", ";pointer-events:auto;flex-wrap:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.alignSelf && "\n    ".concat(renderAlignSelf(p.alignSelf), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (p) {
  return p.gap ? p.gap : "0";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "unset";
}, function (p) {
  return p.margin ? p.margin : "unset";
}, function (p) {
  return p.padding ? p.padding : "0";
}, function (p) {
  return p.borderBottom ? p.borderBottom : "none";
}, function (p) {
  return p.borderTop ? p.borderTop : "none";
}, function (p) {
  return p.bgColor ? p.bgColor : "transparent";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0";
}, function (p) {
  return p.height ? p.height : "unset";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.boxShadow ? p.boxShadow : "none";
}, function (p) {
  return p.flexWrap ? p.flexWrap : "";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FlexComp/FlexComp.tsx




var FlexComp_FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      flexWrap = _ref.flexWrap,
      alignSelf = _ref.alignSelf;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    gap: gap,
    margin: margin,
    borderBottom: borderBottom,
    borderTop: borderTop,
    padding: padding,
    flex: flex,
    bgColor: bgColor,
    borderRadius: borderRadius,
    height: height,
    flexShrink: flexShrink,
    width: width,
    boxShadow: boxShadow,
    onClick: handleClick,
    flexWrap: flexWrap,
    alignSelf: alignSelf,
    "data-test-id": "FlexComp-FlexCompStyle",
    children: children
  });
};

/* harmony default export */ var components_FlexComp_FlexComp = (FlexComp_FlexComp);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FormattedText/FormattedText.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* Every text node can be of either of the three formats - 
1. string - "Hello"
2. text obj with value and styles - 
   text: {
    value: "Travel Assistance",
    styles: {
      color: "#000000",
      fontFamily: "fontSansBold",
    },
  }
3. Array of text objs with value and styles - 
   text: [
    {
      value: "Travel Assistance",
      styles: {
        color: "#000000",
        fontFamily: "fontSansBold",
      },
    },
  ]
*/




var ListItemText = function ListItemText(_ref) {
  var text = _ref.text,
      style = _ref.style;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    style: {
      flexDirection: "row"
    },
    "data-test-id": "ListItemText",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: style,
      children: "\u2022 "
    }), text && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: style,
      children: text
    })]
  });
};

var getPlainText = function getPlainText(data) {
  if (!data) {
    return "";
  } else if (typeof data === "string") {
    return data;
  } else if (data !== null && data !== void 0 && data.text) {
    var text = data.text;

    if (Array.isArray(text)) {
      return text.map(function (node) {
        return node.value;
      }).join("");
    } else if (typeof text === "object") {
      return (text === null || text === void 0 ? void 0 : text.value) || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

var FormattedText_FormattedText = function FormattedText(_ref2) {
  var value = _ref2.value,
      baseStyle = _ref2.baseStyle;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var isList = false;

  if (!value) {
    return null;
  }

  var returnValue = null;

  if (typeof value === "string") {
    returnValue = value;
  } else if (value !== null && value !== void 0 && value.text) {
    var _ref3 = value,
        text = _ref3.text,
        displayType = _ref3.displayType;

    if (displayType === "UNORDERED_LIST") {
      isList = true;
    }

    if (Array.isArray(text)) {
      returnValue = text.map(function (node, index) {
        var _node$styles;

        var mobileStyle = (_node$styles = node.styles) === null || _node$styles === void 0 ? void 0 : _node$styles.mobile;

        var combinedStyles = _objectSpread(_objectSpread({}, node === null || node === void 0 ? void 0 : node.styles), device === "sm" && _objectSpread({}, mobileStyle));

        var textValue = node === null || node === void 0 ? void 0 : node.value;
        return node.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: isList ? /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemText, {
            text: textValue ? textValue : "",
            style: node === null || node === void 0 ? void 0 : node.styles,
            "data-test-id": "FormattedText-ListItemText"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: combinedStyles,
            children: node.value
          }, index)
        }, index) : null;
      });
    } else if (typeof text === "object") {
      var _text$styles;

      var mobileStyle = text === null || text === void 0 ? void 0 : (_text$styles = text.styles) === null || _text$styles === void 0 ? void 0 : _text$styles.mobile;

      var combinedStyles = _objectSpread(_objectSpread({}, text === null || text === void 0 ? void 0 : text.styles), device === "sm" && _objectSpread({}, mobileStyle));

      returnValue = text !== null && text !== void 0 && text.value ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: combinedStyles,
        "data-test-id": "FormattedText",
        children: text.value
      }) : null;
    } else {
      returnValue = text;
    }
  }

  return value !== null && value !== void 0 && value.html ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    dangerouslySetInnerHTML: {
      __html: value.html
    },
    style: baseStyle !== null && baseStyle !== void 0 ? baseStyle : {}
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    style: baseStyle !== null && baseStyle !== void 0 ? baseStyle : {},
    children: returnValue
  });
};

/* harmony default export */ var components_FormattedText_FormattedText = (FormattedText_FormattedText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageComponent/ImageComponent.tsx



var ImageComponent_ImageComponent = function ImageComponent(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$cdnUrlWidths = _ref.cdnUrlWidths,
      cdnUrlWidths = _ref$cdnUrlWidths === void 0 ? [] : _ref$cdnUrlWidths,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? "" : _ref$sizes,
      margin = _ref.margin;
  var imgStyle = margin ? {
    margin: margin
  } : {};

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith && src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      style: imgStyle,
      className: className,
      id: id,
      width: width,
      height: height,
      "data-test-id": "ImageComponent"
    });
  }

  var srcsetUrl = (0,utils/* generateSourceSetImageUrl */.sI)(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    "data-test-id": "ImageComponent-picture",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "ImageComponent-source"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      style: imgStyle
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageTag/ImageTag.style.ts

var ImageTagStyle = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-1k1vovp-0"
})(["display:inline-block;margin:", ";width:", ";", " flex-shrink:0;"], function (props) {
  return props.margin;
}, function (props) {
  return props.width;
}, function (props) {
  return props.showCursorPointer && " cursor: pointer;";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageTag/ImageTag.tsx



var ImageTag = function ImageTag(_ref) {
  var src = _ref.src,
      width = _ref.width,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "image-tag" : _ref$alt,
      margin = _ref.margin,
      height = _ref.height,
      _ref$showCursorPointe = _ref.showCursorPointer,
      showCursorPointer = _ref$showCursorPointe === void 0 ? false : _ref$showCursorPointe;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTagStyle, {
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    "data-test-id": "ImageTag-ImageTagStyle"
  });
};

/* harmony default export */ var ImageTag_ImageTag = (ImageTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButton.tsx








var LandingButton = function LandingButton(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon,
      isLoading = _ref.isLoading,
      buttonref = _ref.buttonref;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButtonStyle, {
    ref: buttonref,
    onClick: onClick,
    customWidth: customWidth,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    btnTheme: context ? context : undefined,
    txtClipIcon: btnLeftIcon !== "" && btnRightIcon !== "",
    "data-test-id": "LandingButton-LandingButtonStyle",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner_Spinner, {
      spinnerColor: "#fff",
      "data-test-id": "LandingButton-Spinner"
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: btnLeftIcon,
        "data-test-id": "LandingButton-ImageComponent"
      }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.blueText */.rS.blueText,
        fontSize: "md",
        fontWeight: "black",
        "data-test-id": "LandingButton-SpanTag",
        children: customTitle
      }), shimmerBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerWrap, {
        "data-test-id": "LandingButton-ShimmerWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "../../../images/shimmerBtn.svg"
        })
      }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        margin: "0 0 0 auto",
        src: btnRightIcon,
        "data-test-id": "LandingButton-ImageComponent"
      })]
    })
  });
};

/* harmony default export */ var LandingButton_LandingButton = (LandingButton);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButtonTertiary.tsx






var LandingButtonTertiary = function LandingButtonTertiary(_ref) {
  var title = _ref.title,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/_jsxs(LandingButtonTertiaryStyle, {
    onClick: onClick,
    disableState: disableState,
    "data-test-id": "LandingButtonTertiary-LandingButtonTertiaryStyle",
    children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    }), title && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.blueText,
      fontSize: "xs",
      fontWeight: "bold",
      "data-test-id": "LandingButtonTertiary-SpanTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title,
        "data-test-id": "LandingButtonTertiary-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonTertiary = ((/* unused pure expression or super */ null && (LandingButtonTertiary)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButtonWhite.tsx






var LandingButtonWhite_LandingButtonWhite = function LandingButtonWhite(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      customHeight = _ref.customHeight,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      flex = _ref.flex,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/_jsxs(LandingButtonWhiteStyle, {
    onClick: onClick,
    customWidth: customWidth,
    customHeight: customHeight,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    "data-test-id": "LandingButtonWhite-LandingButtonWhiteStyle",
    children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    }), customTitle && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.blueText,
      fontSize: "md",
      fontWeight: "bold",
      "data-test-id": "LandingButtonWhite-SpanTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: customTitle,
        "data-test-id": "LandingButtonWhite-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonWhite = ((/* unused pure expression or super */ null && (LandingButtonWhite_LandingButtonWhite)));
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 121 modules
var react_markdown = __webpack_require__(8078);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarkdownText/MarkdownText.tsx




var MarkdownText = function MarkdownText(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
    components: {
      p: "span"
    },
    "data-test-id": "MarkdownText-ReactMarkdown",
    children: value
  });
};

/* harmony default export */ var MarkdownText_MarkdownText = (MarkdownText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RadioButton/RadioButton.style.ts

var RadioButtonStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "g4c4b9-0"
})(["", " display:flex;", " label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;color:#666;width:100%;", "}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:0px;width:15px;height:15px;border:1px solid #008cff;border-radius:100%;background:#fff;", "}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:#008cff;position:absolute;top:3px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], function (p) {
  return p.isPadding && "\n    padding: 16px 10px;\n";
}, function (p) {
  return p.showLabel && "\n        width: 100%;\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RadioButton/RadioButton.tsx





var RadioButton = function RadioButton(_ref) {
  var children = _ref.children,
      activeBtn = _ref.activeBtn,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      inputId = _ref.inputId,
      isPadding = _ref.isPadding,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;

  var handleRadioChange = function handleRadioChange() {
    if (handleChange && inputIndex !== undefined) {
      handleChange(inputIndex);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RadioButtonStyle, {
    isPadding: isPadding,
    onChange: handleRadioChange,
    showLabel: showLabel,
    "data-test-id": "RadioButton-RadioButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "radio",
      onChange: handleRadioChange,
      checked: activeBtn,
      id: inputId,
      name: "radio-group"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      "data-test-id": "RadioButton-label",
      children: children
    })]
  });
};

/* harmony default export */ var RadioButton_RadioButton = (RadioButton);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/utils/index.js

// Holidays array
var holidays = [{
  date: "2023-03-08",
  name: "Holi"
}, {
  date: "2023-03-30",
  name: "Ram Navami"
}, {
  date: "2023-04-04",
  name: "Mahavir Jayanti"
}, {
  date: "2023-04-07",
  name: "Good Friday"
}, {
  date: "2023-04-22",
  name: "Eid-ul-fitr"
}, {
  date: "2023-05-01",
  name: "Labor Day"
}, {
  date: "2023-05-05",
  name: "Budhha Purnima"
}, {
  date: "2023-07-29",
  name: "Muharram"
}, {
  date: "2023-08-15",
  name: "Independence Day"
}, {
  date: "2023-08-29",
  name: "Onam"
}, {
  date: "2023-08-30",
  name: "Raksha Bandhan"
}, {
  date: "2023-09-07",
  name: "Ganesh Chaturthi"
}, {
  date: "2023-10-02",
  name: "Gandhi Jayanti"
}, {
  date: "2023-10-24",
  name: "Dussehra"
}, {
  date: "2023-10-28",
  name: "Valmiki Jayanti"
}, {
  date: "2023-11-12",
  name: "Diwali"
}, {
  date: "2023-11-27",
  name: "Guru Nanak Jayanti"
}, {
  date: "2023-12-25",
  name: "Christmas"
}, {
  date: "2024-01-01",
  name: "New Year's Day"
}]; // Get all days in a month

function getDaysInMonth(year, month, showHolidays) {
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var days = [];
  var holidaysCount = 0;

  for (var i = 1; i <= daysInMonth; i++) {
    /* istanbul ignore next */
    if (showHolidays) {
      (function () {
        var dateTimestamp = Date.UTC(year, month, i);
        var isHoliday = false;
        var holidayName = "";
        holidays.forEach(function (holiday) {
          var holidayDate = new Date(holiday.date);
          var holidayTimestamp = Date.UTC(holidayDate.getFullYear(), holidayDate.getMonth(), holidayDate.getDate());

          if (dateTimestamp === holidayTimestamp) {
            isHoliday = true;
            holidayName = holiday.name;
            holidaysCount++;
          }
        });
        days.push({
          date: new Date(year, month, i),
          isHoliday: isHoliday,
          holidayName: holidayName
        });
      })();
    } else {
      days.push({
        date: new Date(year, month, i)
      });
    }
  }

  return {
    days: days,
    holidaysCount: holidaysCount
  };
} // Get all calendar data

function getCalendarData(startDate, endDate, showHolidays) {
  var currentDate = startDate ? new Date(startDate) : new Date();
  var lastDate = endDate ? new Date(endDate) : new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
  var monthData = [];

  while (currentDate <= lastDate) {
    var year = currentDate.getFullYear();
    var month = currentDate.getMonth();
    var firstDay = new Date(year, month, 1).getDay();
    var lastDay = new Date(year, month + 1, 0).getDate();
    var daysInMonth = getDaysInMonth(year, month, showHolidays);
    monthData.push({
      month: month,
      year: year,
      daysInMonth: daysInMonth,
      firstDayOfWeek: firstDay
    });
    currentDate.setMonth(month + 1);
    currentDate.setDate(1);
  }

  return monthData;
} // Generate empty cell before start date

function emptyCellBefore(data, daysInMonth) {
  var daysBefore = new Array(data).fill(null).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "empty",
      "data-test-id": "daysBefore"
    }, "empty-".concat(i));
  });
  return daysBefore;
} // Generate empty cell after end date

function emptyCellAfter(data, daysInMonth) {
  var emptyDaysAfter = new Array(7 - (emptyCellBefore().length + daysInMonth.days.length) % 7).fill(null).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "empty",
      "data-test-id": "emptyDaysAfter"
    }, "empty-after-".concat(i));
  });
  return emptyDaysAfter;
}
var formatDate = function formatDate(dateString) {
  var date = new Date(dateString);
  var day = date.getDate();
  var month = date.getMonth() + 1; // Month starts from 0, so we add 1 to get the correct month.

  var year = date.getFullYear() % 100; // Get the last two digits of the year.

  return "".concat(day, "/").concat(month, "/").concat(year);
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.style.ts

var CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderWrap",
  componentId: "sc-1ts3bpj-0"
})(["flex:1;overflow-y:auto;padding-bottom:10px;"]);
var CalenderMonthName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderMonthName",
  componentId: "sc-1ts3bpj-1"
})(["background-color:#fff;padding:20px 16px;font-size:16px;font-weight:700;color:#4a4a4a;display:flex;align-items:center;"]);
var CalenderDays = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDays",
  componentId: "sc-1ts3bpj-2"
})(["display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid #e7e7e7;background-color:#f2f2f2;"]);
var CalenderDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDate",
  componentId: "sc-1ts3bpj-3"
})(["border-left:1px solid #e7e7e7;border-top:1px solid #e7e7e7;padding:20px 5px;display:flex;align-items:center;justify-content:center;background-color:#fff;position:relative;", " ", " ", ""], function (p) {
  return p.isSelected && " background-color: #008cff;";
}, function (p) {
  return p.isWithinRange && "background-color: #f0f8ff;";
}, function (p) {
  return p.isDisabled && " pointer-events: none;";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.tsx









var Calendar = function Calendar(_ref) {
  var handleDayClick = _ref.handleDayClick,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      monthNameType = _ref.monthNameType,
      yearType = _ref.yearType,
      selected = _ref.selected,
      _ref$numberOfMonth = _ref.numberOfMonth,
      numberOfMonth = _ref$numberOfMonth === void 0 ? 13 : _ref$numberOfMonth,
      maxEndDate = _ref.maxEndDate;
  // const [sDate, setSDate] = useState(startDate);
  // const [eDate, setEDate] = useState(endDate);
  var monthRefs = (0,react.useRef)([]);
  var calendarData = getCalendarData(new Date(), maxEndDate);
  (0,react.useEffect)(function () {
    if (selected !== null && selected !== void 0 && selected.from) {
      var _monthRefs$current$re;

      var selectedMonth = selected.from.getMonth();
      var selectedYear = selected.from.getFullYear();
      var refIndex = calendarData === null || calendarData === void 0 ? void 0 : calendarData.findIndex(function (_ref2) {
        var month = _ref2.month,
            year = _ref2.year;
        return month === selectedMonth && year === selectedYear;
      });
      refIndex && ((_monthRefs$current$re = monthRefs.current[refIndex]) === null || _monthRefs$current$re === void 0 ? void 0 : _monthRefs$current$re.scrollIntoView({
        behavior: "auto",
        block: "start"
      }));
    }
  }, [selected, calendarData]);

  var disabledDays = function disabledDays(date) {
    return isBefore((0,startOfDay/* default */.Z)(date), (0,startOfDay/* default */.Z)(new Date())) || !!(maxEndDate && isAfter(date, maxEndDate));
  };

  var isBefore = function isBefore(date1, date2) {
    return date1 < date2;
  };

  var isAfter = function isAfter(date1, date2) {
    return date1 > date2;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderWrap, {
    "data-test-id": "Calendar-CalenderWrap",
    children: calendarData === null || calendarData === void 0 ? void 0 : calendarData.map(function (_ref3, index) {
      var month = _ref3.month,
          year = _ref3.year,
          daysInMonth = _ref3.daysInMonth,
          firstDayOfWeek = _ref3.firstDayOfWeek;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: function ref(_ref4) {
          return monthRefs.current[index] = _ref4;
        },
        "data-test-id": "Calendar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderMonthName, {
          "data-test-id": "Calendar-CalenderMonthName",
          children: [new Date(year, month).toLocaleString("en-us", {
            month: monthNameType
          }), " ", "\xA0", new Date(year, month).toLocaleString("en-us", {
            year: yearType
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderDays, {
          "data-test-id": "Calendar-CalenderDays",
          children: [emptyCellBefore(firstDayOfWeek, daysInMonth), daysInMonth.days.map(function (day) {
            var d = new Date();
            var curDate = d.getDate();
            var curMonth = d.getMonth();
            var curYear = d.getFullYear();
            var isSelected = day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.from) && (selected === null || selected === void 0 ? void 0 : selected.from.getTime())) || day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.to) && (selected === null || selected === void 0 ? void 0 : selected.to.getTime()));
            var isWithinRange = selected && day.date > selected.from && day.date < selected.to;
            var isDisabled = disabledDays(day.date);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderDate, {
              isSelected: isSelected,
              isWithinRange: isWithinRange,
              isDisabled: isDisabled,
              onClick: handleDayClick ? function () {
                return handleDayClick(day.date);
              } : function () {},
              "data-test-id": "Calendar-CalenderDate",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                color: isSelected ? Global/* theme.whiteText */.rS.whiteText : isDisabled ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
                "data-test-id": "Calendar-SpanTag",
                children: day.date.getDate()
              })
            }, "".concat(day));
          }), emptyCellAfter(firstDayOfWeek, daysInMonth)]
        })]
      }, "".concat(index));
    })
  });
};

/* harmony default export */ var Calendar_Calendar = (Calendar);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.style.ts

var CalenderFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFooterWrap",
  componentId: "sc-16h4vsx-0"
})(["background-color:#fff;padding:16px;box-shadow:0 0 6px rgba(0,0,0,0.2);position:relative;"]);
var CalenderFootRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFootRange",
  componentId: "sc-16h4vsx-1"
})(["display:flex;align-items:center;gap:8px;margin-bottom:16px;"]);
var CalFootRangeCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalFootRangeCol",
  componentId: "sc-16h4vsx-2"
})(["flex:1;background-color:#f7f7f7;border:1px solid #e7e7e7;border-radius:2px;padding:8px 10px;height:54px;position:relative;", " &:last-child{padding:8px 10px 8px 16px;}"], function (p) {
  return p.selected && "\n        border: 1px solid #008CFF;\n        background: #F9FCFF;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.tsx








var CalendarFooter = function CalendarFooter(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onSubmitButtonPress = _ref.onSubmitButtonPress;

  var _useState = (0,react.useState)(0),
      selected = _useState[0],
      setSelected = _useState[1];

  (0,react.useEffect)(function () {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFooterWrap, {
    "data-test-id": "CalendarFooter-CalenderFooterWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFootRange, {
      "data-test-id": "CalendarFooter-CalenderFootRange",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 0,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "start date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkinDate ? formatDate(checkinDate) : "-"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 1,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "end date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkoutDate ? formatDate(checkoutDate) : "-"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customWidth: "100%",
      onClick: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(checkinDate, checkoutDate);
      } : function () {},
      customTitle: "Confirm",
      disableState: !checkinDate || !checkoutDate,
      "data-test-id": "CalendarFooter-LandingButton"
    })]
  });
};

/* harmony default export */ var CalendarFooter_CalendarFooter = (CalendarFooter);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.style.ts

var CalenderHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarHeaderstyle__CalenderHeaderWrap",
  componentId: "w3gpol-0"
})(["background-color:#fff;padding:12px 16px;position:sticky;display:flex;align-items:center;top:0;z-index:6;"]);
var CalHeaderBackBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "CalendarHeaderstyle__CalHeaderBackBtn",
  componentId: "w3gpol-1"
})(["width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:transparent;outline:0;border:0;position:relative;flex-shrink:0;margin-right:15px;&:after{content:\"\";border:solid #000;border-width:0 2px 2px 0;padding:5px;transform:rotate(135deg);position:absolute;left:2;}&:before{width:16px;height:2px;background-color:#000;content:\"\";flex-shrink:0;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.tsx






var CalendarHeader = function CalendarHeader(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onBackPress = _ref.onBackPress;

  var _useState = (0,react.useState)("Select Travel Dates"),
      text = _useState[0],
      setText = _useState[1];

  (0,react.useEffect)(function () {
    checkinDate && setText("Select Travel Dates");
    checkinDate && checkoutDate && setText("Select Travel Dates");
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderHeaderWrap, {
    "data-test-id": "CalendarHeader-CalenderHeaderWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CalHeaderBackBtn, {
      onClick: onBackPress,
      "data-test-id": "CalendarHeader-CalHeaderBackBtn"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontWeight: "bold",
      fontSize: "md",
      "data-test-id": "CalendarHeader-SpanTag",
      children: text
    })]
  });
};

/* harmony default export */ var CalendarHeader_CalendarHeader = (CalendarHeader);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.style.ts

var WeekDayWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WeekDaysstyle__WeekDayWrap",
  componentId: "sc-5sctr8-0"
})(["background-color:#fff;padding:2px 0;position:sticky;top:49px;z-index:1;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:grid;grid-template-columns:repeat(7,1fr);span{font-size:12px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.tsx

 // import './WeekDays.css';




var WeekDays = function WeekDays(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WeekDayWrap, {
    style: {
      top: top
    },
    "data-test-id": "WeekDays-WeekDayWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sun"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Mon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Tue"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Wed"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Thu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Fri"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sat"
    })]
  });
};

/* harmony default export */ var WeekDays_WeekDays = (WeekDays);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/styles/styles.style.ts

var calenderAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RangeDatePickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__RangeDatePickerStyle",
  componentId: "f6qkoe-0"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;"], calenderAnim);
var styles_style_ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__ErrorToast",
  componentId: "f6qkoe-1"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx











// import './styles/styles.css';
var RangeDatePicker = function RangeDatePicker(_ref) {
  var calendarHeader = _ref.calendarHeader,
      _ref$calendarWeekdays = _ref.calendarWeekdays,
      calendarWeekdays = _ref$calendarWeekdays === void 0 ? true : _ref$calendarWeekdays,
      _ref$monthNameType = _ref.monthNameType,
      monthNameType = _ref$monthNameType === void 0 ? "short" : _ref$monthNameType,
      _ref$yearType = _ref.yearType,
      yearType = _ref$yearType === void 0 ? "numeric" : _ref$yearType,
      calendarFooter = _ref.calendarFooter,
      onBackPress = _ref.onBackPress,
      onSubmitButtonPress = _ref.onSubmitButtonPress,
      range = _ref.range,
      from = _ref.from,
      to = _ref.to,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected,
      maxEndDate = _ref.maxEndDate;

  var _useState = (0,react.useState)(from),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var _useState2 = (0,react.useState)(to),
      endDate = _useState2[0],
      setEndDate = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RangeDatePickerStyle, {
    className: "cal__container",
    "data-test-id": "RangeDatePicker-RangeDatePickerStyle",
    children: [calendarHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarHeader_CalendarHeader, {
      checkinDate: startDate,
      checkoutDate: endDate,
      onBackPress: onBackPress,
      "data-test-id": "RangeDatePicker-CalendarHeader"
    }), calendarWeekdays && /*#__PURE__*/(0,jsx_runtime.jsx)(WeekDays_WeekDays, {
      top: calendarHeader ? 49 : 0,
      "data-test-id": "RangeDatePicker-WeekDays"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_Calendar, {
      handleDayClick: handleDayClick,
      startDate: startDate,
      endDate: endDate,
      monthNameType: monthNameType,
      yearType: yearType,
      selected: selected,
      maxEndDate: maxEndDate,
      "data-test-id": "RangeDatePicker-Calendar"
    }), calendarFooter && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarFooter_CalendarFooter, {
      checkinDate: selected === null || selected === void 0 ? void 0 : selected.from,
      checkoutDate: selected === null || selected === void 0 ? void 0 : selected.to,
      onSubmitButtonPress: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(selected === null || selected === void 0 ? void 0 : selected.from, selected === null || selected === void 0 ? void 0 : selected.to);
      } : function () {},
      "data-test-id": "RangeDatePicker-CalendarFooter"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(styles_style_ErrorToast, {
      "data-test-id": "RangeDatePicker-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "RangeDatePicker-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
          value: toastMessage,
          "data-test-id": "RangeDatePicker-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var RangeDatePicker_RangeDatePicker = (RangeDatePicker);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ReactPortalComp/ReactPortalComp.tsx




var ReactPortalComp = function ReactPortalComp(props) {
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  (0,react.useEffect)(function () {
    ref.current = document.querySelector("#portal");
    setMounted(true);
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return mounted && ref.current ? /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "ReactPortalComp",
    children: props.children
  }), ref.current) : null;
};

/* harmony default export */ var ReactPortalComp_ReactPortalComp = (ReactPortalComp);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RichText/RichText.tsx




var RichText = function RichText(_ref) {
  var value = _ref.value;

  if (typeof value === "string") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(MarkdownText_MarkdownText, {
      value: value,
      "data-test-id": "RichText-MarkdownText"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
    value: value,
    "data-test-id": "RichText-FormattedText"
  });
};

/* harmony default export */ var RichText_RichText = (RichText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.tsx



var SectionDividers = function SectionDividers(_ref) {
  var small = _ref.small,
      large = _ref.large,
      xs = _ref.xs,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      margin = _ref.margin,
      backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividersStyle, {
    backgroundColor: backgroundColor,
    small: small,
    large: large,
    xs: xs,
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin,
    "data-test-id": "SectionDividers-SectionDividersStyle"
  });
};

/* harmony default export */ var SectionDividers_SectionDividers = (SectionDividers);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.style.ts

var shimmer = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
var ShimmerComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "bk32cl-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#2F2F2F  8%,#393939 18%,#2F2F2F   33%);background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;align-items:flex-end;}"], shimmer, function (p) {
  return p.width ? p.width : "100%";
}, function (p) {
  return p.height ? p.height : "14px";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.padding ? p.padding : "";
});
var ShimmerVersion2Style = (0,styled_components_browser_esm/* default */.ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion2Style",
  componentId: "bk32cl-1"
})(["background:linear-gradient(to right,#f6f6f6 8%,#f9fafb 18%,#f6f6f6 33%);background-size:800px 104px;"]);
var ShimmerVersion3Style = (0,styled_components_browser_esm/* default */.ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion3Style",
  componentId: "bk32cl-2"
})(["background:linear-gradient(to right,#cbcbcb 8%,#f9fafb 18%,#cbcbcb 33%);background-size:800px 104px;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.tsx



function Shimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      padding = _ref.padding,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ShimmerComp, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerComp",
    children: [" ", children]
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/ShimmerVersion2.tsx



function ShimmerVersion2(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion2Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/ShimmerVersion3.tsx



function ShimmerVersion3(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion3Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion3Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Spinner/Spinner.styles.ts

var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerCont = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-18udvui-0"
})(["display:inline-block;height:22px;width:22px;animation:", " 1s linear infinite;border-right-color:transparent;border-radius:50%;margin:-2px auto;"], rotate);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Spinner/Spinner.tsx


function Spinner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Spinner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Spinner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Spinner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Spinner = function Spinner(_ref) {
  var _ref$spinnerWidth = _ref.spinnerWidth,
      spinnerWidth = _ref$spinnerWidth === void 0 ? 22 : _ref$spinnerWidth,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === void 0 ? "#0189d2" : _ref$spinnerColor,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
      customStyle = _ref.customStyle;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerCont, {
    style: Spinner_objectSpread({
      width: spinnerWidth,
      height: spinnerWidth,
      border: "".concat(thickness, "px solid ").concat(spinnerColor),
      borderRightColor: "transparent"
    }, customStyle),
    "data-test-id": "Spinner-SpinnerCont"
  });
};

/* harmony default export */ var Spinner_Spinner = (Spinner);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Tags/Tags.style.ts


var TagsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagsStyle",
  componentId: "sc-7t089-0"
})(["display:flex;overflow-x:scroll;gap:8px;flex-shrink:0;&::-webkit-scrollbar{display:none;}"]);
var TagItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagItem",
  componentId: "sc-7t089-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:0px 10px;cursor:pointer;flex-shrink:0;position:relative;display:flex;align-items:center;justify-content:center;height:33px;", " ", "{position:absolute;top:-5px;left:5px;}"], function (p) {
  return p.isSelected && "\nbackground: #F8FBFF;\nborder: 1px solid #008CFF;\nborder-radius: 6px;\n";
}, ImageTagStyle);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Tags/Tags.tsx







var Tags = function Tags(_ref) {
  var data = _ref.data,
      handleClickTab = _ref.handleClickTab;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TagsStyle, {
    "data-test-id": "Tags-TagsStyle",
    children: data === null || data === void 0 ? void 0 : data.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TagItem, {
          isSelected: item.isSelected,
          onClick: handleClickTab ? function () {
            return handleClickTab(item.id);
          } : function () {},
          "data-test-id": "Tags-TagItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: item.isSelected ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            fontSize: "xs",
            fontWeight: "black",
            "data-test-id": "Tags-SpanTag",
            children: item.name
          }), item.tagImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
            src: item.tagImg,
            width: "30px",
            height: "14px",
            "data-test-id": "Tags-ImageTag"
          })]
        }, item.id)
      });
    })
  });
};

/* harmony default export */ var Tags_Tags = (Tags);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/AnchorTag.tsx





var AnchorTag = function AnchorTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      color = _ref.color,
      handleClick = _ref.handleClick,
      hrefProp = _ref.hrefProp,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave,
      textTransform = _ref.textTransform,
      anchorTitle = _ref.anchorTitle,
      targetProp = _ref.targetProp,
      _ref$download = _ref.download,
      download = _ref$download === void 0 ? false : _ref$download,
      disableState = _ref.disableState;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTagStyle, {
    context: context ? context : undefined,
    textAlign: textAlign,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    textTransform: textTransform,
    title: anchorTitle,
    target: targetProp,
    download: download,
    disableState: disableState,
    "data-test-id": "AnchorTag-AnchorTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_AnchorTag = (AnchorTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H2Tag.tsx





var H2Tag = function H2Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H2TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H2Tag-H2TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H2Tag = (H2Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H3SmallTag.tsx





var H3SmallTag = function H3SmallTag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H3TagSmallStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3SmallTag-H3TagSmallStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H3SmallTag = (H3SmallTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H3Tag.tsx





var H3Tag = function H3Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H3TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3Tag-H3TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H3Tag = (H3Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H4Tag.tsx





var H4Tag = function H4Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H4TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H4Tag-H4TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H4Tag = (H4Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H5Tag.tsx





var H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H5TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H5Tag-H5TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H5Tag = (H5Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H6Tag.tsx





var H6Tag = function H6Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = usePartnerContext();
  return /*#__PURE__*/_jsx(H6TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H6Tag-H6TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H6Tag = ((/* unused pure expression or super */ null && (H6Tag)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/ParaTag.tsx





var ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      textTransform = _ref.textTransform;
  var context = (0,hooks/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_ParaTag = (ParaTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/SpanTag.tsx





var SpanTag_SpanTag = function SpanTag(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "black" : _ref$color,
      margin = _ref.margin,
      children = _ref.children,
      textTransform = _ref.textTransform,
      dangerousText = _ref.dangerousText,
      style = _ref.style;

  if (dangerousText && typeof dangerousText !== "string") {
    dangerousText = String(dangerousText);
  }

  var context = (0,hooks/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    style: style,
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_SpanTag = (SpanTag_SpanTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TMFloatingInput/TMFloatingInput.tsx








var TMFloatingInput = function TMFloatingInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      verifiedTag = _ref.verifiedTag,
      maxLength = _ref.maxLength,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      inputMode = _ref.inputMode,
      flex = _ref.flex,
      _ref$fieldType = _ref.fieldType,
      fieldType = _ref$fieldType === void 0 ? "text" : _ref$fieldType,
      _ref$showEdit = _ref.showEdit,
      showEdit = _ref$showEdit === void 0 ? false : _ref$showEdit,
      handleEditClick = _ref.handleEditClick,
      handleDropdownPress = _ref.handleDropdownPress;

  var _useState = (0,react.useState)(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var inputFocusHandler = function inputFocusHandler(event) {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }

    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  var inputBlurHandler = function inputBlurHandler() {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  var handleClick = function handleClick() {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TMInputWrap, {
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    flex: flex,
    placeholder: placeholderTxt,
    clickable: fieldType === "select",
    onClick: handleClick,
    "data-test-id": "TMFloatingInput-TMInputWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputWpr, {
      "data-test-id": "TMFloatingInput-InputWpr",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TMInputStyle, {
        id: labelTxt,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: fieldType === "select" ? function () {} : handleChange,
        value: inputValue,
        errorState: errorState,
        onBlur: inputBlurHandler,
        verifiedTag: verifiedTag,
        disableState: disableState,
        onFocus: inputFocusHandler,
        placeholder: placeholderTxt,
        spellCheck: "false",
        maxLength: maxLength,
        type: type,
        required: true,
        clickable: fieldType === "select",
        "data-test-id": "TMFloatingInput-TMInputStyle"
      }), labelTxt && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: fieldType === "select" ? "" : labelTxt,
        className: "labelText",
        "data-test-id": "TMFloatingInput-label",
        children: labelTxt
      }), fieldType === "text" && verifiedTag && /*#__PURE__*/(0,jsx_runtime.jsx)(VerifiedContainer, {
        "data-test-id": "TMFloatingInput-VerifiedContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: Global/* theme.darkGreen */.rS.darkGreen,
          "data-test-id": "TMFloatingInput-ParaTag",
          children: verifiedTag
        })
      }), fieldType === "text" && showEdit && /*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
        onClick: handleEditClick,
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* EditIcon */.dY, {
          "data-test-id": "TMFloatingInput-EditIcon"
        })
      }), fieldType === "select" && /*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* DownArrow */.pL, {
          "data-test-id": "TMFloatingInput-DownArrow"
        })
      })]
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      margin: "4px 0 0",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      dangerousText: errorState,
      "data-test-id": "TMFloatingInput-ParaTag"
    })]
  });
};

/* harmony default export */ var TMFloatingInput_TMFloatingInput = (TMFloatingInput);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/Toast.tsx







var Toast = function Toast(_ref) {
  var toastCtaTxt = _ref.toastCtaTxt,
      planSelectedTxt = _ref.planSelectedTxt,
      handleClickCta = _ref.handleClickCta,
      handleClose = _ref.handleClose,
      _ref$autoCloseDuratio = _ref.autoCloseDuration,
      autoCloseDuration = _ref$autoCloseDuratio === void 0 ? 3000 : _ref$autoCloseDuratio,
      toastCloseIcon = _ref.toastCloseIcon,
      toastIcon = _ref.toastIcon,
      isDisable = _ref.isDisable,
      showToast = _ref.showToast,
      width = _ref.width,
      height = _ref.height;

  var _useState = useState(true),
      visible = _useState[0],
      setVisible = _useState[1];

  useEffect(function () {
    var timer;

    if (autoCloseDuration) {
      timer = setTimeout(function () {
        if (visible) {
          setVisible(false);
        }
      }, autoCloseDuration);
    }

    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseDuration, visible]);
  return visible ? /*#__PURE__*/_jsxs(ToastStyle, {
    "data-test-id": "Toast-ToastStyle",
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "16px",
      alignItems: "center",
      "data-test-id": "Toast-FlexComp",
      children: [toastIcon && /*#__PURE__*/_jsx(ToastIcon, {
        "data-test-id": "Toast-ToastIcon",
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "Toast-ImageComponent"
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "md",
        color: theme.whiteText,
        "data-test-id": "Toast-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/_jsx(FormattedText, {
          value: planSelectedTxt,
          "data-test-id": "Toast-FormattedText"
        })
      })]
    }), toastCtaTxt && /*#__PURE__*/_jsx(LandingButtonWhite, {
      customTitle: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "Toast-LandingButtonWhite"
    }), toastCloseIcon && /*#__PURE__*/_jsx(CloseIconWrap, {
      onClick: handleClose,
      "data-test-id": "Toast-CloseIconWrap",
      children: /*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "Toast-ImageComponent"
      })
    })]
  }) : null;
};

/* harmony default export */ var Toast_Toast = ((/* unused pure expression or super */ null && (Toast)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/WebToast.style.tsx



var WebToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WebToaststyle__WebToastStyle",
  componentId: "qqkgrl-0"
})(["position:", ";top:", ";left:", ";width:", ";height:", ";background:", ";display:flex;align-items:", ";z-index:200;justify-content:", ";box-shadow:0px 3px 30px rgba(0,0,0,0.16);", " padding:12px 16px 12px 16px;border-radius:6px;bottom:", ";right:", ";picture{height:19px;width:19px;padding:2px;}", "{flex-shrink:0;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], function (p) {
  return p.position ? "".concat(p.position) : "absolute";
}, function (p) {
  return "".concat(p.top);
}, function (p) {
  return "".concat(p.left);
}, function (p) {
  return "".concat(p.width);
}, function (p) {
  return "".concat(p.height);
}, function (p) {
  return p.background ? "".concat(p.background) : "#4a4a4a";
}, function (p) {
  return p.alignItems ? "".concat(p.alignItems) : "center";
}, function (p) {
  return p.justifyContent ? "".concat(p.justifyContent) : "space-between";
}, function (p) {
  return p.margin && "margin: ".concat(p.margin, ";");
}, function (p) {
  return "".concat(p.bottom);
}, function (p) {
  return "".concat(p.right);
}, SpanTagStyle, src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/WebToast.tsx






var TOAST_BG_COLOR = {
  error: "#FCDADB",
  success: "#B8F5E0",
  default: "#4A4A4A",
  warning: "#FFEDD1"
};

var WebToast = function WebToast(_ref) {
  var iconUrl = _ref.iconUrl,
      position = _ref.position,
      toastTxt = _ref.toastTxt,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      toastTxtMargin = _ref.toastTxtMargin,
      top = _ref.top,
      left = _ref.left,
      margin = _ref.margin,
      width = _ref.width,
      bottom = _ref.bottom,
      right = _ref.right,
      height = _ref.height,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WebToastStyle, {
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    width: width,
    height: height,
    margin: margin,
    position: position,
    justifyContent: type === "success" || type === "warning" ? "center" : "space-between",
    background: TOAST_BG_COLOR[type],
    "data-test-id": "WebToast-WebToastStyle",
    children: [iconUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      height: "15px",
      width: "15px",
      src: iconUrl,
      "data-test-id": "WebToast-ImageComponent"
    }), toastTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "10px",
      alignItems: "center",
      "data-test-id": "WebToast-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
        value: toastTxt,
        baseStyle: {
          fontSize: fontSize ? fontSize : "12px",
          fontWeight: fontWeight ? fontWeight : "normal",
          color: color ? color : "#FFFFFF",
          margin: toastTxtMargin ? toastTxtMargin : "10px"
        },
        "data-test-id": "WebToast-FormattedText"
      })
    })]
  });
};

/* harmony default export */ var Toast_WebToast = (WebToast);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ToolTipComp/ToolTipComp.style.ts

var ToolTipCompWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ToolTipCompstyle__ToolTipCompWrapper",
  componentId: "sc-1jxr57r-0"
})(["position:absolute;background:#1a7971;border:4px solid #1a7971;left:", ";right:", ";top:", ";bottom:", ";width:", ";font-size:14px;line-height:20px;padding:8px;border-radius:4px;gap:20px;z-index:1;color:#ffffff;&:after,&:before{border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(0,0,0,0);border-width:13px;}&:before{border-color:rgba(0,0,0,0);border-width:13px;}", " ", " ", " ", ""], function (props) {
  return props.left;
}, function (props) {
  return props.right;
}, function (props) {
  return props.top;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.width;
}, function (props) {
  return props.toolTipArrow == "top" && "\n&:after, &:before {\n\tbottom: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "bottom" && "\n&:after, &:before {\n\ttop: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-top-color: #1A7971;;\n\tmargin-left: -34px;\n}\n&:before {\n\tborder-top-color: #1A7971;\n\tmargin-left: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "right" && "\n&:after, &:before {\n\tleft: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-left-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-left-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "left" && "\n&:after, &:before {\n\tright: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-right-color: #1A7971;\n\tmargin-top: -17px;\n}\n&:before {\n\tborder-right-color: #1A7971;\n\tmargin-top: -19px;\n}\n\n";
});
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx
















































/***/ }),

/***/ 1046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ol": function() { return /* reexport */ ArrowRight; },
  "a": function() { return /* reexport */ BlueChev; },
  "g8": function() { return /* reexport */ ChevronUpIcon; },
  "pL": function() { return /* reexport */ DownArrow; },
  "dY": function() { return /* reexport */ EditIcon; },
  "rj": function() { return /* reexport */ StarEmpty; },
  "Um": function() { return /* reexport */ StarFull; }
});

// UNUSED EXPORTS: MMTIcon

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ArrowRight.tsx


var ArrowRight = function ArrowRight(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "ArrowRight",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 6.86518L21 6.86182L1 6.86518Z",
      fill: "#008CFF"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1 6.86518L21 6.86182",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.8595 13L20.2086 7.65621C20.5731 7.29196 20.5731 6.70132 20.2075 6.33707L14.8595 1",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/BlueChev.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var BlueChev = function BlueChev(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "BlueChev",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00005 9.5L12.25 4.25L13.5 5.5L7.00005 12.0028L0.5 5.5L1.75 4.25L7.00005 9.5Z",
      fill: "#008CFF"
    })
  }));
};


// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ChevronUpIcon.tsx


var _excluded = ["color", "cursor"];

function ChevronUpIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronUpIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronUpIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronUpIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ChevronUpIcon = function ChevronUpIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008cff" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ChevronUpIcon_objectSpread(ChevronUpIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "ChevronUpIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.8583 10.6059C11.9364 10.5278 12.063 10.5278 12.1411 10.6059L16.2423 14.7071C16.6329 15.0976 17.266 15.0976 17.6566 14.7071V14.7071C18.0471 14.3166 18.0471 13.6834 17.6566 13.2929L12.7068 8.34315C12.3163 7.95262 11.6831 7.95262 11.2926 8.34315L6.34285 13.2929C5.95232 13.6834 5.95232 14.3166 6.34285 14.7071V14.7071C6.73337 15.0976 7.36654 15.0976 7.75706 14.7071L11.8583 10.6059Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/DownArrow.tsx


function DownArrow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DownArrow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DownArrow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DownArrow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var DownArrow = function DownArrow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DownArrow_objectSpread(DownArrow_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "DownArrow",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
      fill: "#008CFF"
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/EditIcon.tsx


var EditIcon_excluded = ["size", "color", "cursor"];

function EditIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EditIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EditIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EditIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var EditIcon = function EditIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EditIcon_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", EditIcon_objectSpread(EditIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "EditIcon",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.378 5.45329C15.9045 4.9268 16.7581 4.9268 17.2846 5.45328L19.0567 7.2254C19.5832 7.75188 19.5832 8.60548 19.0567 9.13196L18.3203 9.86834C18.1097 10.0789 17.7683 10.0789 17.5577 9.86834L14.6416 6.95229C14.431 6.74169 14.431 6.40025 14.6416 6.18966L15.378 5.45329Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1781 7.64303C13.3887 7.43244 13.7302 7.43244 13.9408 7.64303L16.8568 10.5591C17.0674 10.7697 17.0674 11.1111 16.8568 11.3217L10.3652 17.8134C10.2926 17.8859 10.1997 17.9347 10.0988 17.9532L6.59734 18.5945C6.25606 18.657 5.95467 18.365 6.00634 18.0219L6.55028 14.4106C6.56638 14.3038 6.61629 14.2049 6.69271 14.1285L13.1781 7.64303Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/MMTIcon.tsx


function MMTIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MMTIcon = function MMTIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_jsxs("svg", MMTIcon_objectSpread(MMTIcon_objectSpread({
    width: 86,
    height: 28,
    viewBox: "0 0 86 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "MMTIcon",
    children: [/*#__PURE__*/_jsx("rect", {
      x: 37.2598,
      y: 4.68359,
      width: 23.8612,
      height: 22.4215,
      rx: 6,
      fill: "white",
      "data-test-id": "MMTIcon-rect"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 35,
      y: 0,
      width: 28,
      height: 28,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.6091 27.8695V0.365234H35.2988V27.8695H62.6091Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.3565 9.77361C59.0587 12.0098 56.74 16.8177 56.74 16.8177C56.74 16.8177 55.5721 19.4131 55.0783 22.0653C54.8587 23.2447 55.2827 24.6147 55.2827 24.6147C55.5999 25.9675 54.0972 25.5958 54.0972 25.5958C52.9995 25.2332 53.03 23.7589 53.03 23.7589C53.03 21.5828 53.9928 19.4794 54.557 18.0716C52.5746 18.8576 51.6475 16.9195 52.2116 14.9624L49.9456 18.0365C49.2164 18.8983 48.498 18.7296 48.498 18.7296C48.4615 18.7296 47.5896 18.6228 47.6337 17.4529C47.6551 16.8864 47.8134 14.5232 47.9949 13.6455C48.0133 13.5537 47.9589 13.4623 47.8859 13.5722C46.9409 15.2542 45.3924 17.0873 45.0845 17.5955C44.6851 18.2544 44.2844 18.5275 44.2844 18.5275C43.9624 18.7885 43.403 18.5912 43.403 18.5912C42.8298 18.3774 42.947 17.7255 42.947 17.7255L43.4898 13.7871C43.4898 13.7331 43.4719 13.7143 43.4172 13.7143C43.2538 13.7143 41.7173 15.8555 40.8695 17.3493L40.3144 18.252C40.3144 18.252 39.8351 19.0085 39.0948 18.5534C38.5159 18.1973 38.6979 17.5318 38.6979 17.5318L40.2856 10.8112C40.2856 10.7929 40.2856 10.6832 40.1943 10.6832C39.7034 10.6832 39.5637 11.9704 38.8925 11.9952C38.5548 12.0077 38.3808 11.8623 38.3808 11.8623C37.923 11.5974 38.1403 10.9105 38.1403 10.9105C38.1403 10.9105 38.8655 8.97975 39.8266 8.4945C39.8266 8.4945 40.3811 8.14464 40.843 8.20718C41.3051 8.26972 42.0443 8.38121 41.6563 10.5005L41.1715 13.2572C41.1715 13.2572 41.1231 13.4983 41.1982 13.5368C41.1982 13.5368 41.3179 13.6566 41.5593 13.333L44.6338 9.10418C45.2961 8.12532 46.0768 8.61909 46.0768 8.61909C46.5968 8.84109 46.4184 9.48236 46.4184 9.48236C46.4184 9.48236 44.903 14.1629 44.903 14.6016C44.903 14.748 45.0306 14.7842 45.1029 14.6751C45.7389 13.7056 47.0844 11.6023 48.2122 10.1944C48.7206 9.57273 49.0121 9.29818 49.5753 9.35319C50.1205 9.40804 50.3752 9.75544 50.3752 10.3041C50.3752 10.3956 50.3568 10.5053 50.3393 10.6151C50.3393 10.6151 49.3391 14.0715 49.2659 15.9184C49.2659 15.9184 49.2504 16.1839 49.3204 16.2376C49.4552 16.3411 49.6215 16.1081 49.6215 16.1081C50.1811 15.488 51.9707 12.6424 52.3752 11.8951L53.6699 9.24514C53.6699 9.24514 54.2194 8.03953 54.9533 8.22699C54.9533 8.22699 56.1209 8.34552 55.5568 9.62381C55.4643 9.83304 54.5754 11.2864 53.8114 14.2863C53.6843 14.7429 53.5204 16.0783 54.3382 16.0783C54.702 16.0783 55.175 15.7851 55.6658 14.8889L58.8834 9.07389C59.156 8.78084 59.3718 8.61909 59.7532 8.61909C60.9445 8.61909 60.3565 9.77361 60.3565 9.77361ZM62.6087 6.59235C62.6087 3.15774 59.8562 0.365234 56.4625 0.365234H41.4468C38.052 0.365234 35.2998 3.15774 35.2998 6.59235L35.3031 21.6389C35.3031 25.0725 38.0548 27.8696 41.4493 27.8696H56.4648C59.8593 27.8696 62.61 25.0733 62.61 21.6389L62.6087 6.59235Z",
        fill: "#EB2226"
      })
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 10,
      width: 11,
      height: 8,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 17.5647H10.3158V10.5566H0L0 17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask1_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00933 17.5647H4.30673V13.7095C4.30673 13.1602 4.21981 12.7499 4.0468 12.4795C3.87363 12.209 3.58099 12.0735 3.16775 12.0735C2.86697 12.0735 2.59159 12.1481 2.34159 12.2978C2.09078 12.4479 1.87822 12.6609 1.70277 12.9371V17.5647H0V10.5634H0.969709L1.60983 11.505C1.74736 11.3792 1.95602 11.2205 2.12496 11.1107C2.29407 11.0008 2.47245 10.9042 2.66043 10.822C2.84793 10.74 3.04552 10.6758 3.25206 10.6279C3.4586 10.5802 3.67051 10.5566 3.88763 10.5566C4.13746 10.5566 4.358 10.5832 4.54728 10.6372C4.73755 10.6904 4.90535 10.7685 5.05134 10.8718C5.19734 10.9744 5.3251 11.0981 5.4335 11.2429C5.54206 11.3886 5.6376 11.5527 5.72109 11.7359C5.85471 11.6016 6.00592 11.4646 6.17518 11.3237C6.34413 11.1829 6.53097 11.0558 6.73556 10.9419C6.94014 10.8281 7.16312 10.7354 7.40514 10.6639C7.64749 10.5923 7.90985 10.5566 8.19419 10.5566C8.57765 10.5566 8.90381 10.6354 9.17367 10.7924C9.44287 10.9499 9.66178 11.1676 9.83104 11.4461C9.99999 11.7246 10.1224 12.0561 10.1999 12.4402C10.277 12.8246 10.3159 13.2436 10.3159 13.6967V17.5647H8.61313V13.7095C8.61313 13.1602 8.52768 12.7499 8.35646 12.4795C8.18556 12.209 7.89927 12.0735 7.49938 12.0735C7.19877 12.0735 6.92305 12.1439 6.67241 12.2843C6.42225 12.425 6.20139 12.6419 6.00933 12.9371V17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9324 14.3823H14.4049C13.9962 14.3823 13.6976 14.4792 13.5094 14.6372C13.3219 14.7945 13.228 15.0149 13.228 15.2966C13.228 15.5656 13.3074 15.7729 13.4661 15.9188C13.6246 16.0638 13.8667 16.1375 14.1917 16.1375C14.3883 16.1375 14.5747 16.111 14.7524 16.0586C14.93 16.0055 15.0935 15.9351 15.2438 15.8456C15.3937 15.756 15.5271 15.6503 15.6443 15.5263C15.7607 15.4029 15.8569 15.2724 15.9324 15.1354V14.3823ZM15.9317 16.7939C15.735 17.0092 15.4264 17.2102 15.0777 17.3553C14.7291 17.4994 14.3128 17.5722 13.8291 17.5722C13.491 17.5722 13.1863 17.5179 12.9145 17.4085C12.6434 17.3001 12.4114 17.1472 12.2173 16.9501C12.0233 16.753 11.8739 16.5207 11.7692 16.2517C11.6652 15.9824 11.6133 15.6887 11.6133 15.3691C11.6133 14.0646 12.6159 13.2355 14.2224 13.2355H15.919V12.8485C15.919 12.6095 15.7994 12.4214 15.5593 12.2852C15.3198 12.1489 14.9514 12.08 14.4547 12.08C13.9915 12.08 13.5626 12.1291 13.1686 12.2269C12.7746 12.324 12.556 12.4063 12.2179 12.5464L12.0075 11.0851C12.1323 11.0298 12.285 10.9715 12.4645 10.9099C12.6434 10.8482 12.8444 10.7914 13.0652 10.7382C13.2864 10.6861 13.5263 10.6421 13.7851 10.608C14.0434 10.5733 14.3152 10.5566 14.5987 10.5566C15.5836 10.5566 16.3232 10.7989 16.8179 11.2847C17.3119 11.7695 17.5593 12.4592 17.5593 13.3532V17.5647H16.3461L15.9317 16.7939Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.6119 10.4593L22.8357 13.9617L25.9934 17.5649H23.8528L20.9329 14.01V17.5649H19.2305V7.95508H20.9329V14.01L23.5336 10.4593H25.6119Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.3989 12.0668C29.1738 12.0668 28.9692 12.0946 28.7851 12.1509C28.6017 12.2071 28.441 12.2873 28.3035 12.3899C28.166 12.4932 28.0528 12.6177 27.9651 12.7635C27.8777 12.9105 27.8173 13.0715 27.7838 13.2475H30.8074C30.8074 13.0898 30.779 12.939 30.7224 12.7948C30.6664 12.6502 30.5798 12.5248 30.4626 12.4184C30.3461 12.311 30.1988 12.2259 30.0219 12.1622C29.8442 12.0987 29.637 12.0668 29.3989 12.0668ZM29.7177 16.0621C30.0182 16.0621 30.2906 16.0375 30.5346 15.9899C30.7787 15.9423 31.0011 15.8787 31.2011 15.8011C31.4018 15.723 31.5834 15.6323 31.7458 15.53C31.9084 15.4269 31.8518 15.4758 31.9852 15.3699L32.3137 16.8826C32.0129 17.0753 31.5881 17.2459 31.1602 17.3759C30.7327 17.5064 30.246 17.5722 29.6992 17.5722C29.1025 17.5722 28.5742 17.4879 28.1157 17.3204C27.6564 17.1524 27.269 16.917 26.9538 16.6123C26.6393 16.3077 26.3997 15.9423 26.2373 15.5141C26.0749 15.086 25.9932 14.6116 25.9932 14.0911C25.9932 13.6101 26.0675 13.1555 26.2155 12.7274C26.3636 12.2991 26.5807 11.9245 26.8664 11.6023C27.1523 11.2799 27.5058 11.0254 27.9274 10.8377C28.3492 10.6506 28.8354 10.5566 29.386 10.5566C29.9413 10.5566 30.4195 10.6457 30.8228 10.8237C31.2248 11.0018 31.557 11.2388 31.8174 11.5347C32.0787 11.8313 32.2714 12.1714 32.3972 12.5556C32.5223 12.9397 32.5682 13.338 32.5682 13.7504C32.5682 13.8616 32.5617 13.9894 32.5492 14.1329C32.5367 14.2764 32.5204 14.3982 32.4992 14.497H27.7526C27.7773 14.7391 27.84 14.9568 27.9401 15.1487C28.04 15.3413 28.1748 15.5048 28.3437 15.6397C28.513 15.7746 28.713 15.8787 28.9444 15.9519C29.1761 16.0256 29.434 16.0621 29.7177 16.0621Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.2822 11.5566L66.5825 8.80273H67.0869V10.5633H69.0522V12.0875H67.0869V14.9568C67.0869 15.1562 67.1106 15.3227 67.1588 15.456C67.2062 15.5883 67.2727 15.694 67.3564 15.7743C67.4392 15.8537 67.5353 15.9097 67.6435 15.9436C67.7522 15.9766 67.8674 15.993 67.9881 15.993C68.2133 15.993 68.4127 15.9714 68.5854 15.9277C68.759 15.8844 68.9128 15.8294 69.0461 15.7641V17.29C68.8621 17.3821 68.6692 17.4519 68.467 17.4998C68.2646 17.5485 68.0173 17.5722 67.725 17.5722C67.3121 17.5722 66.9571 17.5232 66.6613 17.4245C66.365 17.3258 66.1227 17.1837 65.9355 16.9959C65.7466 16.8076 65.608 16.5793 65.5187 16.3113C65.4292 16.0433 65.3836 15.7394 65.3836 15.3995V12.0875H64.2822V11.5566Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M71.955 12.006C72.1847 11.5864 72.5958 11.1824 72.936 10.9319C73.2757 10.6817 73.6842 10.5566 74.1593 10.5566C74.3219 10.5566 74.4552 10.5648 74.5572 10.581C74.6594 10.5972 74.7374 10.613 74.7918 10.6269C74.7918 10.6269 74.7374 11.0229 74.4788 12.2323C74.374 12.209 74.2491 12.1972 74.1028 12.1972C73.7815 12.1972 73.4952 12.2527 73.2423 12.3646C72.9899 12.4764 72.776 12.6375 72.6012 12.8469C72.4262 13.0568 72.2913 13.3144 72.1974 13.618C72.1028 13.9218 72.0563 14.2658 72.0563 14.6495V17.5647H70.3535V10.5632H71.4445L71.955 12.006Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 79,
      y: 10,
      width: 7,
      height: 11,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.9243 20.3934V10.5566L79.2148 10.5566V20.3934H85.9243Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask2_1734_41229)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.5325 12.0876C82.316 12.0876 82.1192 12.1199 81.9443 12.1847C81.7694 12.2491 81.6147 12.333 81.481 12.4368C81.3473 12.5395 81.2328 12.6575 81.137 12.789C81.0409 12.92 80.963 13.0549 80.9055 13.1927V15.1809C80.9716 15.3009 81.0589 15.4147 81.1645 15.5222C81.2711 15.6293 81.3907 15.7236 81.5248 15.8053C81.6584 15.8868 81.807 15.952 81.9722 16.0019C82.1371 16.0509 82.3132 16.0754 82.5014 16.0754C82.7888 16.0754 83.0386 16.0283 83.2491 15.9335C83.4598 15.8397 83.6348 15.7074 83.7751 15.5381C83.9149 15.3679 84.0188 15.1642 84.0848 14.9257C84.1516 14.6876 84.1848 14.4244 84.1848 14.1364C84.1848 13.836 84.1454 13.5599 84.0656 13.3085C83.9867 13.057 83.8746 12.8414 83.7281 12.661C83.5813 12.4807 83.4078 12.3396 83.2053 12.2391C83.0023 12.1379 82.7787 12.0876 82.5325 12.0876ZM84.2999 10.8505C84.6698 11.0471 84.9753 11.3099 85.2169 11.6388C85.4592 11.9677 85.6376 12.3469 85.7525 12.7778C85.8669 13.2072 85.9244 13.6545 85.9244 14.1171C85.9244 14.5896 85.8638 15.0336 85.7429 15.4511C85.6218 15.8683 85.4395 16.2342 85.1954 16.5498C84.9512 16.8646 84.6475 17.1141 84.2841 17.2975C83.9216 17.481 83.496 17.5722 83.0074 17.5722C82.5318 17.5722 82.1303 17.5026 81.8025 17.3623C81.4751 17.2235 81.188 17.0185 80.9422 16.7482L80.9171 16.7628V20.3934H79.2148V10.5634H80.2331L80.8834 11.4162C81.1302 11.1626 81.4808 10.9162 81.8214 10.7724C82.1619 10.6285 82.5458 10.5566 82.9763 10.5566C83.4895 10.5566 83.9314 10.6554 84.2999 10.8505Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M76.5459 7.68164C76.0555 7.68164 75.6592 8.08111 75.6592 8.57406C75.6592 9.06717 76.0555 9.46697 76.5459 9.46697C77.0359 9.46697 77.4331 9.06717 77.4331 8.57406C77.4331 8.08111 77.0359 7.68164 76.5459 7.68164ZM75.695 17.5648H77.3974V10.5635H75.695V17.5648Z",
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/StarEmpty.tsx


var StarEmpty_excluded = ["width", "height"];

function StarEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarEmpty_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarEmpty = function StarEmpty(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 26 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarEmpty_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarEmpty_objectSpread(StarEmpty_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarEmpty",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0675 19.9704L6.05072 23.7389L7.3908 15.7571L1.71415 10.1044L9.55909 8.93983L13.0675 1.67773L16.5758 8.93983L24.4208 10.1044L18.7441 15.7571L20.0842 23.7389L13.0675 19.9704Z",
      fill: "#E2B634",
      fillOpacity: 0.1,
      stroke: "#E2B634",
      strokeOpacity: 0.4
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/StarFull.tsx


var StarFull_excluded = ["width", "height"];

function StarFull_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarFull_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarFull_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarFull_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarFull = function StarFull(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 23 : _ref$height,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarFull_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarFull_objectSpread(StarFull_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarFull",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9415 18.9704L4.92475 22.7389L6.26482 14.7571L0.588172 9.10436L8.43311 7.93983L11.9415 0.677734L15.4498 7.93983L23.2948 9.10436L17.6181 14.7571L18.9582 22.7389L11.9415 18.9704Z",
      fill: "#E2B634"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx









/***/ })

}]);